import React from 'react';
import axios from 'axios';
import ApplicationLanding from './applicationLanding';
import { personalQuestions } from '../../action/application/personalQuestions';
import { questions } from '../../action/application/questions';
import Element from '../application/element';
import { connect } from "react-redux";
import { createApplication } from '../../action/application/getApplicationValidate';
import { insertApplicationUserDetails } from '../../action/application/insertApplicationUserDetails';
import Loader from '../loader/loader';
import QrCode from '../miteck/qrCode';
import { applicationSave, openBankingInitialize, continueOpenBanking, getOBApplicationStatus } from '../../action/applicationSave/applicationSave';
import { prepopulate } from '../../action/application/prepopulatedQuestion';
import DocumentVerify from './documentVerify';
import { v4 as uuidv4 } from 'uuid';
import parse from 'html-react-parser';
import { analyticsChangeEvent, analyticsClickEvent, firebaseLoadingEvent } from '../../action/firebaseAnalytics/firebaseAnalytics';
import { getAvatar } from "../../action/avatar/getAvatar";
import Cookies from 'universal-cookie';
import { GTMApplicationId, GTMApplicationSubmitStatus, GTMClientSubmitErrors, GTMServerSubmitError, GTMUserId, GTMUserIdAndLoginState,GTMValidStepsSubmit,GTMApplicationFunnelSubmitError } from '../../utils/GtmDatalayer';
import { thirdPartyWebsiteAlertPopupText } from '../../utils/const';
import Reaptcha from 'reaptcha';
import { sendMarketingConstent } from '../../action/marketingConstent/marketingConstent';
import { validatePersonalDetails } from '../../action/application/validatePersonalDetails';
import { emailSendOTP, verifyEmailOTP } from '../../action/application/emailOTP';
import { sendMobileOTP, verifyMobileOTP } from '../../action/application/mobileOTP';
import { handleStatusCode } from '../../utils/handleStatusCode';
import $ from "jquery";
import { frontEndLogs } from '../../action/logs/frontEndLogs';
import { convertDateFormat } from '../../utils/convertDateFormat';
import { checkUserApplicationEligibility } from '../../action/application/checkApplicantEligibility';
import { generateSessionForUser } from '../../action/application/generateSession';
import { checkUserExistence } from '../../action/application/checkUserExistence';
import { mitekVerificationLinkSentToMobile } from '../../action/application/mitekVerificationLink';
import { mfaValidationCheckForUser  } from '../../action/application/mfaValidationCheckForUser';
import { PropTypes } from 'prop-types';
import { handlePopstate, handleRefreshTheScreen } from '../../action/logs/detectPageEvent';
import OpenBankingConsent from './openBankingConsent';
import { getRetailer } from '../../action/partner/getRetailer';
import branch from 'branch-sdk';
import { removeSpecialCharacterInAddressFields } from '../../utils/helpers/addressFieldValidation';
import { getConsentStatus } from "../../action/application/getConsentStatus";
import { BrokerPrivacyPolicy } from './brokerPrivacyPolicy';
import withRouter from '../../withRouter';
import { getBrokerUserDetails } from '../../action/application/getBrokerUserDetails';
import { Navigate } from 'react-router-dom';
import { getFrequencyDuration } from "../../action/application/getFrequencyDuration";
import { updateAccountInfo } from '../../action/application/updateAccountInfo';
import { QuoteCalculatorAPI } from '../../action/quoteCalculator/quoteCalculator';
import RetailerPlanSection from '../application/retailerPlanSection';
import { QuoteTool } from '../../action/quoteCalculator/quoteTool';
import { updateQrStatusOb } from '../../action/application/updateObQrStatus';
import { handlingSession, sessionID } from './../../utils/handlingSession'
import { Link } from 'react-router-dom';
import SessionExpiredModal from '../modals/sessionExpiredModal';
import CommonModal from '../modals/commonModal';
import FieldErrorShowModal from '../modals/fieldErrorShowModal';
import UserBalanceShowModal from '../modals/userBalanceShowModal';
import ServerErrorShowModal from '../modals/serverErrorShowModal';
import RegisterModal from '../modals/registerModal';
import MobileModal from '../modals/mobileModal';
import { SelectPlan } from './selectPlan';
import { MitekConsent } from './mitekConsent'
import { UserNoteShowModal } from '../modals/userNoteShowModal';
import { DisplayMarketingConsent } from './displayMarketingConsent';
import { getEmailFromStorage, isValidSessionId, setSessionIdInStorage, setEmailInStorage, setTokenInStorage, setCsrfTokenInStorage, removeSessionIdFromStorage, removeEmailFromStorage, removeTokenFromStorage, removeCsrfTokenFromStorage, generateUuid, setUserDetails,fetchBannerConfiguration} from '../../utils/helpers/storageUtils'
const IS_TMX_ENABLED = process.env.REACT_APP_ISTMXENABLED === 'true';

export class Application extends React.Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.qrRef = React.createRef();
    this.divRef = React.createRef();
    this.thirdSectionRef = React.createRef();
    this.resizeObserver = null;
    this.state = {
      hasErrorMessage: 's',
      step: 1,
      stepOne: '',
      stepTwo: '',
      stepThree: '',
      stepFour: '',
      stepZeroData: '',
      stepOnedata: '',
      stepTwodata: '',
      stepThreedata: '',
      displayErrorsStepOne: '',
      displayErrorsStepTwo: '',
      displayErrorsStepThree: '',
      stages: '',
      email: '',
      phoneNo: '',
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      confirmEmailAddress: '',
      displayPhoneError: '',
      hasOtpSendMessage: '',
      hasOtpSendToUserMessage: '',
      otpNumber: '',
      isEmailConsentChecked: sessionStorage.getItem('emailConsent') === 'true',
      isMobileAppConsentChecked: sessionStorage.getItem('mobileConsent') === 'true',
      isSMSConsentChecked: sessionStorage.getItem('smsConsent') === 'true',
      isApplicationConsentChecked: sessionStorage.getItem('applicationConsent') === 'true',
      loading: false,
      isResendEnableBtn: true,
      hasOtpResendMessage: '',
      documentSteps: true,
      passportInstruction: false,
      drivinglicenseInstruction: false,
      selfieInstruction: false,
      width: window.innerWidth,
      showMitekConsent: false,
      unableToProvide: false,
      otpVerify: false,
      otpVerifyStatus: '',
      isEnableMobileBtn: true,
      isEnableCheckBox: true,
      serverErrorMessage: '',
      isPopupDisabled: true,
      isEnableOkButton: true,
      isEnableDesktopCapture: false,
      isContinuePrevAmount: false,
      privacyPolicyCheck: false,
      validateStatusCode: '',
      resultSourceURL: '',
      verificationMessage: "",
      userToken: "",
      reCaptchaToken: '',
      codeError: '',
      isReturningUser:false,
      isExistingUser:false,
      isAddressConfirmed:false,
      approvedApplicationMessage: '',
      disableVerifyOkButton: false,
      mobileVerifyFlag: false,
      emailVerifyFlag: false,
      resendEmailFlag: false,
      resendMobileFlag: false,
      loggedUserApplyNowFlag: false,
      isMobileVerified: false,
      prepopulateFlag: false,
      showMobileandEmailAddress: false,
      popupButtonLabel: '',
      runEmailVerificationOnOk: false,
      isDisableContinue: true,
      redirectURL: '',
      occupationValidation: ['occupation', 'time_in_occupation'],
      showFooterText: false,
      secondSection: '',
      thirdSection: '',
      fourSection: '',
      fifthSection: '',
      showSecondSection: false,
      firstSectionProgressValue: 0,
      secondSectionProgressValue: 20,
      thirdSectionProgressValue: 40,
      fourSectionProgressValue: 60,
      fifthSectionProgressValue: 80,
      showThirdSection: false,
      showFourSection: false,
      showFifthSection: false,
      hideSectionThree: false,
      globalProgressBarValue: 0,
      globalProgressBarIndicatorValue:25,
      userLoanTerm: '',
      userLivingCost: '',
      userMonthlyIncome: '',
      userTotalExpenditure: '',
      flxAgree_C: false,
      flxDocumentAgree_C: false,
      flxContactAgree_C: false,
      flxAgree_c_Error: '', 
      flxDocumentAgree_c_Error: '',
      flxContactAgree_C_Error: '',
      progressBarImageSrc: 'images/bird-shadow--logo.svg',
      progessBarLogoStyle: 'img-sizing-svg',
      isMitekProcessReached: false,
      isMobileOTPVerified: false,
      isEmailOTPVerified: false,
      isUserExists: false,
      isNewAccountValue: false,
      sectionHeadingValue: '',
      sectionContextValue: '',
      isFrequencyExists: false,
      isAmendButtonClicked: false,
      emailCheckConsentSrc: 'images/unchecked.svg',
      smsCheckConsentSrc: 'images/unchecked.svg',
      mobileCheckConsentSrc: 'images/unchecked.svg',
      applicationConsentSrc: 'images/unchecked.svg',
      submitSectionFlag: false,
      sendButtonDisable: false,
      showContinueAppButton: false,
      isFormValidated: false,
      inputValue: '',
      mobileValueUpdatedTimeStamp: '',
      verifyMessage: '',
      finalinputValue:'',
      failedfieldValidationCollection: [],
      isShowDecommissionMessage:true,
      isExistingUserChangeEmailOption:false,
      isEmptyChangeEmail: false,
      openBankingRedirectURL:"",
      decisionByLendingMetrics:false,
      openWarningOBConsent:false,
      obStatusRecived:false,
      obStatus:"",
      messageTitle: '',
      reachLimitOTPVerify:false,
      retryLimit:0,
      changedValueAfterComplete:false,
      retryLimitTogetRetailerID:0,
      onBlurInputFiled:false,
      isBrokerApplication:false,
      isMitekApp:false,
      disableMobileNumberField: (localStorage.getItem('fromWhere') !== 'apply_now' || sessionStorage.getItem('fromWhere')!== 'apply_now'),
      invalidTitlesInFirstName: false,
      disableApplicationConsentButton: true,
      showQRCode: false,
      showPrivacyPolicyModal: false,
      isBioConsentShown: false,
      displayQRCodeErrorModal: false,
      mitekToken: '',
      showInitializePage: false,
      activeNewApp: false,
      isConfirmEmailFieldDisabled: false,
      isEmailFieldDisabled: false,
      frequencyDuration: '',
      isActiveContract: false,
      storeName: '',
      repaymentPlan: '',
      balance: '',
      hasPartnerDetails:{},
      amount: '',
      hasDisplay: true,
      NoRetailerMessage: '',
      quoteResult: '',
      selectPlanNext: false,
      isDisabled: false,
      isplanSelected: false,
      selectedPlanId: '',
      addTermValue:0,
      selectedPlanInterval: '',
      hideSecondSection: true,
      lockRetailerPlan: '',
      selectedTermId: '',
      selectedPlanName: '',
      showProgressValue: true,
      recalculationRequired: false,
      isApplicationNormalFlow: true,
      isAmountAvailable: false,
      planNotSelectedByDefault: false,
      thirdSectionHeight: 0,
      isObRedirect: false
    }
    this.reCaptchaRef = null;
    this.bottomScrollRef = React.createRef();
    this.observer = null;
    this.checkIntervalMobileChange = '';
    this.checkIntervalEmailAddress = '';
    this.removeFromHistory = this.removeFromHistory.bind(this);
    this.isDateval = this.isDateval.bind(this);
    this.getUserValidated = this.getUserValidated.bind(this);
    this.prepopulateUserPersonalDetails = this.prepopulateUserPersonalDetails.bind(this);
    this.validationCheckForPrepopulateData = this.validationCheckForPrepopulateData.bind(this);
    this.selectTermPlan = this.selectTermPlan.bind(this);
    this.serverErrorRedirection = this.serverErrorRedirection.bind(this);
    this.redirectionBasedOnOB = this.redirectionBasedOnOB.bind(this);
  }

  setMobileNumberForBroker = () => {
    const mobileNumber = sessionStorage.getItem('mobileNumber');
    if (mobileNumber) {
      this.setState({ phoneNo: mobileNumber });
    }
  };

  componentDidUpdate(prevProps, prevState) {
    const { isBrokerApplication, showMitekConsent, showQRCode } = this.state;
    const wrapper = document.querySelector('.wrapperpage');

    if (wrapper) {
      const shouldHideScroll = isBrokerApplication || showMitekConsent || showQRCode;

      if (shouldHideScroll) {   
          wrapper.style.scrollbarColor = '#ffffff #ffffff';
          wrapper.style.scrollbarWidth = 'thin';
      }
    }
    if (this.thirdSectionRef.current && !this.resizeObserver) {
      const domNode = this.thirdSectionRef.current;
      this.resizeObserver = new ResizeObserver((entries) => {
        const entry = entries[0];
        if (!entry) {
          return;
        }
        const newHeight = Math.round(entry.contentRect.height);
        const prevHeight = this.state.thirdSectionHeight;
        if (newHeight !== prevHeight) {
          this.setState(
            { thirdSectionHeight: newHeight },
            () => {
              if (this.resizeObserver) {
                this.resizeObserver.unobserve(domNode);
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
              }
            }
          );
        }
      });
      this.resizeObserver.observe(domNode);
    }

  }


  async componentDidMount() {
    window.addEventListener('pageshow', this.handlePageShow);
    this.handleSetUser();
    this.validationScroll();
    this.handleBanner();
    let searchParams = new URLSearchParams(window.location.search);
    let broker = window.location.search.includes('broker');    
    let mitekToken = window.location.search.includes('mitek_token');
    let store=searchParams.get("store");
    generateUuid();
    await this.handleFlow(searchParams,broker,mitekToken);
    await this.handleMitekToken(broker,mitekToken,searchParams);
    await this.handleReferralAndTokens(searchParams);
    await this.handlePreviousJourney(searchParams,mitekToken);
    let email = getEmailFromStorage();
    const obj = {
      "email": email
    }
    const response = await QuoteCalculatorAPI(obj);
    let loanAmount = new URLSearchParams(window.location.search).get('loanAmt');
    if (loanAmount) {
      this.setState({
        isAmountAvailable: true
      })
    }
    
    if (response) {
      if (response.data.statusCode === 200) {
        this.setState({ storeName: response.data.data.store, repaymentPlan: response.data.data.repayment_plan, balance: response.data.data.card_balance })
        if (store) {
          this.updateStoreNameById(response, store);
        }
      }
    }

    handleRefreshTheScreen('application')
    window.addEventListener('popstate', handlePopstate);

    sessionStorage.removeItem('applicationConsent')

    const cookie = new Cookies();
    cookie.remove('applicationId')
    
    

    // Push the customer id and loginState if available on this page to the dataLayer
    window.dataLayer = window.dataLayer || {}; 
    GTMUserIdAndLoginState();

    
    if (localStorage.getItem('fromWhere') == 'skip') {
      setSessionIdInStorage('');
    }

    // Validation for each section input fields is initialized
    this.props.firstSectionStepsReset([]);
    this.props.secondSectionStepsReset([]);
    this.props.thirdSectionStepsReset([]);
    this.props.fourSectionStepsReset([]);
    this.props.resetSectionHeading([]);
    this.props.resetSectionContext([]);

    this.props.resetMobileChange(false);
    this.props.resetEmailChange(false);
    this.props.resetFrequencyExists(false);
    this.props.removeAgreeLabel('');
    this.props.removeDocumentAgreeLabel('');
    this.props.removeContactHummAgreeLabel('');
    this.props.resetMobileVerified();
    this.props.resetEmailVerified();

    this.props.removeQuestionSave([]);
    this.props.appValidationsRemove([]);
    this.props.showappValidation('');
    this.props.getAmountRequested('');
    this.props.removeSavedata([]);
    this.props.showAddress('');

    this.props.firstNameFlagStatusCall(false);
    this.props.lastNameFlagStatusCall(false);
    this.props.emailFlagStatusCall(false);
    this.props.mobileNumberFlagStatusCall(false);
    this.props.birthDateFlagStatusCall(false);
    window.addEventListener("popstate", this.removeFromHistory);
    window.addEventListener('resize', this.handleWindowSizeChange);

    sessionStorage.setItem('ApplicationErrors', '');

    sessionStorage.setItem('flxPersonEmail__c', '')
    this.openModal();

    if(this.props.phoneNumbers !== ''){
      this.setState({phoneNo: this.props.phoneNumbers});
    }

    $(window).on("beforeunload", () => { 
      this.clearOBFailLocalStorageValue();
      try {        
        if ((localStorage.getItem('fromWhere') == 'apply_now' || sessionStorage.getItem('fromWhere') == 'apply_now')){
          this.clearApplyNowLocalStorage();
        }
        this.clearCookies();
      } catch (error) {
        console.log("Error during beforeunload cleanup:", error);
      }
    });

    let approvedURL = window.location.search.includes('approvedURL');
    let loanAmt = window.location.search.includes('loanAmt');
    let term = window.location.search.includes('term');
    let branch_referrer = window.location.search.includes('_branch_referrer');
    let redirectToken = window.location.search.includes('redirectToken');

    if ((localStorage.getItem('fromWhere') == 'apply_now' || sessionStorage.getItem('fromWhere') == 'apply_now') && ((!loanAmt && !term && !branch_referrer) && !approvedURL && !redirectToken)) {                 
      const cookie = new Cookies();
      cookie.remove('retailerId');
      sessionStorage.removeItem('storeID');
      sessionStorage.removeItem('quote-loan-amount');
      sessionStorage.removeItem('quote-loan-term');
      sessionStorage.removeItem('RetailerIdFromQuoteTool');
    }

    if ((localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') && (!loanAmt && !term && !branch_referrer)) {
      const cookie = new Cookies();
      cookie.remove('retailerId');
      sessionStorage.removeItem('quote-loan-term');
      sessionStorage.removeItem('quote-loan-amount');
      sessionStorage.removeItem('RetailerIdFromQuoteTool');
      sessionStorage.removeItem('storeID');       
    }      

    if (localStorage.getItem('fromWhere') == 'apply_now' || sessionStorage.getItem('fromWhere') == 'apply_now'){
      this.setState({ isEmailConsentChecked: false, isMobileAppConsentChecked: false,isSMSConsentChecked: false, isApplicationConsentChecked: false })
      sessionStorage.removeItem('smsConsent')
      sessionStorage.removeItem('mobileConsent')
      sessionStorage.removeItem('emailConsent')
      sessionStorage.removeItem('applicationConsent')
    }

    const optionsForScrollObserve = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5, 
    };
     this.handlingOBSuccessResponse();

    if (typeof IntersectionObserver !== `undefined`) {
      this.observer = new IntersectionObserver(this.handleScrollBottomObserver, optionsForScrollObserve);
      this.observer.observe(this.bottomScrollRef.current);
    }

    window.scrollTo(0, 0);
  }

  async handleBanner() {
    try {
      await this.props.fetchBannerConfiguration();
    } catch (error) {
      frontEndLogs('Failed to fetch banner', true, 400, 'handleBanner', error.message);
    }
  }

  async handleFlow(searchParams, broker, mitekToken) {
    if (broker) {
      this.setMobileNumberForBroker();
      let applicationID = searchParams.get("applicationID");
      let sessionId = searchParams.get("sessionId");
      sessionStorage.setItem('application_id', applicationID);
      sessionStorage.setItem('applicationId', applicationID)
      sessionStorage.setItem('flxPersonEmail__c', '');
      sessionStorage.setItem('brokerFlow', true);
      setSessionIdInStorage(sessionId);
      await this.getBrokerUserDetails();
      if (mitekToken) {
        if (this.qrRef?.current) {
          this.qrRef.current.callevent();
        }
        this.getConsentStatus();
        this.setState({ loading: false, showMitekConsent: true, isMitekProcessReached: true, privacyPolicyCheck: true })
      } else {
        this.setState({ loading: true });
        await this.handleWarningOBResponse();
        if (this.state.openWarningOBConsent) {
          this.getConsentStatus();
        }
      }
      this.setState({ isBrokerApplication: true });
    } else {
      sessionStorage.removeItem('applicationConsent');
    }
  }
  async handleMitekToken(broker, mitekToken ,searchParams) {
    if (!broker && mitekToken) {
      let applicationID = searchParams.get("applicationID");
      let sessionId = searchParams.get("sessionId");
      sessionStorage.setItem('application_id', applicationID);
      sessionStorage.setItem('applicationId', applicationID);
      await this.setupPreviousAppJourney();
      if (this.qrRef?.current) {
        this.qrRef.current.callevent();
      }
      this.getConsentStatus();
      this.setState({ loading: false, showMitekConsent: true, isMitekProcessReached: true });
    }
  } 
  async handleReferralAndTokens(searchParams) {
    const branchReferrer = window.location.search.includes('_branch_referrer');
    const purchaseRedirectToken = window.location.search.includes('redirectToken');
    const loanAmount = searchParams.get('loanAmt');
    const selectedPlanTerm = searchParams.get('term');

    if (loanAmount) {
      this.setState({ isAmountAvailable: true });
    }

    if (branchReferrer && !purchaseRedirectToken) {
      frontEndLogs('Attempted to retrieve the retailerId using the Branch SDK.', false, 200, 'redirectionOfApplyNowButton');
      analyticsClickEvent('attempted_to_retrieve_retailerId_using_branch_sdk', '');
      this.setState({
        amount: loanAmount,
        selectedPlanInterval: selectedPlanTerm,
        addTermValue: 1,
        isApplicationNormalFlow: false
      });
      if (!window.location.href.includes('redirectToken')) {
        await this.getRetailerFromBranchSDK();
      }
    }

    if (window.location.href.includes('redirectToken')) {
      await this.processRedirectToken();
    }
  }
  async processRedirectToken() {
    this.setState({ isReturningUser: true });
    const cookie = new Cookies();
    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get('source');
    const trackingId = urlParams.get('trackingId') || cookie.get('trackingId');
    let getRetailerRequest = {};
    let decryptedPayload = cookie.get('decryptedPayload');

    if (decryptedPayload) {
      getRetailerRequest.expandedUrl = `${window.location.origin}${window.location.pathname}?${decryptedPayload}`;
    }
    if (source) {
      getRetailerRequest.source = source;
    } else {
      getRetailerRequest.trackingId = trackingId;
    }

    if (cookie.get('loanAmount')) {
      this.setState({ isAmountAvailable: true });
    }

    let url = process.env.REACT_APP_BACKEND + 'application/retailer-id-from-purchase-link';
    await axios.post(url, getRetailerRequest, { headers: sessionID() })
      .then(response => {
        this.setState({
          amount: String(cookie.get('loanAmount')),
          selectedPlanInterval: String(cookie.get('term')),
          hasPartnerDetails: {
            id: response.data.data.retailer_id,
            store_name: response.data.data.retailer_name
          },
          addTermValue: 0,
          isApplicationNormalFlow: false
        }, () => { this.selectTermPlan(); });
      })
      .catch(() => {});
  }
 async handlePreviousJourney(searchParams, mitekToken) {
    if(sessionStorage.getItem('previousAppId')) {
      await this.initiatePreviousAppJourney(searchParams, mitekToken)
    }
  }


  handleSetUser() {
    if ((localStorage.getItem('fromWhere') != 'apply_now' && sessionStorage.getItem('fromWhere') != 'apply_now') && sessionStorage.getItem('isDetailsSet') !== 'true') {
      setUserDetails(this.props.setUserName, this.props.setProfilePic);
    }
  }

  clearOBFailLocalStorageValue() {
    const urlParams = new URLSearchParams(window.location.search);
    let obStatus = urlParams.get('status');
    if (!this.state.showInitializePage && obStatus !== null && obStatus !== undefined && obStatus !== 'failure' && obStatus !== 'success') {
        sessionStorage.removeItem('applicationId');
        sessionStorage.removeItem('application_id');
        sessionStorage.removeItem('userID');
        removeEmailFromStorage();
        removeSessionIdFromStorage();
        sessionStorage.removeItem('brokerFlow');
    }
  }

  clearApplyNowLocalStorage() {
    const urlParams = new URLSearchParams(window.location.search);
    let obStatus = urlParams.get('status');   
     removeTokenFromStorage();
     sessionStorage.removeItem('UserName');
     removeCsrfTokenFromStorage();
     if(!this.state.isObRedirect && obStatus !== 'failure') {
      sessionStorage.removeItem('uuid');
     }
  }

  clearCookies() {
    try {
      const cookie = new Cookies();
      cookie.remove('trackingId');
      cookie.remove('retailerId');
      cookie.remove('firstName');
      cookie.remove('lastName');
      cookie.remove('addressLine2');
      cookie.remove('approvedURL');
      cookie.remove('decryptedPayload');
      cookie.remove('email');
      cookie.remove('flatAbode');
      cookie.remove('houseandBuildingName');
      cookie.remove('houseandBuildingNumber');
      cookie.remove('loanAmount');
      cookie.remove('mobileNumber');
      cookie.remove('numberAndStreet');
      cookie.remove('postcode');
      cookie.remove('retailerReference');
      cookie.remove('sourceURL');
      cookie.remove('term');
      cookie.remove('townOrCity');
      cookie.remove('Dob');
    } catch (error) {
      console.log("Cookie clearing failed:", error);
    }
  }

  
  handleObredirect = async (value) => {
    this.setState({ isObRedirect: value });
  }

  quoteLoanAmountandTermValidation = (pathname, search, branchTrackingId) => {
    let branchReferrer = window.location.search.includes('_branch_referrer');

    let createAppBrowserPathRequest = {
        pathname : pathname,
        search: search,
        QuoteAmount : sessionStorage.getItem('quote-loan-amount'),
        QuoteTerm: sessionStorage.getItem('quote-loan-term')
      }

    if(sessionStorage.getItem('quote-loan-amount') && sessionStorage.getItem('quote-loan-term')){
      frontEndLogs('Browser path history',false,200, 'setHummRetailerLink',createAppBrowserPathRequest)
        if(search){
        const { location } = this.props;
        const { search } = location;
        const urlParams = new URLSearchParams(search);
        const quoteLoanAmt = urlParams.get('loanAmt');
        const quoteLoanTerms = urlParams.get('term');
        if(quoteLoanAmt && quoteLoanTerms){
          return window.location.href;
        }
      }
    }else if(branchReferrer && !branchTrackingId){
      return window.location.href;
    }
    return null;
  }

  // The Humm retailer link send when creating application
  setHummRetailerLink = ()=>{
    try {
      const cookie = new Cookies();
      const { pathname, search } = this.props.location;
      let branchTrackingId = window.location.search.includes('trackingId');
      let redirectToken = window.location.search.includes('redirectToken');
      if (cookie.get('trackingId')) {
        branchTrackingId = cookie.get('trackingId')
      }
    
    if(!redirectToken) {
      return this.quoteLoanAmountandTermValidation(pathname, search, branchTrackingId);
    }
    return null;
    } catch (error) {
      frontEndLogs('Catch Error - Send retailer link with quote amount and term ',true,400, 'setHummRetailerLink',error?.message)
    }
  }

  handleScroll= (event) =>{
    // Scroll event to show heading and content
    setTimeout(() => {
      this.validationOfProgressIndicatorSections(event);
      }, 200);
      
  }
  
  validationScroll = () => {
    const applicationLandingSection = document.querySelector('.start-the-application--heading');
    const mitekConsentSection = document.getElementById('mitekConsentScreenScroll');

    const wrapper = document.querySelector('.wrapperpage');
    const navbar = document.querySelector('.navbar');
    
    if (navbar) {
      if (applicationLandingSection) {
        navbar.style.right = '14px';
      } else {
        navbar.style.right = '0px';
      }

      if(wrapper && mitekConsentSection) {
        wrapper.style.scrollbarColor = '#ffffff #ffffff';
        wrapper.style.scrollbarWidth = 'thin';
      }
    }
  }

  openModal=()=>{
    if(localStorage.getItem('fromWhere')=='skip' && sessionStorage.getItem('showPopup')=='true'){ 
      setTimeout(() => {
        window.$("#sessionExpiredModal").modal("show");
      sessionStorage.setItem('showPopup','false');
    }, 1000);
    }
    sessionStorage.setItem('showPopup','false');
  }

  clearEmailAddressAndHighlightField = () => {
    this.setState({loading: true});

    const inputElement = document.getElementById('Email_Address');
    inputElement.style.border = "1px solid #ff6200";
    let inputValues = {}
    inputValues['Email_Address'] = '';
    this.props.saveApplicationDatas(inputValues);

    setTimeout(() => {
      if(this.state.isExistingUserChangeEmailOption){
        this.props.updateEmailChange(false);
        this.setState({isExistingUserChangeEmailOption:false})
      }else{
        this.props.updateEmailChange(true);
      }

      this.setState({loading: false})
      inputElement.focus();
    }, 2500);
  }

  isDateval=(dateStr)=>{
    return !Number.isNaN(new Date(dateStr).getDate());
  }

  handleScrollBottomObserver = (entries) => {
    const bottomScrollApplyButton = entries[0];
    if (bottomScrollApplyButton.isIntersecting) {
      setTimeout(() => {
        this.setState({ isDisableContinue: false });
      }, 400);
    }
  };

  handlechangeemailNotTriggred = (e) => {
    this.setState({ loading: true });
    const userDetails = Object.assign({}, ...this.props.saveApplicationData);
   
    this.setState({email: userDetails.Email_Address}, () => {
    setEmailInStorage(this.state.email);
    });
    
    this.checkEmailAddress();
    

  };

  mitekVerificationLinkForUser = async() => {
    this.setState({ sendButtonDisable: true});
    let email = getEmailFromStorage();
    const requestPayload = {
      "application_id": await this.getApplicationIDInstorage(),
      "email": email ?? this.state.email,
      "mobile_number": this.state.phoneNo,
      "userId": sessionStorage.getItem('userID'),
    }

    this.setState({ loading: true, popupButtonLabel:'', validateStatusCode: '' });
    const responseResult = await mitekVerificationLinkSentToMobile(requestPayload);

    if(responseResult.status === 200) {
      if(responseResult.data.data.isSendLink) {
        // disable the send button as the mitek Verification link is already sent for the user
        this.setState({ serverErrorMessage: responseResult.data.message, loading: false, sendButtonDisable: true });
      }
      else {
        this.setState({ serverErrorMessage: responseResult.data.message, loading: false, sendButtonDisable: false });
      }
      window.$('#serverErrorShowModel').modal('show');
    }
    else if(handleStatusCode(responseResult.status)){
      this.setState({ serverErrorMessage: responseResult.data.message, loading: false, sendButtonDisable: true });
      window.$('#serverErrorShowModel').modal('show');
    }

  }

  //function to handle stateupdates from obconsent
  handleObVerificationLinkSentToMobile = async (errorMessage) => {
    this.setState({ serverErrorMessage: errorMessage });
  }

  componentWillUnmount() {        
    const urlParams = new URLSearchParams(window.location.search);
    const obStatus = urlParams.get('status') || '';
    this.props.appValidationsRemove([]);
    this.props.showappValidation('');
    window.removeEventListener('pageshow', this.handlePageShow);
    window.removeEventListener('resize', this.handleWindowSizeChange);
    const isApplicationPage = window.location.pathname.split('/')[1] === 'application';
    const hasStatusParam = urlParams.has('status');
     if (isApplicationPage && (!hasStatusParam || (obStatus !== 'failure'&& obStatus !== 'success'))) {
      sessionStorage.removeItem('applicationId');
    } 
    if(this.disconnect) {
      this.observer.disconnect();
    }

    clearInterval(this.checkIntervalMobileChange);
    clearInterval(this.checkIntervalEmailAddress);


    const applicationBodyElement = document.querySelector('body');
    applicationBodyElement.classList.remove('applicationPage');
    this.resizeObserver?.disconnect();
  }
  handleWindowSizeChange = () => {
    this.setState({ width: window.innerWidth });
  };

  analyticsClickEvent = (data) => {
    if (data === 'serverErrorShowModel') {
      analyticsClickEvent('serverError_popup_ok','')
    } else if (data === 'fieldErrorShowModel') {
      analyticsClickEvent('fieldError_popup_ok','')
    }
  }

  handlePageShow = (event) => {      
    // Page was restored from bfcache (browser back/forward)
    window.dispatchEvent(new CustomEvent('triggerInitialLoad'));
  }

  removeFromHistory() {

    if (window.$('#forgotModal').hasClass('show') === false) {
      window.$('#forgotModal').modal('hide');
      window.$('.modal-backdrop').removeClass('show');
      window.$('body').removeClass('modal-open');
      window.$('.modal-backdrop').remove();
    }
  }

  redirectToMobileVerification(){
    window.$('#serverErrorShowModel').modal('hide');
    analyticsClickEvent('mobile_number_does_not_exist_ok','');
    this.props.navigate('/mobile-verification'); 
  }

  loggedUserApplyNow = async () => {
    this.setState({reCaptchaToken: ''});

    if(this.reCaptchaRef !== null && this.reCaptchaRef !== undefined){
      await this.reCaptchaRef.execute();
    }
    this.setState({loggedUserApplyNowFlag: true});
  }

  setValueOfShowMobileAndEmailAddress = () => {
    if(this.state.stepZeroData !== '' && this.state.stepZeroData !== undefined){
      this.state.stepZeroData.map((src) => {
          src.Questions.map((eachQuestion) => {
            if(eachQuestion.flxFieldApiName__c === 'Mobile_Number' || eachQuestion.flxFieldApiName__c === 'Email_Address')
            {
                this.setState({showMobileandEmailAddress: true})
              }
          })
        })
    }
  }

  isFrequencyExistInSecondSection = () => {
    if(this.state.stepZeroData !== '' && this.state.stepZeroData !== undefined){
      this.state.stepZeroData.map((src) => {
          src.Questions.map((eachQuestion) => {
            if(eachQuestion.flxFieldApiName__c === 'frequency')
            {
                this.props.updateFrequencyExists(true);
            }
          })
        })
    }
  }

  setValueOfSectionHeadingAndSubContext = (sectionData) => {
    let allSectionHeading = Object.assign({}, ...this.props.sectionHeading);
    let allSectionContext = Object.assign({}, ...this.props.sectionSubContext);

    if(sectionData !== '' && sectionData !== undefined) {
      sectionData.map((src, i) => {
        if(src.flxHeader__c !== '') {
          if(src.flxHeader__c.includes('Personal') || src.flxHeader__c.includes('About')) {
            allSectionHeading[0] = src.flxHeader__c
            allSectionContext[0] = src.flxSectionBodyRich__c
          }
          else if(src.flxHeader__c.includes('Loan')) {
            allSectionHeading[1] = src.flxHeader__c
            allSectionContext[1] = src.flxSectionBodyRich__c
          }
          else if(src.flxHeader__c.includes('Address')) {
            allSectionHeading[2] = src.flxHeader__c
            allSectionContext[2] = src.flxSectionBodyRich__c
          }
          else if(src.flxHeader__c.includes('Income')) {
            allSectionHeading[3] = src.flxHeader__c
            allSectionContext[3] = src.flxSectionBodyRich__c
          }
          
          this.props.updateSectionHeading(allSectionHeading)
          this.props.updateSectionContext(allSectionContext)
        }
      })

    }

  }

  // This method is called when the Apply Now button is clicked on the Important Information page of the application
  getUserValidated = async() => {
    
    if(!sessionStorage.getItem('user_tracking_id')) {
      const trackingId = uuidv4();
      sessionStorage.setItem('user_tracking_id', trackingId);
    }
    
    // remove the application id from the localStorage
    sessionStorage.removeItem('applicationId');

    let consents = {
      'Mobile_Consent':sessionStorage.getItem('mobileConsent'),
      'Email_Consent':sessionStorage.getItem('emailConsent'),
      'SMS_Consent':sessionStorage.getItem('smsConsent'),
      'Application_Consent':sessionStorage.getItem('applicationConsent')
    }
    frontEndLogs('Marketing Consent ',false,200, 'getUserValidated',consents);
    if(sessionStorage.getItem('mobileConsent')){
      frontEndLogs('Mobile App consent is ' + sessionStorage.getItem('mobileConsent'), false, 200, 'getUserValidated')
    }
    
    if(sessionStorage.getItem('emailConsent')){
      frontEndLogs('Email consent is '+ sessionStorage.getItem('emailConsent'),false,200, 'getUserValidated')
    }

    if(sessionStorage.getItem('smsConsent')){
      frontEndLogs('SMS consent is '+ sessionStorage.getItem('smsConsent'),false,200, 'getUserValidated')
    }

    if(sessionStorage.getItem('applicationConsent')){
      frontEndLogs('Application consent is ' + sessionStorage.getItem('applicationConsent'), false, 200, 'getUserValidated')
    }


    //Initialise the minimum and maximum loanAmount range as empty
    sessionStorage.setItem('maxLoanAmountRange', '');
    sessionStorage.setItem('minLoanAmountRange', '');
    let isvalidsessionId = isValidSessionId();
    if (localStorage.getItem('fromWhere') == 'apply_now' || sessionStorage.getItem('fromWhere') == 'apply_now') {
      analyticsClickEvent('apply_now_user_continue_button', '');
      await frontEndLogs('apply_now_user_continue_button_clicked', false, 200, 'start_application_page');
      const result = await this.props.questions();
      if(result?.data !== undefined){
        const details = result.data.data[0].sections.filter((drink, index) => index === 1);

        this.setState({ stepZeroData: details }, () => {
          this.setValueOfShowMobileAndEmailAddress()
          this.setValueOfSectionHeadingAndSubContext(this.state.stepZeroData)
        });

        const resultTwo = result.data.data[0].sections.filter((drink ,index) => index === 2);

        this.setState({secondSection: resultTwo, sectionTwoLength: Object.keys(resultTwo[0]['Questions']).length}, () => {
          this.isFrequencyExistInSecondSection()
          this.setValueOfSectionHeadingAndSubContext(this.state.secondSection);
        });

        const resultThree = result.data.data[0].sections.filter((drink ,index) => index === 3);
        this.setState({thirdSection: resultThree}, () => {
          this.setValueOfSectionHeadingAndSubContext(this.state.thirdSection);


        });

        const resultFour = result.data.data[0].sections.filter((drink ,index) => index === 4);
        this.setState({fourSection: resultFour}, () => {
          this.setValueOfSectionHeadingAndSubContext(this.state.fourSection);
        });


        firebaseLoadingEvent('apply_now_user_loaded','')
        this.props.removeSavedata([]);
        this.props.showappValidation('');
        setTimeout( async() => {
          
          this.setState({privacyPolicyCheck: true});
          this.showSectionHeading();
          this.showSectionSubContext();
          window.scrollTo(0, 0);
          this.setState({loading: false});
          await frontEndLogs('apply_now_questions_loaded', false, 200, 'application_flow');
          firebaseLoadingEvent('apply_now_questions_loaded', '')

        }, 1500);
      }
      return false;
    }
    else if(isvalidsessionId){
      analyticsClickEvent('logged_user_apply_now_button','');

      // update marketing consent for the login user
      this.setState({
        isEmailConsentChecked: sessionStorage.getItem('emailConsent') === 'true',
        isMobileAppConsentChecked: sessionStorage.getItem('mobileConsent') === 'true',
        isSMSConsentChecked: sessionStorage.getItem('smsConsent') === 'true',
        isApplicationConsentChecked: sessionStorage.getItem('applicationConsent') === 'true',
      })

      await frontEndLogs('logged_user_apply_now_button_clicked', false, 200, 'start_application_page');
      analyticsClickEvent('logged_user_apply_now_button_clicked', '')
      let applicationId = await this.getApplicationIDInstorage()
      if(applicationId !== null && applicationId !== undefined) {
        await this.continueApplicationJourney();
        return false;
      }

      this.setState({loggedUserApplyNowFlag: false});

      this.checkApplicantEligiblityForUser();
      
    }

  }

  loadQuestionsForLoginFlow = async() => {
    this.props.removeSavedata([]);
    this.props.showappValidation('');
    const result = await this.props.questions();
      if(result?.data != undefined){
        const detailsOfFirstSection = result.data.data[0].sections.filter((drink, index) => index === 1);

        this.setState({ stepZeroData: detailsOfFirstSection }, () => {
          this.setValueOfShowMobileAndEmailAddress()
          this.setValueOfSectionHeadingAndSubContext(this.state.stepZeroData)
        });

        const detailsOfSecondSection = result.data.data[0].sections.filter((drink ,index) => index === 2);

        this.setState({secondSection: detailsOfSecondSection, 
          sectionTwoLength: Object.keys(detailsOfSecondSection[0]['Questions']).length}, () => {
          this.isFrequencyExistInSecondSection()
          this.setValueOfSectionHeadingAndSubContext(this.state.secondSection);
        });

        const detailsOfThirdSection = result.data.data[0].sections.filter((drink ,index) => index === 3);
        this.setState({thirdSection: detailsOfThirdSection}, () => {
          this.setValueOfSectionHeadingAndSubContext(this.state.thirdSection);
        });

        const detailsOfFourthSection = result.data.data[0].sections.filter((drink ,index) => index === 4);
        this.setState({fourSection: detailsOfFourthSection}, () => {
          this.setValueOfSectionHeadingAndSubContext(this.state.fourSection);
        });
      }

      return false
  }

  checkUserDataIsEmpty = (userData, fieldName) => {
    let prepopulateValues = {}

    if(userData !== '' && userData !== null) {
      prepopulateValues[fieldName] = userData

      if(fieldName === 'First_Name') {
        this.props.firstNameFlagStatusCall(true);
      }
      if(fieldName === 'Last_Name'){
        this.props.lastNameFlagStatusCall(true);
      }
      if(fieldName === 'Email_Address') {
        this.props.emailFlagStatusCall(true);
      }
      if(fieldName === 'Mobile_Number') {
        this.props.mobileNumberFlagStatusCall(true);
      }
      
    }
    
    setTimeout(() => {
      this.props.saveApplicationDatas(prepopulateValues)
    }, 200);
    return false;
  }


  prepopulateUserPersonalDetails = (prepopulateData, fieldName) => {

    let prepopulateValues = {}
    if(fieldName == 'flxFirst_Name__c') {
      prepopulateValues['First_Name'] = prepopulateData[fieldName];
    }
    if(fieldName == 'flxLast_Name__c') {
      prepopulateValues['Last_Name'] = prepopulateData[fieldName];
    }
    if(fieldName == 'flxPersonEmail__c') {
      prepopulateValues['Email_Address'] = prepopulateData[fieldName];
    }
    if(fieldName == 'flxBirthDate__c') {
      prepopulateValues['Birth_Date'] = prepopulateData[fieldName];
    }
    if(fieldName == 'flxpersonmobile__c') {
      prepopulateValues['Mobile_Number'] = prepopulateData[fieldName];
    }

    this.props.saveApplicationDatas(prepopulateValues);
  }

  validationCheckForPrepopulateData = (prepopulatedData, keyName) => {
    let errorPrePopulate = {}
    if(keyName == 'flxFirst_Name__c' && prepopulatedData[keyName] !== undefined) {
      errorPrePopulate['First_Name'] = '';
    }
    if(keyName == 'flxLast_Name__c' && prepopulatedData[keyName] !== undefined) {
      errorPrePopulate['Last_Name'] = '';
    }
    if(keyName == 'flxPersonEmail__c' && prepopulatedData[keyName] !== undefined) {
      errorPrePopulate['Email_Address'] = '';
    }
    if(keyName == 'flxBirthDate__c' && prepopulatedData[keyName] !== undefined) {
      errorPrePopulate['Birth_Date'] = '';
    }
    if(keyName == 'flxpersonmobile__c' && prepopulatedData[keyName] !== undefined) {
      errorPrePopulate['Mobile_Number'] = ''
    }

    this.props.appvalidations(errorPrePopulate);
  }

  generatePurchaseRedirectURL = () => {
    const cookie = new Cookies()

    if(cookie.get('sourceURL') !== '' && cookie.get('sourceURL') !== undefined){
      let resultSourceURL = decodeURIComponent(cookie.get('sourceURL'));

      this.setState({resultSourceURL});
    }

  }

  userDetailsPopulateForExistingUser = async() => {
    let email = getEmailFromStorage();
    const requestObject = {
      email: email,
      Application_Channel: "Web"
    }
    
    let prepopulateValues = {}
    const result = await getAvatar(requestObject);
    if(result.status==200 && Object.keys(result.data.data).length !== 0){
        if(result?.data?.data?.mobile_number){
          sessionStorage.setItem('mobileNumber', result.data.data.mobile_number);
        }
        sessionStorage.setItem('UserEmail', result?.data?.data?.email);
        this.checkUserDataIsEmpty(result?.data?.data?.first_name, "First_Name");
        this.checkUserDataIsEmpty(result?.data?.data?.last_name, "Last_Name");
        this.checkUserDataIsEmpty(result?.data?.data?.email, "Email_Address");
        this.checkUserDataIsEmpty(result?.data?.data?.mobile_number, "Mobile_Number");

        if(result.data.data.personbirthdate !== null && result.data.data.personbirthdate !== '') {
          this.props.saveDate(convertDateFormat(result.data.data.personbirthdate));
          this.props.birthDateFlagStatusCall(true)
          prepopulateValues['Birth_Date'] = convertDateFormat(result.data.data.personbirthdate)
        }

        this.props.saveApplicationDatas(prepopulateValues)        


        setTimeout(() => {
          
          this.setState({privacyPolicyCheck: true});
          this.showSectionHeading();
          this.showSectionSubContext();
          window.scrollTo(0, 0);
          this.setState({loading: false});
        }, 5000);
    }
  }

  PrepopulateHideData = async () => {
    let prepopulateData = [];
    this.props.applicationValidation.map((appValidationData) => {
      let appValidationStageDatas = {};
      appValidationStageDatas[Object.keys(appValidationData)[0]] = appValidationData.stage
      prepopulateData.push(appValidationStageDatas)
    });


    if(this.state.prepopulateFlag){
        const prepopulateResult = await prepopulate();
        sessionStorage.setItem('mobileNumber', prepopulateResult.data.data.flxpersonmobile__c);
        sessionStorage.setItem('UserEmail', prepopulateResult.data.data.flxPersonEmail__c);
        if(prepopulateResult.status === 200) {
          this.props.prepopulateStatusCall(true);
          this.setState({prepopulateFlag: false,isReturningUser:true})
        }
        else{
          this.setState({isReturningUser:true})
        }
        return await this.handlePrepopulateDetailsInApplication(prepopulateResult,prepopulateData);
    }
    else{
      this.setState({isReturningUser:true})
    }

  }

  handlePrepopulateDetailsInApplication = async (prepopulateResult,prepopulateData) => {
    let self = this.props;
    if (prepopulateResult.data.data !== '') {
      const prepopulateDataFilter = Object.assign({}, ...prepopulateData);
      for (let key of Object.keys(prepopulateResult.data.data)) {
        if (prepopulateResult.data.data[key]) {
          let prepopulateValues = {}
           prepopulateValues[key] = this.handleSetPrepopulateValuesInField(prepopulateValues,key,prepopulateResult,self);
          if(Object.keys(prepopulateValues).length === 0){
            return false;
          }
          prepopulateValues[key] = prepopulateResult.data.data[key];
          
          prepopulateValues = removeSpecialCharacterInAddressFields(prepopulateValues,key,prepopulateResult,'prePopulate');
          
          self.saveApplicationDatas(prepopulateValues);
          if (prepopulateDataFilter[key] != undefined) {
            let errorPrepopulate = {};
            errorPrepopulate[key] = '';
            errorPrepopulate['stage'] = prepopulateDataFilter[key];
            self.appvalidations(errorPrepopulate);
          }
        }
      };
      setTimeout(() => {
        
        this.setState({privacyPolicyCheck: true});
        this.showSectionHeading();
        this.showSectionSubContext();
        window.scrollTo(0, 0);
        this.setState({loading: false});
      }, 10000);
    }
  }

  handleSetPrepopulateValuesInField = async(prepopulateValues,key,prepopulateResult,self) => {
    if (key === 'flxBirthDate__c' || key === 'time_in_occupation' || key === 'genesis__bank_hours__c') {
      const dayMonthPart = `(0[1-9]|[12][0-9]|30)[-/]?(0[13-9]|1[012])|31[-/]?(0[13578]|1[02])|(0[1-9]|1[0-9]|2[0-8])[-/]?02`;
      const yearPart = `[0-9]{4}`;
      const dateRegex = new RegExp(`^(${dayMonthPart})[-/]?(${yearPart})$`);
      const MonthPart = `29[-/]?02`;
      const leapYearPart = `(?:\\d{2}(?:[02468][048]|[13579][26])|(?:[02468][048]|[13579][26])00)`;
      const leapYearRegex = new RegExp(`^(${MonthPart})[-/]?(${leapYearPart})$`);

      const monthYearRegex = /^(0[1-9]|1[0-2])\/\d{4}$/;
    
      if (dateRegex.test(prepopulateResult.data.data[key]) || leapYearRegex.test(prepopulateResult.data.data[key]) || monthYearRegex.test(prepopulateResult.data.data[key])) {
        console.log('check true');
      } else {
        return prepopulateValues;
      }
    }

    if (key === 'flxBirthDate__c') {
      self.saveDate(prepopulateResult.data.data[key])
    }
    if(key==="sortcode_bankaccount"){
      prepopulateResult.data.data[key] = prepopulateResult.data.data[key].replace(/(\d{2})(\d{2})(\d{2})/, "$1-$2-$3")
    }
    if(key === 'flxFirst_Name__c') {
      prepopulateValues['First_Name'] = prepopulateResult.data.data[key];
      self.firstNameFlagStatusCall(true);
    }
    if(key === 'flxLast_Name__c') {
      prepopulateValues['Last_Name'] = prepopulateResult.data.data[key];
      
    } 
    if(key === 'flxPersonEmail__c') {
      prepopulateValues['Email_Address'] = prepopulateResult.data.data[key];
      self.emailFlagStatusCall(true);
    }
    if(key === 'flxBirthDate__c') {
      prepopulateValues['Birth_Date'] = prepopulateResult.data.data[key];
      self.birthDateFlagStatusCall(true)
    }
    if(key === 'flxpersonmobile__c') {
      prepopulateValues['Mobile_Number'] = prepopulateResult.data.data[key];

      self.mobileNumberFlagStatusCall(true)
    }
    return prepopulateValues;
  }

  monthDiff = (d1) => {
    if (d1 === null) {
      return 0;
    }
    let today = new Date();
    let months;
    months = (today.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += today.getMonth() + 1;
    return months <= 0 ? 0 : months;
  }


  getLabelName=(fieldName)=>{
    let LabelNames='';
    this.props.questionValueSave.map((src) => {
      if(src['field_api_name']===fieldName){
        LabelNames=src['field_question'];
      }
    });
    return LabelNames;
  }

  onlyAcceptInputs = (e) => {
    if (!/\d/.test(e.clipboardData.getData('Text')) || (/[a-zA-Z]/.test(e.clipboardData.getData('Text'))) ) {
        e.preventDefault();
    }
  }

  getMonthDifferenceForDate = (savedUserData) => {
    let monthDiffValue;

    if (savedUserData['date_moved_in_current_address'] && savedUserData['date_moved_in_current_address'] != '' && savedUserData['flxBirthDate__c'] != undefined) {
      let monthdiffData = savedUserData['date_moved_in_current_address'].split('/');
      let date_moved_in_current_address = monthdiffData[0] + '/' + '01' + '/' + monthdiffData[1];
      monthDiffValue = this.monthDiff(new Date(date_moved_in_current_address));
    }
    return monthDiffValue;
  }


  addApplicationProcessSave = (completedSteps, steps= '', stage = '') => {
    this.props.showAddress('');
    let errorDataShow='';
    const accountValue = this.props.amountRequested;
    const savedData = Object.assign({}, ...this.props.saveApplicationData);
    const validationData = Object.assign({}, ...this.props.applicationValidation);
    let applicationSaveProcess = [];
    let monthDiffValue = 6;
    
    monthDiffValue = this.getMonthDifferenceForDate(savedData);

    if (completedSteps === steps) {
      this.props.questionValueSave.map((src) => {
        if (src.stage == stage) {
          if (accountValue > this.props.threashold) {
          
            const completedStepsIfPartResult = this.completedStepsIfPart(src,monthDiffValue, savedData, validationData, applicationSaveProcess)
            applicationSaveProcess = completedStepsIfPartResult['applicationSaveProcess']
          } else {
           
            const completedStepsResult = this.completedStepsElsePart(src,monthDiffValue,savedData, validationData, applicationSaveProcess)

            applicationSaveProcess = completedStepsResult['applicationSaveProcess']
          }
        }
      })
    }

    if (completedSteps === 'three') {
      this.props.questionValueSave.map((src) => {
        if (src.stage == '2') {
          this.completedStepsThreeSortCodeValidation(src, savedData);
          
          applicationSaveProcess = this.completedStepsThreeEmploymentValidation(src,savedData, validationData,applicationSaveProcess)
        }
      })
    }

    errorDataShow = this.stepTwoAddressFieldValidation(completedSteps, monthDiffValue, savedData, errorDataShow)
    if(errorDataShow===''){
      return applicationSaveProcess;
    }else{
      const emptyArrayForError = []
      return emptyArrayForError;
    }
  }

  handleUserDetails = async(details)  => {
     const cookie = new Cookies();
     let isValidSessionId = ((localStorage.getItem('fromWhere')=='apply_now')|| (sessionStorage.getItem('fromWhere')=='apply_now')) ? sessionStorage.getItem('sessionId') !== null : localStorage.getItem('sessionId') !== null;
    if ((localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') && isValidSessionId) {
        removeSessionIdFromStorage();
        removeTokenFromStorage();
        removeEmailFromStorage();
        removeCsrfTokenFromStorage();
        sessionStorage.removeItem('UserName');
        sessionStorage.removeItem('userID');
      }

      let userDetails = details;
      this.setState({email: userDetails.Email_Address}, () => {
        setEmailInStorage(this.state.email);
      });
      this.setState({phoneNo: userDetails.Mobile_Number});

      userDetails.Application_Channel = "Web";
      userDetails.recaptchaToken = this.state.reCaptchaToken;
      userDetails.Retailer_Account__c = cookie.get('retailerId')
      userDetails.isMobileVerified = this.state.isMobileVerified

      if(this.state.userToken !== '' && this.state.userToken !== undefined){
        userDetails.dataToken = this.state.userToken
      }

      const result = await validatePersonalDetails(userDetails);

      this.setState({userDetailsFlag: false});

      if (result?.data?.statusCode !== undefined) {
        this.setState({loading: false})
        if(result.data.statusCode === 200 && result.data.data.dataToken !== ''){
          this.setState({userToken: result.data.data.dataToken })
          this.setState({codeError: ''});

          await this.redirectionOfApplyNowUser(result.data.data);
        } 
        else if(result.data.message !== undefined){
          let resultMessage = result.data.message;
          resultMessage = this.convertMessage(resultMessage);
          this.setState({serverErrorMessage : resultMessage});

          GTMServerSubmitError('Step 1', 'server',resultMessage, 1, 4, '1 : 4')
          window.$('#serverErrorShowModel ').modal('show')
        }
      } 
  }

  redirectionOfApplyNowUser = async(resultData) => {
    if(resultData.sendOtpTo === 'Mobile'){
      await frontEndLogs('mobile verification popup displayed '+this.state.phoneNo,false,200,'guest user');
      analyticsClickEvent('mobile_verification_popup_displayed', '');
      window.$('#mobileModal').modal('show')
      return false;
    }
    if(resultData.sendOtpTo === 'Email' && process.env.REACT_APP_ENABLE_EMAIL_OTP_VERIFICATION == 'true'){
      await frontEndLogs('email verification popup displayed '+this.state.email,false,200,'guest user');
      window.$('#registerModal').modal('show')
      return false;
    }
    if(resultData.showMarketingConsent){
      window.$('#marketingConsentModal').modal('show')
      return false;
    }
    else{
      setTokenInStorage(resultData.access_token);
      setEmailInStorage(resultData.user_details.email);
      setSessionIdInStorage(resultData.session_id);
      setCsrfTokenInStorage(resultData.csrf_token);
      sessionStorage.setItem('UserName',resultData.user_details.username);
      sessionStorage.setItem('userID',resultData.user_details.userid);
      GTMUserIdAndLoginState();
      GTMUserId();
      await this.checkApplicantEligiblityForUser();
    }
  }

  checkIfButtonLabelAndRedirectUrLExists = (dataResponse) => {

    if(dataResponse.buttonLabel !== '' && dataResponse.buttonLabel !== null && dataResponse.buttonLabel !== undefined) {
      this.setState({ popupButtonLabel: dataResponse.buttonLabel});
    }

    if(dataResponse.redirectUrl !== '' && dataResponse.redirectUrl !== null && dataResponse.redirectUrl !== undefined) {
      this.setState({ redirectURL: dataResponse.redirectUrl});
    }
  }

  validateStepConditions(steps, vals, completedSteps) {
    return steps[vals] !== '' && steps[vals] !== undefined && completedSteps === 'two';
  }

  handleNameCount(nameCount,labelNames, vals) {
    if (nameCount <= 2) {
      const labelName = this.getLabelName(vals);
      if (labelName !== undefined) {
        nameCount++;
        labelNames.push(labelName);
      }
    }
    return {nameCount : nameCount,labelNames:labelNames}
  }

  handleErrorCount(errorCount) {
    errorCount++;
    return errorCount;
  }
  
  incrementStepOne(stepone) {
    stepone++;
    return stepone;
  }

  updateStateAndProps() {
    this.setState({ displayErrorsStepOne: 'errors' });
    this.props.showappValidation('yes');
  }

  handleApplicationSteps = async(stepone,steptwo,errorCount,nameCount,LabelNames,completedSteps) => {
    this.props.applicationValidation.map((steps) => {
      let vals = Object.keys(steps)['0'];
      if (steps['stage'] === '1' && this.validateStepConditions(steps, vals, completedSteps)) {
       let checkNameCount =  this.handleNameCount(nameCount,LabelNames, vals);
       nameCount = checkNameCount.nameCount;
       LabelNames = checkNameCount.labelNames;
       errorCount = this.handleErrorCount(errorCount);
       stepone = this.incrementStepOne();
        this.updateStateAndProps();
      }

      if (steps['stage'] === '2') {
        steptwo++;
        if(steps[vals]!='' && steps[vals]!=undefined &&  completedSteps !== 'two'){
          if(nameCount<=2){
            let label_name=this.getLabelName(vals);
            if(label_name!=undefined){
            nameCount++;
            LabelNames.push(label_name);
            }
          }
          errorCount++;
        }
        this.setState({ displayErrorsStepTwo: 'erros' });
        this.props.showappValidation('yes');
      }
      if (steps['stage'] === '3') {
        steptwo++;
        this.setState({ displayErrorsStepThree: 'erros' });
        this.props.showappValidation('yes');
      }
    });
    return {stepone:stepone,steptwo:steptwo,errorCount:errorCount,nameCount:nameCount,LabelNames:LabelNames}
  }

 

  nextStep = async (completedSteps, e) => {
    window.dataLayer = window.dataLayer || {}; 
    let applicationProcessBasedResult;
    window.$('#userNoteShowModel').modal('hide')
    if(completedSteps == "two"){
      applicationProcessBasedResult = Promise.resolve(this.addApplicationProcessSave(completedSteps,'two', '1')); 
    }
    else {
      applicationProcessBasedResult = Promise.resolve(this.addApplicationProcessSave(completedSteps));
    }
    
    applicationProcessBasedResult = await applicationProcessBasedResult.then((value) => {
      return value;
    })
   
    this.setState({ unableToProvide: false });
    const { step } = this.state;
    if (this.props.applicationValidation.length === '0') {
      this.props.hideappValidation('');
      this.setState({
        step: step + 1
      });
      return false;
    }

    let stepone = 0;
    let steptwo = 0;
    let errorCount=0;
    let nameCount=0;
    let LabelNames=[];
    let applicationStepsResult = await this.handleApplicationSteps(stepone,steptwo,errorCount,nameCount,LabelNames,completedSteps);
    nameCount = applicationStepsResult.nameCount;
    LabelNames = applicationStepsResult.LabelNames;
    errorCount = applicationStepsResult.errorCount;
    stepone = applicationStepsResult.stepone;
    steptwo = applicationStepsResult.steptwo;
    setTimeout(() => {
      if(this.state.errorCount >=1 && this.state.step === 3){
        if(localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now'){
          GTMClientSubmitErrors('Step 3', 'client', this.state.errorCount, 3, 4, '3 : 4')
        } else {
          GTMClientSubmitErrors('Step 2', 'client', this.state.errorCount, 2, 3, '2 : 3')
        }
  
          return false;
      }
    }, 1000);
    this.setState({errorCount:errorCount})
    this.setState({LabelNames:LabelNames})
    this.setState({requiredFieldCount:nameCount})
    if(Object.keys(applicationProcessBasedResult).length === 0){
      window.$('#fieldErrorShowModel').modal('show')
      return false;
    }
    await this.applicationValidationInProps(stepone,steptwo,completedSteps,applicationProcessBasedResult,step);
  };

  applicationValidationInProps = async (stepone,steptwo,completedSteps,applicationProcessBasedResult,step) => {
    let j = 0;
    this.props.applicationValidation.map(async (src) => {
      let val = Object.keys(src)['0'];
      let stageOneResult = await this.handleStageOneValidation(src,val,stepone,completedSteps,applicationProcessBasedResult,step);
      if(stageOneResult === false){
        return stageOneResult;
      }

      if (src[val] !== '' && src['stage'] === '2') {
        let jsub = j - 1;
        j = jsub;
      }
      let sessionId = (localStorage.getItem('fromWhere')=='apply_now' || sessionStorage.getItem('fromWhere')=='apply_now'  ) ? sessionStorage.getItem('sessionId') !== null : localStorage.getItem('sessionId') !== null;
      let moveToStepThree = src[val] === '' && src['stage'] === '2' && completedSteps !== 'two' && sessionId;
      let checkErrorInStepTwo = this.checkstepTwoApiResponse(moveToStepThree,completedSteps);
      if(checkErrorInStepTwo === false){
        return false;
      }
        j++;
        if (steptwo === j) {
          if(!this.props.saveApplicationData){
            return false;
          }
            analyticsClickEvent('step3_next','')
            // window.$('#fieldErrorShowModel').modal('show')
            const allDetailsStage = Object.assign({}, ...applicationProcessBasedResult);
            const cookie = new Cookies();
            if(IS_TMX_ENABLED) {
              const TMXSessionId = uuidv4();
              window.threatmetrix.profile(process.env.REACT_APP_TMXDOMAIN, process.env.REACT_APP_TMXKEY, TMXSessionId);
              allDetailsStage.session_id = TMXSessionId;
            }
            allDetailsStage.application_id = await this.getApplicationIDInstorage();
            this.setState({ loading: true })
            await frontEndLogs('Application submit request : session Storage applicationId :'+sessionStorage.getItem("applicationId")+',cookie applicationID :'+cookie.get('applicationId'),false,200,'applicationValidationInProps',allDetailsStage);
            return await this.applicationSubmit();      
        }
      
    })
  }


  handleStageOneValidation = async(src,val,stepone,completedSteps,applicationProcessBasedResult,step) => {
    let i = 0;
    if (src[val] === '' && src['stage'] === '1') {
      i++;
      this.props.saveApplicationData.filter(async function (itm) {
        if (Object.keys(itm).toString() === val) {
          return itm
        }
      });

      let sessionId = (localStorage.getItem('fromWhere')=='apply_now' || sessionStorage.getItem('fromWhere')=='apply_now' ) ? sessionStorage.getItem('sessionId') !== null : localStorage.getItem('sessionId') !== null;
      let moveToNextStep = stepone === i && completedSteps !== 'three' && sessionId;
      if(!moveToNextStep){
        return this.handleForShowFieldErrorPopup(completedSteps);
      }
        analyticsClickEvent('step2_next','')
        if (!this.props.saveApplicationData) {
          return false;
        }
      const allDetails = Object.assign({}, ...applicationProcessBasedResult);
      const cookie = new Cookies();
      if (IS_TMX_ENABLED) {
        const TMXSessionId = uuidv4();
        window.threatmetrix.profile(process.env.REACT_APP_TMXDOMAIN, process.env.REACT_APP_TMXKEY, TMXSessionId);
        allDetails.session_id = TMXSessionId;
      }
      allDetails.application_id = await this.getApplicationIDInstorage();
      allDetails.Application_Channel = 'Web';
      this.checkApplicationType(allDetails);
      await frontEndLogs('Application submit request : Local Storage applicationId :' + localStorage.getItem("applicationId") + ',cookie applicationID :' + cookie.get('applicationId'), false, 200, 'handleStageOneValidation', allDetails);
      return await this.applicationSubmit();
    }
  }

  handleForShowFieldErrorPopup = (completedSteps)=> {
    this.props.applicationValidation.map(async (src) => {
      let valuesOfStageOne = Object.keys(src)['0'];
      if (src[valuesOfStageOne] !== '' && src['stage'] === '1' && completedSteps === 'two') {
        window.$('#fieldErrorShowModel').modal('show')
      }
    })
  }

  checkApplicationType = (allDetails) => {
    if (this.state.resultSourceURL) {
      allDetails.Humm_Purchase_Source_Url__c = this.state.resultSourceURL;
    }

    this.setState({ loading: true })
    const { amountRequested } = this.props;
    const eventType = Number(amountRequested) > Number(process.env.REACT_APP_MAXIMUM_LT_AMOUNT) ? 'big_thing' : 'little_thing';
    const customerType = Number(amountRequested) > Number(process.env.REACT_APP_MAXIMUM_LT_AMOUNT) ? '[BIG THINGS]' : '[LITTLE THINGS]';
    analyticsChangeEvent(eventType, amountRequested);

    window.dataLayer.push({
      "event": "metadata",
      "customerType": customerType
    });
  }


  checkstepTwoApiResponse = (moveToStepThree,completedSteps) => {
    if(!moveToStepThree){
      this.props.applicationValidation.map(async (src) => {
        let valuesOfStageTwo = Object.keys(src)['0'];
        let showErrorModel = src[valuesOfStageTwo] !== '' && src['stage'] === '2' && completedSteps === 'three';
        if (showErrorModel) {
          window.$('#fieldErrorShowModel').modal('show')
        }
      })
      return false;
    }
  }



  sendGtmErrorForVerifyOTP = (errorMessage) => {
    (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now')
    ? GTMServerSubmitError('Mobile Verification', 'server', errorMessage, 1, 4, '1 : 4')
    : GTMServerSubmitError('Mobile Verification', 'server', errorMessage, 1, 3, '1 : 3')
  }
  
  sendGtmEmailVerifyStatus = () => {
    (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now')
    ? GTMApplicationSubmitStatus('Email verification','server', 1, 4, "1 : 4", "[Email Verified]")
    : GTMApplicationSubmitStatus('Email verification','server', 1, 3, "1 : 3", "[Email Verified]")
  }

  sendGtmErrorForEmailVerifyOTP = (errorMessage) => {
    (localStorage.getItem('fromWhere') === 'apply_now'|| sessionStorage.getItem('fromWhere') === 'apply_now' )
    ? GTMServerSubmitError('Email Verification', 'server', errorMessage, 1, 4, '1 : 4')
    : GTMServerSubmitError('Email Verification', 'server', errorMessage, 1, 3, '1 : 3')
  }

  // 
  continueApplicationJourney = async(marketingConsent) => {
    this.setState({loading: true})
    const cookie = new Cookies();
    const allUserData = Object.assign({}, ...this.props.saveApplicationData);
    let applicationId = await this.getApplicationIDInstorage();
    if(applicationId == null || applicationId == undefined) {
      if(!marketingConsent){
        this.setState({prepopulateFlag: true});
      }
      
      const obj = {
        "Application_Channel": "Web",
        "Retailer_Account__c": this.state.hasPartnerDetails.id || cookie.get('retailerId') || sessionStorage.getItem('storeID') || sessionStorage.getItem('RetailerIdFromQuoteTool'),
        "Retailer_Campaign_Code__c": cookie.get('retailerReference') || null,
        "Humm_Retailer_Link__c":this.setHummRetailerLink()
      }
      if(process.env.REACT_APP_ENABLE_CONFIRM_EMAIL_ADDRESS_FIELD == 'true') {
        obj['Confirm_Email_Address'] = allUserData['Confirm_Email_Address'] || ''
      }
      await this.checkRetailerAndSendLogs();
      cookie.remove('applicationId');
      const result = await createApplication(obj);
      await frontEndLogs('Received Application Id - ' + result.data.data.application_id, false, 200, 'continueApplicationJourney');
      analyticsClickEvent('received_application_id', '')
      if(result.status === 200 && result.data.data.application_id !== undefined){
        sessionStorage.setItem('applicationId', result.data.data.application_id);

        cookie.set('applicationId',result.data.data.application_id)
        // Push the applicationID to the GTM through dataLayer event
        GTMApplicationId();
      }else {
        this.setState({serverErrorMessage: result.data.message, loading: false});
        window.$('#marketingConsentModal').modal('hide');
        window.$('#serverErrorShowModel').modal('show');
        return false;
      }
    }

    if(window.$('#marketingConsentModal').hasClass('show') === true) {
      window.$('#marketingConsentModal').modal('hide');
    }

    this.setState({loading: true});
    if (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') {
      firebaseLoadingEvent("step2_loaded");
      this.setState({stepOne: "completed"});
      this.setState({step: 2});
    }
    else {
      firebaseLoadingEvent('step1_logged_user_loaded','')
      this.setState({step: 1});
      this.setState({privacyPolicyCheck: true});
    }
    this.props.removeSavedata([]);
    await this.PrepopulateHideData();
    this.props.showappValidation('');

    window.scrollTo(0, 0);
  }

  checkRetailerAndSendLogs = async()=>{
    const cookie = new Cookies();
    if(cookie.get('retailerId')) {
      await frontEndLogs('Retailer Id is sent on request of API call - '+cookie.get('retailerId'),false,200, 'application/createApplication');
    } else {
      await frontEndLogs('Retailer Id is not sent on request of API call ',false,200, 'application/createApplication');
    }
  }

  extractEmails(text) {
     return text.match(/(?=([a-z0-9._%+-]+))\1@(?=([a-z0-9-]+))\2\.(?=([a-z]{2,}))\3/gi);
  }

  retryApplication = async() => {         
    if(this.state.stages == 'one'){
      window.$('#serverErrorShowModel').modal('hide');
      await this.nextStep('two');
    }
    else if(this.state.stages == 'two'){
      window.$('#serverErrorShowModel').modal('hide');
      await this.nextStep('three');
    }
  }

  redirectionForErrorMessage = () => {
    if (this.state.reachLimitOTPVerify) {
      if (!this.state.isMobileOTPVerified) {
        this.setState({ reachLimitOTPVerify: false })
        this.props.updateMobileChange(true);
        let fieldValues = {}
        fieldValues['Mobile_Number'] = false;
        this.clearMobileNumberAndHighlightField();
        this.props.firstSectionValidationUpdate(fieldValues);
      } else if (!this.state.isEmailOTPVerified) {
        let fieldValues = {}
        fieldValues['Email_Address'] = false;
        this.validateEmailAddressCheck();
        this.clearEmailAddressAndHighlightField();
        this.props.firstSectionValidationUpdate(fieldValues);
        this.hidePopup("#registerModal")
      }
    }
    //Handle first name or last name update of user with existing contract.
    if (this.state.isActiveContract) {
      const newUrl = this.state.redirectURL;
        this.setState({serverErrorMessage: "",popupButtonLabel: "",redirectURL:''}, () => {
          window.location.replace(newUrl);
        });  
    }
    
    analyticsClickEvent('ok', '')
    window.$('#commonModel').modal('hide');
    window.$('#userBalanceShowModel').modal('hide')
    window.$('.modal-backdrop').removeClass('show');
    window.$('body').removeClass('modal-open');
    window.$('.modal-backdrop').remove();
    if(this.state.runEmailVerificationOnOk){
      this.setState({ runEmailVerificationOnOk: false, loading: true }, async () => {
      this.props.disableChangeEmailOption(true);
      this.setState({ isEmailFieldDisabled: true });
      if (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') {
        this.handleEmailVerificationFlow();
      } else {
        this.setState({ isMobileOTPVerified: true })
        this.checkMfaValidationForUserToEmail();
      }
      });
    }
    if(this.state.validateStatusCode == 400){
      this.props.appValidationsRemove([]);
      this.props.getAmountRequested('');
      this.props.showappValidation('');
      this.props.removeSavedata([]);
      this.redirectionForErrorPopupUpIfRedirectURLExists();
    }
  }

  serverErrorRedirection(){
    if(this.state.decisionByLendingMetrics && !this.state.showMitekConsent){
      return ( 
        <button type="button" className="btn btn-primary text-capitalize" onClick={() => {this.setState({loading:true});window.$('#serverErrorShowModel').modal('hide'); this.handleWarningOBResponse() }}
        >Try Again</button> );
    }else if(parse(this.state.serverErrorMessage) === 'Something went wrong. Please try again.'){
      return ( 
        <button type="button" className="btn btn-primary text-capitalize" onClick={() => { this.retryApplication().catch(error => console.error(error)); }}
      >Try Again</button> );
    }else if(this.state.decisionByLendingMetrics) {
      return (
        <button type="button" className="btn btn-primary" data-dismiss="modal" 
      onClick={this.redirectionBasedOnLendingMetrics}
      >Ok</button>)
    }
    else if(this.state.validateStatusCode != 404) {
      return (
        <button type="button" className="btn btn-primary" data-dismiss="modal" 
      onClick={this.redirectionForErrorMessage}
      >{this.state.popupButtonLabel ? this.state.popupButtonLabel : `Ok`}</button>)
    }
    else {
      return (
        <button type="button" className="btn btn-primary"  
      onClick={() => this.redirectToMobileVerification()}
      >Ok</button>
      );
    }

  }

  // To handle button label for OB failure
  redirectionBasedOnOB(){
    return ( 
      <button type="button" className="btn btn-primary text-capitalize" onClick={() => {this.setState({loading:true});window.$('#serverErrorShowModel').modal('hide'); this.redirectionBasedOnLendingMetrics() }}
      >OK</button> );
  }

// To handle redirect for OB failure
  redirectionBasedOnLendingMetrics = async() => {
      const urlParams = new URLSearchParams(window.location.search);
      let obStatus = this.state.obStatus || urlParams.get('status');
      
      if(obStatus === 'failure') {
        this.setState({showInitializePage: true, phoneNo: sessionStorage.getItem('mobileNumber')});
        await  this.handleWarningOBResponse();
        if(sessionStorage.getItem('brokerFlow') == 'true') {
          const { location } = this.props;
          const { pathname, search } = location;
          const urlParams = new URLSearchParams(search);
          urlParams.set('broker', true);
          urlParams.set('applicationID', sessionStorage.getItem('application_id') || this.getApplicationIDInstorage());
          urlParams.set('sessionId', (localStorage.getItem('sessionId') || sessionStorage.getItem('sessionId')));
          urlParams.delete('application_id')
          urlParams.delete('connection_id')
          urlParams.delete('status')

          const newUrl = `${pathname}?${urlParams.toString()}`;
          if (window.location.href !== newUrl) {
            window.history.replaceState(null, '', newUrl);
          }          
        } else {
          const currentPath = window.location.pathname;
          window.history.replaceState({}, '', currentPath);
      }
    }
  }

  convertMessage = (msg) => {

    if (this.extractEmails(msg) != null) {
      let newtext = '';
      let val = this.extractEmails(msg);
      val.map((src) => {
        let anchorTag = "<a target='_blank' href='https://mail.google.com/mail/u/0/?fs=1&to=" + src + "&su=Enquiry&tf=cm'>" + src + "</a>"
        newtext = msg.replace(src, anchorTag);
        msg = newtext;

      })
    }

    return msg;

  }

  // Method to generate reCaptcha when otp code for mobile is not empty
  handleRecaptchaMobileVerify = () => {
    this.setState({reCaptchaToken: ''})

    if (this.state.code != '' && this.state.code != undefined) {
        this.reCaptchaRef.execute()
          .catch(error => console.error(error));

        this.setState({mobileVerifyFlag: true})
    }
    else {
      this.setState({ codeError: 'Verification code is required.', codeSuccess: ''});

      (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now')
      ? GTMServerSubmitError('Mobile Verification', 'client', "Verification code is required.", 1, 4, '1 : 4')
      : GTMServerSubmitError('Mobile Verification', 'client', "Verification code is required.", 1, 3, '1 : 3')
    }
  }

  // Method to generate reCaptcha when otp code for Email is not empty
  handleRecaptchaEmailVerify = () => {
    this.setState({reCaptchaToken: ''})

    if (this.state.code != '' && this.state.code != undefined) {
        this.reCaptchaRef.execute()
          .catch(error => console.error(error));

        this.setState({emailVerifyFlag: true})
    }
    else {
      this.setState({ codeError: 'Verification code is required.', codeSuccess: ''});

      (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now')
      ? GTMServerSubmitError('Email Verification', 'client', "Verification code is required.", 1, 4, '1 : 4')
      : GTMServerSubmitError('Email Verification', 'client', "Verification code is required.", 1, 3, '1 : 3')
    }
  }

  handleRecaptchaForResendEmail = (event) => {
    if(event) {
      let text = event.target.innerText.replaceAll(' ', '_');
      analyticsClickEvent(text.toLocaleLowerCase(),'')
    }

    this.setState({reCaptchaToken: ''})
    this.reCaptchaRef.execute()
      .catch(error => console.error(error));

    this.setState({resendEmailFlag: true})
  }

  handleRecaptchaForResendMobile = (event) => {
    if(event) {
      let text = event.target.innerText.replaceAll(' ', '_');
      analyticsClickEvent(text.toLocaleLowerCase(),'')
    }

    this.setState({reCaptchaToken: ''})
    this.reCaptchaRef.execute()
      .catch(error => console.error(error));

    this.setState({resendMobileFlag: true})
  }

  isConsentUndefinedCheck = (userConsent) => {
    let consents = {
      'Mobile_Consent':sessionStorage.getItem('mobileConsent'),
      'Email_Consent':sessionStorage.getItem('emailConsent'),
      'SMS_Consent':sessionStorage.getItem('smsConsent'),
      'Application_Consent':sessionStorage.getItem('applicationConsent')
    }
    frontEndLogs('Marketing Consent ',false,200, 'isConsentUndefinedCheck',consents);

    if(userConsent === 'mobileConsent' && sessionStorage.getItem('mobileConsent')){
      frontEndLogs('Mobile App consent is ' + sessionStorage.getItem('mobileConsent'), false, 200, 'isConsentUndefinedCheck')
      analyticsClickEvent('mobile_consent_clicked', '')
    }
    else if(userConsent === 'emailConsent' && sessionStorage.getItem('emailConsent')){
      frontEndLogs('Email consent is ' + sessionStorage.getItem('emailConsent'), false, 200, 'isConsentUndefinedCheck')
      analyticsClickEvent('email_consent_clicked', '')
    }
    else if(userConsent === 'smsConsent' && sessionStorage.getItem('smsConsent')){
      frontEndLogs('SMS consent is ' + sessionStorage.getItem('smsConsent'), false, 200, 'isConsentUndefinedCheck')
      analyticsClickEvent('sms_consent_clicked', '')
    }
    else if(userConsent === 'applicationConsent' && sessionStorage.getItem('applicationConsent')){
      frontEndLogs('Application consent is '+ sessionStorage.getItem('applicationConsent'),false,200, 'isConsentUndefinedCheck')
      analyticsClickEvent('application_consent_clicked', '')
    }
  }

  handleInputChangeValidation = (event) => {
    if(window.$('#registerModal').hasClass('show') && event.target.value.length >= 6) {
        return false
    }
    else if(window.$('#mobileModal').hasClass('show')) {
      analyticsClickEvent('mobile_verification_popup_displayed', '');
      if (event.target.value.length >= 7) {
        return false
      }
    }
    return true;
  }
  
  // method to input change for input field in email, mobile and marketing consent popup
  handleInputChange = (event) => {
    let emailAndMobileInputValidation = this.handleInputChangeValidation(event);
    if(!emailAndMobileInputValidation) {
      return emailAndMobileInputValidation;
    }

    let name = event.target.name;
    let value = event.target.value;
    let checked = event.target.checked;
    this.setState({ [name]: value });
    if (name === 'code') {
      if (!/\d/.test(value)) {
          event.preventDefault();
      }
    } 
    let newImageSrc;

    const updateConsent = (consentKey, stateKey) => {
      
      sessionStorage.setItem(consentKey, checked);
      const newImageSrc = checked ? 'images/checked.svg' : 'images/unchecked.svg';
      this.setState({ [stateKey]: newImageSrc });
      this.updateMarketingConsentForLogin();
      setTimeout(() => this.isConsentUndefinedCheck(consentKey), 200);
    };

    switch(name){
      case "mobile-app-radio":
        updateConsent('mobileConsent', 'mobileCheckConsentSrc');
        break;
      case "smsRadio":
        updateConsent('smsConsent', 'smsCheckConsentSrc');
        break;
      case "emailRadio":
        updateConsent('emailConsent', 'emailCheckConsentSrc');
        break;
        case "applicationConsentRadio":    
        if(this.state.disableApplicationConsentButton && this.state.showQRCode) {
          sessionStorage.setItem('applicationConsent', 'true');
        } else {
          sessionStorage.setItem('applicationConsent', event.target.checked);         
          newImageSrc = sessionStorage.getItem('applicationConsent') === 'true' ? 'images/checked.svg' : 'images/unchecked.svg';
          this.setState({ applicationConsentSrc: newImageSrc });
          if(!this.state.showQRCode) {
            this.setState({ disableApplicationConsentButton: !event.target.checked });          
          }        
        }
        setTimeout(() => {
          this.isConsentUndefinedCheck('applicationConsent');
        }, 200);
        break;
        
        
    }
  }

  aboutSectionValueSendInlogs = (requestObjectMobile,methodName) => {
    const allUserData = Object.assign({}, ...this.props.saveApplicationData);
    let aboutSectionStateValues = {
      "Email_Address": this.state.email,
      "First_Name": this.state.firstName,
      "Last_Name": this.state.lastName,
      "Mobile_Number": this.state.phoneNo,
      "Birth_Date": this.state.dateOfBirth
    }
    frontEndLogs('Application user details sent before call the API', false, 200, methodName, { requestPayload: requestObjectMobile, aboutSectionValues: aboutSectionStateValues, allUserData: allUserData });
  }

  // Resend OTP for mobile
  resendCodeForMobile = async(_e) => {
    let requestObjectMobile = { 
      recaptchaToken: this.state.reCaptchaToken,
      "Mobile_Number": this.state.phoneNo
    }

    this.setState({resendMobileFlag: false})
    if(this.state.reCaptchaToken){
      this.aboutSectionValueSendInlogs(requestObjectMobile,'resendCodeForMobile')
      const result = await sendMobileOTP(requestObjectMobile);
      this.setState({onBlurInputFiled:false},()=>{
        this.handleResendOTPResult(result);
      })
    }

  }

  checkIfUserExistsAfterMobileVerify = async() => {
    const allUserData = Object.assign({}, ...this.props.saveApplicationData);
    this.setState({serverErrorMessage: ''});
      const requestPayload = {
        "Email_Address": this.state.email ? this.state.email : allUserData['Email_Address'],
        "First_Name": this.state.firstName ? this.state.firstName : allUserData['First_Name'],
        "Last_Name": this.state.lastName ? this.state.lastName : allUserData['Last_Name'],
        "Mobile_Number": this.state.phoneNo ? this.state.phoneNo : allUserData['Mobile_Number'],
        "Birth_Date": this.state.dateOfBirth ? this.state.dateOfBirth : allUserData['Birth_Date']
      }
	let checkUserStateRequest = {
	      "Email_Address": this.state.email,
	      "First_Name": this.state.firstName,
	      "Last_Name": this.state.lastName,
	      "Mobile_Number": this.state.phoneNo,
	      "Birth_Date": this.state.dateOfBirth
	    }
      if(process.env.REACT_APP_ENABLE_CONFIRM_EMAIL_ADDRESS_FIELD == 'true') {
        requestPayload['Confirm_Email_Address'] = allUserData['Confirm_Email_Address'] || ''
      }
      frontEndLogs('sent request before call the check user existence api', false, 200, 'checkIfUserExistsAfterMobileVerify', { requestPayload: requestPayload, checkUserStateRequest: checkUserStateRequest, allUserData: allUserData });

      const responseCheckUserExistence = await checkUserExistence(requestPayload);
this.setState({ onBlurInputFiled: false }, () => {
      if(responseCheckUserExistence?.status === 200 || responseCheckUserExistence?.status === 409){
        this.handleSuccessResponseOfCheckUserExistenceAPI(responseCheckUserExistence)
      }
      else if(responseCheckUserExistence?.status === 400) {
        this.handleFailureResponseOfCheckUserExistenceAPI(responseCheckUserExistence)
      }
    });
  }

  updateMarketingConsentForLogin = () => {
    return isValidSessionId() ? this.updateMarketingConsent() : {};
  }

  handleFailureResponseOfCheckUserExistenceAPI = (responseCheckUserExistence) => {
    if(responseCheckUserExistence?.data?.data?.accountStatus === "PARTIAL_MATCH_ACCOUNT"){
      let resultmessage = responseCheckUserExistence.data.message;
      resultmessage = this.convertMessage(resultmessage);

      GTMServerSubmitError('About You','server',resultmessage,1,4,'1 : 4');
      this.setState({serverErrorMessage: resultmessage, validateStatusCode: responseCheckUserExistence.status,
        popupButtonLabel: responseCheckUserExistence.data.data.buttonLabel, 
        redirectURL: responseCheckUserExistence.data.data.redirectUrl,isExistingUserChangeEmailOption: true},()=>{
          analyticsClickEvent('mobile_verification_popup_hidden', '');
          this.hidePopup('#mobileModal');
      if (localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') {
        this.setState({validateStatusCode: '', loading: false});
        window.$('#serverErrorShowModel').modal('show');
      }      
      else if(!this.state.isEmailOTPVerified && process.env.REACT_APP_ENABLE_EMAIL_OTP_VERIFICATION == 'true') {        
        this.handleRecaptchaForResendEmail();
        setTimeout(() => {
          if(this.state.codeSuccess !== '') {
            this.setState({ codeSuccess: '', codeError: '', codeErrorForResendCode: ''});
            this.setState({ loading: false });
            window.$('#registerModal').modal('show');
          }
          else if(this.state.codeErrorForResendCode !== '') {
            this.setState((prevState)=>{
              return {
                popupButtonLabel: '',
                serverErrorMessage: prevState.codeErrorForResendCode,
                validateStatusCode: '',
                redirectURL: '',
                loading: false
              }
            })
            window.$('#serverErrorShowModel').modal('show');
            this.props.updateEmailChange(true);
            let fieldValues = {}
            fieldValues['Email_Address'] = false;
          }
        }, 2500); 
      } else {        
        this.setState({ serverErrorMessage: resultmessage, validateStatusCode: responseCheckUserExistence.status,
        popupButtonLabel: responseCheckUserExistence.data.data.buttonLabel, 
        redirectURL: responseCheckUserExistence.data.data.redirectUrl, loading: false });
        window.$('#serverErrorShowModel').modal('show');
      }
        });
    }else if(responseCheckUserExistence?.data?.message === 'The last name must contain alphabets and must be at least two characters long.')
    {
      frontEndLogs('The last name field failed the validation' + this.getApplicationIDInstorage(), true, 400, 'handleFailureResponseOfCheckUserExistenceAPI',responseCheckUserExistence);
      let lastNameValidationMessage = responseCheckUserExistence?.data?.message;
      GTMServerSubmitError('About You','server',lastNameValidationMessage,1,4,'1 : 4');
      this.setState({serverErrorMessage: lastNameValidationMessage,loading: false},()=>{
        let stages = {};
        let lastNameStagesValues={}
        lastNameStagesValues['Last_Name'] = '';
        stages['Last_Name'] = 'This is Required';
        stages['stage'] = this.props.stage;
        this.props.saveApplicationDatas(lastNameStagesValues);
        this.props.appvalidations(stages);
        let fieldValues = {}
        fieldValues['Last_Name'] = false;
        this.props.firstSectionValidationUpdate(fieldValues)
        window.$('#serverErrorShowModel').modal('show')
        return false;
      })
      ;

    } else if (responseCheckUserExistence?.data?.data?.fields === 'First_Name') {
      this.setState({serverErrorMessage: responseCheckUserExistence?.data?.message, loading: false},()=>{
      let stages = {};
        let firsttNameStagesValues = {}
        firsttNameStagesValues['First_Name'] = '';
        stages['First_Name'] = responseCheckUserExistence?.data?.message;
        stages['stage'] = this.props.stage;
        this.props.saveApplicationDatas(firsttNameStagesValues);
        this.props.appvalidations(stages);
        let fieldValues = {}
        fieldValues['First_Name'] = false;
        this.props.firstSectionValidationUpdate(fieldValues)
        window.$('#serverErrorShowModel').modal('show')
        return false;
      })

    } else{
       frontEndLogs('Other response of check user existence ' + this.getApplicationIDInstorage(), true, 400, 'handleFailureResponseOfCheckUserExistenceAPI',responseCheckUserExistence);
        this.setState({ loading: false,serverErrorMessage: responseCheckUserExistence?.data?.message,popupButtonLabel:responseCheckUserExistence?.data?.data?.buttonLabel,redirectURL:responseCheckUserExistence?.data?.data?.redirectUrl, isActiveContract: responseCheckUserExistence?.data?.data?.isActiveContract });
        GTMApplicationFunnelSubmitError('Application Flow','server',1,2,"1:2","Something went wrong");
        window.$('#serverErrorShowModel').modal('show')
        return false;
    }
  }

  handleEmailVerificationFlow = () => {
    if(this.props.emailFlag){
      this.checkMfaValidationForUserToMobile();
    } else if(process.env.REACT_APP_ENABLE_EMAIL_OTP_VERIFICATION == 'false') {
        this.createSessionForUser()
    } else if(!this.state.isEmailOTPVerified || process.env.REACT_APP_ENABLE_EMAIL_OTP_VERIFICATION == 'true'){            
      
      this.handleRecaptchaForResendEmail();
      setTimeout(() => { 
        if(this.state.codeSuccess !== '') {
          this.setState({ codeSuccess: '', codeError: '', codeErrorForResendCode: ''});
          this.setState({ loading: false });
          window.$('#registerModal').modal('show');
        }
        else if(this.state.codeErrorForResendCode !== '') {
          this.setState((prevState) => ({ validateStatusCode: '', serverErrorMessage: prevState.codeErrorForResendCode, popupButtonLabel: '',
           redirectURL: '',  loading: false }));
          window.$('#serverErrorShowModel').modal('show');
          this.props.updateEmailChange(true);
          let fieldStateValues = {}
          fieldStateValues['Email_Address'] = false;
        }
      }, 2500);
    }
  }

  handleAccountRecordNeedsUpdate = async () => {
    const allUserData = Object.assign({}, ...this.props.saveApplicationData);
    const updatePayload = {
      "Email_Address": this.state.email ? this.state.email : allUserData['Email_Address'],
      "Mobile_Number": this.state.phoneNo ? this.state.phoneNo : allUserData['Mobile_Number'],
      "userId": sessionStorage.getItem('userID')
    };

    try {
      const updateResponse = await updateAccountInfo(updatePayload);

      if(updateResponse?.status === 200) {
        // Update localStorage email after successful API call
        setEmailInStorage(this.state.email || allUserData['Email_Address']);
        sessionStorage.setItem('UserEmail', this.state.email);
        const sessionId = updateResponse?.data?.data?.sessionId || updateResponse?.data?.sessionId;
        if(sessionId) {
          setSessionIdInStorage(sessionId);
        }

        this.loaderDelayWait(10000).then(() => {
          this.setState({
            serverErrorMessage: 'Email Address updated successfully',
            popupButtonLabel: 'OK',
            loading: false,
            runEmailVerificationOnOk: true
          });
          window.$('#serverErrorShowModel').modal('show');
        });
      } else {
        // Handle update failure
        this.setState({
          serverErrorMessage: updateResponse?.data?.message || 'Failed to update Email Address',
          loading: false
        });
        window.$('#serverErrorShowModel').modal('show');
      }
    } catch (error) {
      this.setState({
        serverErrorMessage: 'Failed to update Email Address',
        loading: false
      });
      window.$('#serverErrorShowModel').modal('show');
    }
  };

  handleSuccessResponseOfCheckUserExistenceAPI = async (responseCheckUserExistence) => {
    
    if(responseCheckUserExistence?.data?.data?.isNewAccount === true) {
      if(!this.state.isEmailOTPVerified){
        this.setState({loading: true, isNewAccountValue: responseCheckUserExistence?.data?.data?.isNewAccount})
        this.handleScrollOfNextSection();
      }
    }
    else if(responseCheckUserExistence?.data?.data?.isNewAccount === false){
      if (responseCheckUserExistence?.status === 409) {
        sessionStorage.setItem('userID', responseCheckUserExistence.data.data.userId);
        this.setState({loading: true, isUserExists: true, isNewAccountValue: responseCheckUserExistence?.data?.data?.isNewAccount});
        await this.handleAccountRecordNeedsUpdate();
      } else {
        this.setState({loading: true, isUserExists: true, isNewAccountValue: responseCheckUserExistence?.data?.data?.isNewAccount});
        this.handleEmailVerificationFlow();
      }
    }
  }

  analyticsCheckBoxClickEvent = (e) => {
    analyticsClickEvent('privacy_policy','');
  }

  resendCodeForEmail = async(_e) => {
    let email = getEmailFromStorage();
    let requestObjectEmail = {
      recaptchaToken: this.state.reCaptchaToken,
      "Email_Address": email ?? this.state.email,
      "First_Name": this.state.firstName,
      "Last_Name": this.state.lastName
    }
    this.setState({resendEmailFlag: false})
    if(this.state.reCaptchaToken) {
      this.aboutSectionValueSendInlogs(requestObjectEmail,'resendCodeForEmail');
      const result = await emailSendOTP(requestObjectEmail);
      this.setState({onBlurInputFiled:false},()=>{
      this.handleResendOTPResult(result);
      });
    }
  }

  checkUserExistsAfterEmailVerified = async(responseEmailVerified) => {
    await this.checkIfUserExistsAfterMobileVerify();

    setTimeout(() => {
      if(this.state.serverErrorMessage !== '') {
        if(window.$('#registerModal').hasClass('show') || this.state.loading) {
          this.hidePopup('#registerModal')
          this.setState({ loading: false });
          window.$('#serverErrorShowModel').modal('show');
          return false;
        }
      }
      else if(responseEmailVerified?.data?.data?.dataToken){
        this.setState({loading: true });
        this.props.updateEmailVerified(true)
  
        if (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') {
          this.createSessionForUser(responseEmailVerified.data.data.dataToken);
        }
        else {
          this.hidePopup('#registerModal');
          this.checkApplicantEligiblityForUser();
        }
      }
    }, 3000);
  }

  handleResendOTPResult = (result) => {
    if (result.data.statusCode === 200) {
      this.setState({ codeSuccess: result.data.message }, () => {
        this.stylingChangesForVerificationMessage();
      })
      this.setState({ codeErrorForResendCode: '', codeError: ''})
    }
    /* check whether the status code received matches in the list
    using handleStatusCode method and set the error message in variable codeErrorForResendCode
    */
   else if(handleStatusCode(result.data.statusCode)){
    if(result.data.statusCode === 429){
      this.setState({ reachLimitOTPVerify:true,onBlurInputFiled:false,disableVerifyOkButton:true});
    }
    const resultMessage = result.data.message;
    let verifyMobileMessage = resultMessage?.replace("\n", "<br>");
    this.setState({ codeSuccess: '', codeError: ''});
    this.setState({ codeErrorForResendCode: verifyMobileMessage}, () => {
    this.stylingChangesForVerificationMessage();
    });
    }
  }

  checkMFAForEmailNecessaryForUser = () => {

    if (localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') {
      if(this.state.email === sessionStorage.getItem('UserEmail')) {
        this.checkMfaValidationForUserToEmail();
      } else {
        this.checkIfUserExistsAfterMobileVerify();
      }
    }
    else {
      this.checkIfUserExistsAfterMobileVerify();
    }
  }

  // Method to handle recaptacha verify for mobile verification
  redirectCodeScreenMobile = async(recaptchaToken) => {
    analyticsClickEvent('mobile_verify_ok_button','');
    const allUserData = Object.assign({}, ...this.props.saveApplicationData);
    this.setState({ codeError: '', codeErrorForResendCode: '', codeSuccess: ''})
    if (this.state.code === '') {
    this.setState({ codeError: 'Verification code is required.', loading: false, codeErrorForResendCode: '', codeSuccess: '' });
    this.setState({ loading: false });
    return false;
    }

    this.setState({disablePopupRegistration:'disable-popup'});

   let requestObject = {
    'verify_code': this.state.code,
    "recaptchaToken": this.state.reCaptchaToken ? this.state.reCaptchaToken : recaptchaToken,
    "Mobile_Number": this.state.phoneNo}

    if (localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') {
      requestObject["Email_Address"] = sessionStorage.getItem('UserEmail') ?? this.state.email ?? allUserData['Email_Address'] 
    }

    
    this.setState({disableVerifyOkButton:true})
     
    this.setState({mobileVerifyFlag: false, disableField: true});
    this.aboutSectionValueSendInlogs(requestObject,'redirectCodeScreenMobile');
    const mobileVerifyResult = await verifyMobileOTP(requestObject);

    if(mobileVerifyResult.status == 200){
      sessionStorage.setItem('mobileNumber', (this.state.phoneNo));
      const resultMessage = mobileVerifyResult.data.message;
      let verifyMobileMessage = resultMessage.replace("\n", "<br>");

      this.setState({verificationMessage: verifyMobileMessage, verifyMessage: verifyMobileMessage, codeSuccess: '',
      codeError: "", codeErrorForResendCode: '', isMobileOTPVerified: true, isEmailFieldDisabled: true, isConfirmEmailFieldDisabled: true}, () => {
        this.stylingChangesForVerificationMessage();
      })

        await this.loaderDelayWait(2600);
        analyticsClickEvent('mobile_verification_popup_hidden', '');
        this.hidePopup('#mobileModal');
        analyticsClickEvent('mobile_success_popup_displayed', '');
        window.$('#mobileSuccessModal').modal('show')


        await this.loaderDelayWait(2700);
        this.setState({ loading: true})
        analyticsClickEvent('mobile_success_popup_hidden', '');
        this.hidePopup('#mobileSuccessModal');
        this.props.updateMobileVerified(true);
        let fieldValues = {}
        fieldValues['Mobile_Number'] = true;
        this.props.firstSectionValidationUpdate(fieldValues)
        this.setState({isMobileOTPVerified: true})

        if(mobileVerifyResult?.data?.data?.verificationStatus === 'PARTIAL_MATCH_ACCOUNT') {
          this.setState({
            serverErrorMessage: mobileVerifyResult.data.data.verificationMessage,
            validateStatusCode: '',
            popupButtonLabel: mobileVerifyResult.data.data.buttonLabel,
            redirectURL: mobileVerifyResult.data.data.redirectUrl, loading: false });

            window.$('#serverErrorShowModel').modal('show')
        }
        else if(!this.props.saveDates) {
          this.handleUser(requestObject);
        }
        else {
          this.checkMFAForEmailNecessaryForUser();
        }
    }
    else {
        this.setState({disableVerifyOkButton:false, disableField: false})
        this.setState({codeError: mobileVerifyResult.data.message, codeSuccess: '', 
        codeErrorForResendCode: '',verificationMessage: ''});
        this.setState({ loading: false })

        this.stylingChangesForVerificationMessage();

        // Push error message for OTP verification to the datalayer
        this.sendGtmErrorForVerifyOTP(this.state.codeError);
    }
  }

  handleUser(requestObject) {
    if(localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') {
            this.checkIfUserExistsAfterMobileVerify();
          } else {
            if(requestObject["Email_Address"] === sessionStorage.getItem('UserEmail')) {
              this.checkMfaValidationForUserToEmail();
            }
            this.checkIfUserExistsAfterMobileVerify();
          }
  }

  checkUserIfExistsValidationPointForEmail = (result='') => {
    if (localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') {
      if(window.$('#registerModal').hasClass('show') === true && process.env.REACT_APP_ENABLE_EMAIL_OTP_VERIFICATION == 'true') {
        this.setState({loading: true})
        this.hidePopup('#registerModal');
      }

      if ((localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') || this.state.isUserExists) {
        this.handleScrollOfNextSection();
      }
      else {
        if(this.state.loading){
          this.setState({loading: false})
        }
        this.termsDisplay()
        analyticsClickEvent('user_note_show_model_displayed', '');
        window.$('#userNoteShowModel').modal('show')
      }
    }
    else {
      this.checkUserExistsAfterEmailVerified(result);
    }
  }

  stylingChangesForVerificationMessage = () => {
    if (window.$('#mobileModal').hasClass('show') === true && 
      (this.state.codeSuccess !== ''|| this.state.codeErrorForResendCode !== '')) {
      const textMessage = document.querySelector('#verifyMessage');
      textMessage.style.marginTop = "2.1375rem";

      const mobileModalButton = document.querySelector('#mobileModal .modal-footer');
      mobileModalButton.style.marginTop = "2.1375rem";

    }
    else if (window.$('#registerModal').hasClass('show') === true && 
    (this.state.codeSuccess !== ''|| this.state.codeErrorForResendCode !== '')) {
      const emailModalButton = document.querySelector('#registerModal .modal-footer');
      emailModalButton.style.marginTop = "2.34rem";

      const textMessage = document.querySelector('#verificationMessage');
      textMessage.style.marginTop = "2.34rem";
    }
  }
 
  // Method to handle recaptacha verify for email verification
  redirectCodeScreenEmail = async(recaptchaToken) => {
    analyticsClickEvent('email_verify_ok_button','');
      
    this.setState({ codeError: '' })
    if (this.state.code === '') {
    this.setState({ codeError: 'Verification code is required.', loading: false, codeSuccess: '' });
    return false;
    }
      this.setState({ codeError: '', codeErrorForResendCode: ''});
    

    this.setState({disablePopupRegistration:'disable-popup'});

      let obj = {
        "verify_code": this.state.code,
        "recaptchaToken": this.state.reCaptchaToken ? this.state.reCaptchaToken : recaptchaToken,
        "Email_Address": this.state.email
    }
    
    this.setState({disableVerifyOkButton:true, disableField: true})
     
    this.setState({emailVerifyFlag: false});
    this.aboutSectionValueSendInlogs(obj,'redirectCodeScreenEmail');
    const result = await verifyEmailOTP(obj);

    if(result.status == 200){

        let message = result.data.message;
        const verifyMessage = message.replace("\n", "<br>")
        this.setState({ verificationMessage: verifyMessage, verifyMessage: verifyMessage, isEmailOTPVerified: true, 
          codeSuccess: '', codeErrorForResendCode: ''}, () => {
            this.stylingChangesForVerificationMessage();
          })
        // Push email verified success status to the GTM datalayer
        this.sendGtmEmailVerifyStatus();

        setTimeout(() => {
          this.hidePopup('#registerModal');
          this.setState({ loading: false });
          window.$('#registerSuccessModal').modal('show')
        }, 2000);

        setTimeout(() => {
          this.hidePopup('#registerSuccessModal');
          this.setState({ loading: true });
        }, 4700);

        setTimeout(async () => {
          this.checkUserIfExistsValidationPointForEmail(result);
        }, 5500);

        setTimeout(async () => {
          let applicationCreateResult = await this.callToCreateApplicationForLoginUser();
          if(applicationCreateResult === false) {
            return false;
          }
        }, 6000);
    }
    else if(result.data.statusCode === 400) {
      this.setState({disableField: false})
      this.convertVerifyApiResponseMessage(result);
    }
    else if(result.data.statusCode === 409) {
      this.setState({disableField: false})
      let resultmessage = result.data.message;
      resultmessage = this.convertMessage(resultmessage);
      this.setState({approvedApplicationMessage: resultmessage, verificationMessage: result.data.data.verificationMessage});

      if(result.data.data.session_id){
        setTokenInStorage(result.data.data.access_token);
        sessionStorage.setItem('UserName',result.data.data.user_details.username);
        setSessionIdInStorage(result.data.data.session_id);
        setCsrfTokenInStorage(result.data.data.csrf_token);
        sessionStorage.setItem('userID', result.data.data.user_details.userid);

        GTMUserIdAndLoginState();
        GTMUserId();
      }

      setTimeout(() => {
        this.hidePopup('#registerModal');
      }, 2000)

      setTimeout(() => {
        window.$('#userBalanceShowModel').modal('show');
      }, 2700);
    }
    else {
        this.setState({disableVerifyOkButton:false, disableField: false})
        this.setState({
            codeError: result.data.message, codeSuccess: ''
            });
            this.setState({ loading: false })
            this.setState({ otpErrorMessage: result.data.message })
        
        // Push error message for email OTP verification to the datalayer
        this.sendGtmErrorForEmailVerifyOTP(result.data.messager);
    }
  }

  callToCreateApplicationForLoginUser = async() => {
    if (localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') {
      frontEndLogs('Email MFA Completed for the login user', false, 200, 'user/check_validity_of_user_mfa');
      let applicationId = await this.getApplicationIDInstorage();
      const allUserData = Object.assign({}, ...this.props.saveApplicationData);
      if(applicationId === null || applicationId === undefined){

        // call createNewApplication for creating an application id 
        const browserStoreCookie = new Cookies();
        let email = getEmailFromStorage();
        const createApplicationRequest = {
          "Humm_Purchase_Source_Url__c": this.state.resultSourceURL ?? null,
          "Email_Address": this.state.email ?? allUserData['Email_Address'] ?? email,
          "Retailer_Account__c": this.state.hasPartnerDetails.id ?? browserStoreCookie.get('retailerId') ?? sessionStorage.getItem('storeID') ?? sessionStorage.getItem('RetailerIdFromQuoteTool'),
          "Retailer_Campaign_Code__c": browserStoreCookie.get('retailerReference') ?? null,
          "Humm_Retailer_Link__c":this.setHummRetailerLink()
        }
        if(process.env.REACT_APP_ENABLE_CONFIRM_EMAIL_ADDRESS_FIELD == 'true') {
          createApplicationRequest['Confirm_Email_Address'] = allUserData['Confirm_Email_Address'] || ''
        }
        const cookie = new Cookies();
        cookie.remove('applicationId');
        const ApiResultFromCreateAPI = await createApplication(createApplicationRequest);
        await frontEndLogs('Recived Application Id - ' + ApiResultFromCreateAPI.data.data.application_id, false, 200, 'callToCreateApplicationForLoginUser');
        analyticsClickEvent('received_application_id_createApplication', '')
        let createApplicationResponseResult = this.checkCreateApplicationApiResponse(ApiResultFromCreateAPI);
        if(createApplicationResponseResult === false){
          return false;
        }
      }else{
        this.checkUserIfExistsValidationPointForEmail();
      }
        }
  }

  convertVerifyApiResponseMessage = (result) => {
    if(result.data.data.verificationMessage) {
      let resultmessage = result.data.message;
      resultmessage = this.convertMessage(resultmessage);

      let message = result.data.data.verificationMessage;
      const verificationMessage = message.replace("\n", "<br>")
      this.setState({verificationMessage: verificationMessage, popupButtonLabel: result.data.data.buttonLabel, redirectURL: result.data.data.redirectUrl});
      this.setState({serverErrorMessage: resultmessage, validateStatusCode: result.data.statusCode,
        codeSuccess: '', codeErrorForResendCode: '',});
      // Push email verified success status to the GTM datalayer
      this.sendGtmEmailVerifyStatus();

      setTimeout(() => {
        this.hidePopup('#registerModal');
        this.setState({loading: true})
      }, 2000);

      setTimeout(() => {
        this.setState({loading: false})
        window.$('#serverErrorShowModel').modal('show');
      }, 2700);
    }
    else {
      this.setState({disableVerifyOkButton:false})
      this.setState({codeError: result.data.message, codeSuccess: '', codeErrorForResendCode: ''});
      // Push error message for email OTP verification to the datalayer
      this.sendGtmErrorForEmailVerifyOTP(this.state.codeError);
    }
  }

  checkCreateApplicationDetailsFromApiResponse = (ApiResultForApplicationId) => {
    const cookie = new Cookies();
    if(ApiResultForApplicationId.status == 201 && ApiResultForApplicationId.data != undefined) {
      sessionStorage.setItem('applicationId', ApiResultForApplicationId.data.data.application_id);

      cookie.set('applicationId',ApiResultForApplicationId.data.data.application_id)
      // Push the applicationID to the GTM through dataLayer event
      GTMApplicationId();
      window.$('#registerModal').modal('hide')
    }
    else if(handleStatusCode(ApiResultForApplicationId.status)){
      this.setState({statusCode: ApiResultForApplicationId?.status,serverErrorMessage: ApiResultForApplicationId.data.message});
      window.$('#serverErrorShowModel').modal('show');

      return false;
    }
  }

  // Get application id from the API call 'application/create_new_app'
  createNewApplication = async () => {
    const allUserData = Object.assign({}, ...this.props.saveApplicationData);
    if (localStorage.getItem('fromWhere') == 'apply_now' || sessionStorage.getItem('fromWhere') == 'apply_now') {
    const cookie = new Cookies();
    this.setState({ loading: true });
    let email = getEmailFromStorage();
    const requestPayloadForCreateApplication = {
      "Email_Address": this.state.email ?? allUserData['Email_Address']  ?? email,
      "Retailer_Account__c": this.state.hasPartnerDetails.id ?? cookie.get('retailerId') ?? sessionStorage.getItem('storeID') ?? sessionStorage.getItem('RetailerIdFromQuoteTool'),
      "Retailer_Campaign_Code__c": cookie.get('retailerReference') ?? null,
      "Humm_Purchase_Source_Url__c": this.state.resultSourceURL ?? null,
      "Humm_Retailer_Link__c":this.setHummRetailerLink()
    }
    if(process.env.REACT_APP_ENABLE_CONFIRM_EMAIL_ADDRESS_FIELD == 'true') {
        requestPayloadForCreateApplication['Confirm_Email_Address'] = allUserData['Confirm_Email_Address'] || ''
    }

    cookie.remove('applicationId');
    const ApiResultForApplicationId = await createApplication(requestPayloadForCreateApplication);
     await frontEndLogs('Received Application Id - ' + ApiResultForApplicationId.data.data.application_id, false, 200, 'createNewApplication');
     analyticsClickEvent('received_application_id', '')
    let checkCreateApplicationResult = this.checkCreateApplicationDetailsFromApiResponse(ApiResultForApplicationId);
    if(checkCreateApplicationResult === false){
      return false;
    }

    let returnPrepopulatedResult = await this.SetPrepopulateDataToLoginUser();
    if(returnPrepopulatedResult === false){
      return false;
    }
    this.handleUserExists();
   } else if (localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') {
    this.setState({ loading: true, activeNewApp: true, isUserExists: true});
    await this.loadQuestionsForLoginFlow();
    await this.PrepopulateHideData();
   }

  }

  handleUserExists = () => {
    if (this.state.isUserExists) {
      if (this.state.prepopulateFlag) {
        this.PrepopulateHideData();
      }
      this.setState({ firstSectionProgressValue: 25, isEmailFieldDisabled: true, isConfirmEmailFieldDisabled: true });
      this.handleScrollOfNextSection();
    }
    else {
      if (this.state.loading) {
        this.setState({ loading: false })
      }
      this.termsDisplay()
      analyticsClickEvent('user_note_show_model_displayed', '');
      window.$('#userNoteShowModel').modal('show')
    }
  }

  SetPrepopulateDataToLoginUser = async() => {
    if (localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') {
      if(await this.getApplicationIDInstorage()) {
        await this.loadQuestionsForLoginFlow();

        setTimeout( async() => {
          this.props.removeSavedata([]);
          this.props.showappValidation('');

          if(this.state.prepopulateFlag) {
            this.PrepopulateHideData();
            return false;
          }
          
          this.props.userDetailsPopulateStatusCall(true);
          await this.userDetailsPopulateForExistingUser();
        }, 100);
          
          return false;
      }
    }
  }

  checkCreateApplicationApiResponse = (ApiResultFromCreateAPI) => {
    const cookie = new Cookies();
    if(ApiResultFromCreateAPI.status == 201 && ApiResultFromCreateAPI.data != undefined) {
      sessionStorage.setItem('applicationId', ApiResultFromCreateAPI.data.data.application_id);
      cookie.set('applicationId',ApiResultFromCreateAPI.data.data.application_id,{ path: '/', maxAge: 3600 });

      cookie.set('applicationId',ApiResultFromCreateAPI.data.data.application_id)
      // Push the applicationID to the GTM through dataLayer event
      GTMApplicationId();
      window.$('#registerModal').modal('hide')
    }
    else if(handleStatusCode(ApiResultFromCreateAPI.status)){
      this.setState({statusCode: ApiResultFromCreateAPI?.status,serverErrorMessage: ApiResultFromCreateAPI.data.message});
      window.$('#serverErrorShowModel').modal('show');

      return false;
    }
    if(this.state.isUserExists) {        
      this.setState({firstSectionProgressValue: 25, isEmailFieldDisabled: true, isConfirmEmailFieldDisabled: true});
    
      const moveToNextSection = document.getElementById("second-section");          
        this.setState({loading: false, globalProgressBarValue: 25}, () => {
          this.showSectionSubContext();
          this.showSectionHeading(); 
        });
        if(moveToNextSection && this.state.firstSectionProgressValue === 25){
            this.validationforPrepopulatedOfSecondSection();
        }                
    }
    else {
      if(this.state.loading){
        this.setState({loading: false})
      }
      this.termsDisplay()
      analyticsClickEvent('user_note_show_model_displayed', '');
      window.$('#userNoteShowModel').modal('show')
    }
  }

  handleMobileOTPFlow = () => {
    this.handleRecaptchaForResendMobile();
          
    setTimeout(() => {
      if(this.state.codeSuccess !== '') {
        this.setState({ codeSuccess: '', codeError: '', codeErrorForResendCode: '', loading: false });
        
        setTimeout(() => {
          this.props.disableChangeMobileOption(true);
          this.props.updateMobileChange(false);
          window.$('#mobileModal').modal('show');              
        }, 800);
      } else if(this.state.codeErrorForResendCode !== '') {
        this.setState((prevState) => {
          return {
            serverErrorMessage: prevState.codeErrorForResendCode,
            loading: false
          }
        })
        window.$('#serverErrorShowModel').modal('show');
        this.props.updateMobileChange(false);
        let fieldValues = {}
        fieldValues['Mobile_Number'] = false;
      }
    }, 2500);
  }

  validateEmailMismatchAndTriggerMobileOTP = () => {
    try {
      const storedEmail = sessionStorage.getItem('UserEmail');
      const enteredEmail = this.state.email;
      if (storedEmail && enteredEmail && storedEmail !== enteredEmail) {
        this.handleMobileOTPFlow();
      } else {
        this.setState({ isMobileOTPVerified: true });
        frontEndLogs('Mobile MFA not needed for the login user', false, 200, 'user/check_validity_of_user_mfa');
        this.checkMfaValidationForUserToEmail();
      }
    } catch (err) {
      console.log("Error", err);
    }
  }

  checkMfaValidationForUserToMobile = async() => {

    const requestPayload = {
      "recipient": this.state.phoneNo,
      "recipientType": "Mobile"
    }

    const responseResult = await mfaValidationCheckForUser(requestPayload)
    this.setState({onBlurInputFiled:false}, async ()=>{
    if(responseResult.status === 406) {
      this.handleMobileOTPFlow();
    } else {
      this.validateEmailMismatchAndTriggerMobileOTP();
      frontEndLogs('Mobile MFA not needed for the login user', false, 200, 'user/check_validity_of_user_mfa');

    }
  });
  }

  checkMfaValidationForUserToEmail = async() => {
    const requestPayload = {
      "recipient": this.state.email,
      "recipientType": "Email"
    }

    const responseResult = await mfaValidationCheckForUser(requestPayload)
    this.setState({onBlurInputFiled:false},async()=>{
    if(responseResult.status === 406) {
      this.handleRecaptchaForResendEmail();

      setTimeout(() => {
        if(this.state.codeSuccess !== '') {
          this.setState({ codeSuccess: '', codeError: '', codeErrorForResendCode: ''});
          this.setState({ loading: false });
            this.props.disableChangeEmailOption(true);
          window.$('#registerModal').modal('show');
        }
        else if(this.state.codeErrorForResendCode !== '') {
          this.setState((prevState) => {
            return {
              loading: false,
              serverErrorMessage: prevState.codeErrorForResendCode,
              popupButtonLabel: '',
              validateStatusCode: '',
              redirectURL: ''
            }
          })
          window.$('#serverErrorShowModel').modal('show');
          this.props.updateEmailChange(true);
          let fieldValue = {}
          fieldValue['Email_Address'] = false;
        }
      }, 5500);
    } else if(responseResult.status === 202) {
      // call to create application API after Email MFA verified
      this.setState({ loading: false });
      await this.createApplicationAfterMFACompleted();
    }
    else {
      this.setState({ isEmailOTPVerified: true})
      frontEndLogs('Email MFA not needed for the login user', false, 200, 'user/check_validity_of_user_mfa');

      this.checkUserIfExistsValidationPointForEmail();
    }
  });
  }

  // call to create application API after Email MFA verified
  createApplicationAfterMFACompleted = async() => {
    this.setState({ isEmailOTPVerified: true})
    frontEndLogs('Email MFA not needed for the login user', false, 200, 'user/check_validity_of_user_mfa');
    let applicationId = await this.getApplicationIDInstorage();
    const allUserData = Object.assign({}, ...this.props.saveApplicationData);
    if(applicationId === null || applicationId === undefined){

      // call createNewApplication for creating an application id 
      const browserCookie = new Cookies();
      this.setState({ loading: true });
      let email = getEmailFromStorage();
      const requestForCreateApplication = {
        "Email_Address": this.state.email ?? allUserData['Email_Address']  ?? email,
        "Humm_Purchase_Source_Url__c": this.state.resultSourceURL ?? null,
        "Retailer_Account__c": this.state.hasPartnerDetails.id ?? browserCookie.get('retailerId') ?? sessionStorage.getItem('storeID') ?? sessionStorage.getItem('RetailerIdFromQuoteTool'),
        "Retailer_Campaign_Code__c": browserCookie.get('retailerReference') ?? null,
        "Humm_Retailer_Link__c":this.setHummRetailerLink()
      }
      if(process.env.REACT_APP_ENABLE_CONFIRM_EMAIL_ADDRESS_FIELD == 'true') {
          requestForCreateApplication['Confirm_Email_Address'] = allUserData['Confirm_Email_Address'] || ''
      }
      browserCookie.remove('applicationId');
      const applicationDetails = await createApplication(requestForCreateApplication);
      await frontEndLogs('Received Application Id - '+applicationDetails.data.data.application_id,false,200, 'createApplicationAfterMFACompleted');
      if(applicationDetails.status == 201 && applicationDetails.data != undefined) {
        sessionStorage.setItem('applicationId', applicationDetails.data.data.application_id);
        browserCookie.set('applicationId',applicationDetails.data.data.application_id)
        // Push the applicationID to the GTM through dataLayer event
        GTMApplicationId();
        window.$('#registerModal').modal('hide')
      }
      else if(handleStatusCode(applicationDetails.status)){
        this.setState({statusCode: applicationDetails?.status,serverErrorMessage: applicationDetails.data.message});
        window.$('#serverErrorShowModel').modal('show');
        return false;
      }

      if(this.state.isUserExists) {    
        this.setState({firstSectionProgressValue: 25, isEmailFieldDisabled: true, isConfirmEmailFieldDisabled: true});
        this.handleScrollOfNextSection();
      }
      else {
          this.setState({loading: false})
          this.termsDisplay()
          analyticsClickEvent('user_note_show_model_displayed', '');
        window.$('#userNoteShowModel').modal('show')
      }
    }else{
      this.checkUserIfExistsValidationPointForEmail();
    }
  }

  // create session for the user from the API call 'user/generate_session'
  createSessionForUser = async(userDataToken) => {
    const requestObject = {
      "Email_Address": this.state.email,
      "First_Name": this.state.firstName,
      "Last_Name": this.state.lastName,
      "Mobile_Number": this.state.phoneNo,
      "Birth_Date": this.state.dateOfBirth,
      "dataToken": userDataToken || ""
    }

    const resultData = await generateSessionForUser(requestObject);

    if(resultData.status ===200) {
      setTokenInStorage(resultData?.data?.data?.access_token);
      setEmailInStorage(resultData?.data?.data?.user_details.email);
      sessionStorage.setItem('UserName',resultData?.data?.data?.user_details.username);
      setSessionIdInStorage(resultData?.data?.data?.session_id);
      setCsrfTokenInStorage(resultData?.data?.data?.csrf_token);
      sessionStorage.setItem('userID',resultData?.data?.data?.user_details.userid);
      GTMUserIdAndLoginState();
      GTMUserId();

      if(!this.state.isUserExists) {
        this.updateMarketingConsent();
      }

      this.hidePopup('#registerModal');
      this.checkApplicantEligiblityForUser();
    }
    else {
      window.$('#registerModal').modal('hide')
      
      setTimeout(() => {
        this.setState({loading: false, validateStatusCode: resultData?.data?.statusCode ?? '',serverErrorMessage: resultData?.data?.message ?? ''});
        window.$('#serverErrorShowModel').modal('show');
      }, 800);
    }
  }

  checkApplicantEligiblityForUser = async() => {

    const obj = {
      "Mobile_Number": sessionStorage.getItem('mobileNumber') ?? this.state.phoneNo,
      isNewAccount: this.state.isNewAccountValue
    }

    this.generatePurchaseRedirectURL();
    this.aboutSectionValueSendInlogs(obj,'checkApplicantEligiblityForUser');
    const ApplicantEligibilityResult = await checkUserApplicationEligibility(obj);
    if(ApplicantEligibilityResult.status == 200 && ApplicantEligibilityResult.data.data.application_id !== ''){
      if (localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') {
        this.setState({ isUserExists: true})
        this.props.removeSavedata([]);
    this.props.showappValidation('');
          await this.loadQuestionsForLoginFlow();
  
          setTimeout( async() => {
            this.props.removeSavedata([]);
            this.props.showappValidation('');
  
            if(this.state.prepopulateFlag) {
              this.PrepopulateHideData();
              return false;
            }
            
            this.props.userDetailsPopulateStatusCall(true);
            await this.userDetailsPopulateForExistingUser();
          }, 3400);
          
            
            return false;
      }
      else {
        this.createNewApplication();
      }
    }
    else if(ApplicantEligibilityResult.status === 409) {
        if(ApplicantEligibilityResult?.data?.data?.hasPreviousApprovedApp===true){
            this.setState({isReturningUser:true,isExistingUser:true,prepopulateFlag:true,loading:false},()=>{
                this.createNewApplication();
            })
        }
        else{
            this.setState({ isReturningUser: true , isExistingUser:true}, () => {
			if (ApplicantEligibilityResult.data.data.continue_with) {
				return this.handlePreviousAppRedirection(ApplicantEligibilityResult.data);
			}
			this.setState({ redirectURL: ApplicantEligibilityResult.data.data.redirectUrl })

			let resultmessage = ApplicantEligibilityResult.data.message;
			resultmessage = this.convertMessage(resultmessage);
			this.setState({ popupButtonLabel: ApplicantEligibilityResult?.data?.data?.buttonLabel ?? "" });

			this.setState({ approvedApplicationMessage: resultmessage, prepopulateFlag: true });
			this.setState({ loading: false });
			window.$('#userBalanceShowModel').modal('show');
		    })
		}
	}
    else if(ApplicantEligibilityResult.status === 400 ) {
      this.setState({ redirectURL: ApplicantEligibilityResult?.data?.data?.redirectUrl ?? '', 
      popupButtonLabel: ApplicantEligibilityResult?.data?.data?.buttonLabel ?? ''});
      let resultMessage = ApplicantEligibilityResult.data.message;
      resultMessage = this.convertMessage(resultMessage);

      this.setState({ serverErrorMessage: resultMessage, validateStatusCode: ApplicantEligibilityResult.status });
      this.setState({ loading: false });
      window.$('#serverErrorShowModel').modal('show');
    }
  }
  
 handlePreviousAppRedirection = async (response) => {
    const { message, data } = response
    this.setState({
      serverErrorMessage: this.convertMessage(message),
      popupButtonLabel: data.buttonLabel || 'Ok',
      redirectURL: data.redirectUrl,
      validateStatusCode: 400,
      loading: false
    })
    sessionStorage.setItem('previousAppId', data.application_id);
    window.$('#serverErrorShowModel').modal('show');
  }

  initiatePreviousAppJourney = async (searchParams, mitek_token) => {

    const applicationID = sessionStorage.getItem('previousAppId');
    const sessionId = searchParams.get("sessionId");

    if (!sessionId) return;
    setSessionIdInStorage(sessionId);
    
    if (applicationID) {
      sessionStorage.setItem('application_id', applicationID);
      sessionStorage.setItem('applicationId', applicationID);
    }

    if (mitek_token) {
      await this.setupPreviousAppJourney()
      this.qrRef?.current?.callevent();
      this.setState({
        loading: false,
        showMitekConsent: true,
        isMitekProcessReached: true,
        privacyPolicyCheck: true,
      });
    }
    else {
      this.setState({ loading: true })
      await this.handleWarningOBResponse();
      this.setupPreviousAppJourney()
    }
  };

  setupPreviousAppJourney = async () => {
    const fetchAccount = await getBrokerUserDetails(sessionStorage.getItem('application_id')).then(res => res.data);
    if (fetchAccount) {
      this.setState({ phoneNo: fetchAccount.data.mobile, email: fetchAccount.data.email });
      sessionStorage.setItem('userID', fetchAccount.data.userId)
      sessionStorage.setItem('mobileNumber', fetchAccount.data.mobile);
      setEmailInStorage(fetchAccount.data.email);
      setSessionIdInStorage(fetchAccount.data.sessionId);
    }

    const consentStatus = await getConsentStatus(sessionStorage.getItem('application_id')).then(res => res.data);
    if (consentStatus.statusCode === 200) {
      frontEndLogs('Agree consent checkbox clicked, Consent and Continue Button enabled', false, 200, 'getConsentStatus', consentStatus);
      analyticsClickEvent('agree_consent_checkbox_clicked', '')
      this.setState({
        isBioConsentShown: consentStatus.data.isBioConsentShown,
        disableApplicationConsentButton: !consentStatus.data.isBioConsentShown,
      });
      if (consentStatus.data.isBioConsentShown) {
        this.setState({ showQRCode: true, applicationConsentSrc: 'images/checked.svg' });
      }
    }
  }

  updateMarketingConsent = async() =>{
    let email = getEmailFromStorage();
    const obj = {
      email: email,
      email_marketing_consent: sessionStorage.getItem('emailConsent'),
      sms_marketing_consent: sessionStorage.getItem('smsConsent'),
      mobile_app_marketing_consent: sessionStorage.getItem('mobileConsent'),
      application_marketing_consent: sessionStorage.getItem('applicationConsent'),
      Application_Channel: "Web",
    }

    let marketingConsetResult = await sendMarketingConstent(obj);
    sessionStorage.setItem('smsConsent', marketingConsetResult.data.data.sms_marketing_consent);
    sessionStorage.setItem('emailConsent', marketingConsetResult.data.data.email_marketing_consent);
    sessionStorage.setItem('mobileConsent', marketingConsetResult.data.data.mobile_app_marketing_consent);
    sessionStorage.setItem('applicationConsent', marketingConsetResult.data.data.application_marketing_consent);
  }

  onKeyPressData = (event) => {
    let eventValue = event.target.value
    if (!/\d/.test(event.key)) {
        event.preventDefault();
    }

    if (this.state.code !== '') {
      this.setState({ otpErrorMessage: '' });
    } else {
      this.setState({ otpErrorMessage: eventValue });
      this.setState({ otpErrorMessage: 'Verification code is required.' });
      return false;
    }
  }

  /*  Handle fields change */
  handleChange = input => e => {
    this.setState({ [input]: e.target.value });
  };

  onLoad = () => {
    this.setState({
      captchaReady: true
    });

  };

  onVerify = (getToken) => {
      // If the reCaptcha is loaded and token is generated, save the token to the state reCaptchaToken
      if(getToken != null && getToken !== '' && this.state.captchaReady){
          this.setState({verified: true})
          this.setState({reCaptchaToken: getToken}, async () => {
              if(this.state.userDetailsFlag){
                  await this.handleUserDetails(this.state.userDetails);
              }

              if(this.state.mobileVerifyFlag){
                  await this.redirectCodeScreenMobile(getToken);
              }

              if(this.state.emailVerifyFlag){
                await this.redirectCodeScreenEmail(getToken);
              }
              await this.onVerifyReCaptcha();
          });

      }
      else {
          this.setState({verified: false})
      }

  }

  firstSectionValidationDuringScroll = (firstSectionValidFields, firstSectionValidation, allUserData) => {
    if(this.state.globalProgressBarValue<=25 && firstSectionValidFields < 6) {      
      this.setState({ firstSectionProgressValue: 0})
    }
    else if(firstSectionValidation['Mobile_Number'] === false) {
      this.setState({ firstSectionProgressValue: 0})
    }
    else if(this.state.firstSectionProgressValue === 25 && this.state.isMobileOTPVerified) {
        return false;
    }
    else if(firstSectionValidFields === 6 && !this.state.isMobileOTPVerified && !window.$('#mobileModal').hasClass('show')) {  
      this.setState({onBlurInputFiled:true},()=> {
        this.changeProgressBarValueForFirstSection(allUserData);
        const mobileInputElement = document.getElementById('Mobile_Number');
        mobileInputElement.style.border = "none";
        const emailInputElement = document.getElementById('Email_Address');
        emailInputElement.style.border = "none";
      })      
    } else {
      return false;
    }
  }

  fourthSectionValidationDuringScroll = (fourSectionValidFields, allUserData) => {

    if(this.state.fourSectionProgressValue === 100) {
      let applicationData = Object.assign({}, ...this.props.saveApplicationData);
      GTMValidStepsSubmit('Income & Expenses','Client','4','4','4:4');
      console.log("Validation If condition");
      if((applicationData['Current_Residential_Status__c'] === "Homeowner - mortgaged" || applicationData['Current_Residential_Status__c'] === "Tenant/Boarding") && (!applicationData.hasOwnProperty('Fractional_Residential_Expense__c') || applicationData['Fractional_Residential_Expense__c'] === '')) {

        let stages = {};
        let mortageStagesValues={}      
        mortageStagesValues['Fractional_Residential_Expense__c'] = '';
        stages['Fractional_Residential_Expense__c'] = 'This is Required';
        stages['stage'] = this.props.stage;
        this.props.saveApplicationDatas(mortageStagesValues);
        this.props.appvalidations(stages);
        let fieldValues = {}
        fieldValues['Fractional_Residential_Expense__c'] = false;
        this.props.firstSectionValidationUpdate(fieldValues)
        return;      
      }
      return false;
    }
    else if((allUserData['Current_Residential_Status__c'] === 'Homeowner - no mortgage' 
    || allUserData['Current_Residential_Status__c'] === 'Living with parents/family') && 
    (allUserData['Employment_Stability__c'] == 'Student'
    || allUserData['Employment_Stability__c'] == 'Unemployed' || 
    allUserData['Employment_Stability__c'] == 'Retired') && fourSectionValidFields == 6) {
      this.validationForFourthSection(allUserData);
    }
    else if((allUserData['Current_Residential_Status__c'] === 'Homeowner - no mortgage' 
    || allUserData['Current_Residential_Status__c'] === 'Living with parents/family') && fourSectionValidFields == 7) {
      this.validationForFourthSection(allUserData);
    }
    else if((allUserData['Employment_Stability__c'] == 'Student'
      || allUserData['Employment_Stability__c'] == 'Unemployed' || 
      allUserData['Employment_Stability__c'] == 'Retired') && fourSectionValidFields == 6){
        this.validationForFourthSection(allUserData);
      }
      else if(fourSectionValidFields == 7){
        this.validationForFourthSection(allUserData);
      }else{
        console.log("else",fourSectionValidFields);
      }
  }

  checkSecondSelectionValidation = (secondSectionValidation,allUserData) => {
    if(secondSectionValidation !== this.state.secondSectionProgressValue){
      const secondSectionValidFields = this.validationCheckForEachSection(secondSectionValidation);

      setTimeout(() => {
        this.changeProgressBarValueForSecondSection(secondSectionValidFields,allUserData);

      }, 200);
    }
  }

  getFlatHouseFieldValidation = (allUserData) => {
    let flatNumberLimit = 0, houseNumberLimit = 0, houseNameLimit = 0, addressLine1Limit = 0, townLimit = 0, postalCodeLimit = 0;
    let previousAddressLine1Limit = 0, previousTownLimit = 0, previousPostalCodeLimit = 0,previousFlatNumberLimit = 0, previousHouseNumberLimit = 0, previousHouseNameLimit = 0, previousAddressLine2Limit = 0;

    if (this.state.thirdSection && Array.isArray(this.state.thirdSection)) {
      this.state.thirdSection.forEach((src) => {
        src.Questions.forEach((eachQuestion) => {
          if (['Current_Flat_No__c', 'HouseNumber__c', 'Current_House_Name__c', 'Address_Line1__c', 'Town__c', 'Postal_Code__c', 'Previous_Address_Line1__c', 'Previous_Town__c', 'Previous_Postal_Code__c', 'Previous_Flat_No__c', 'Previous_HouseNumber__c', 'Previous_House_Name__c', 'Previous_Address_Line2__c'].includes(eachQuestion.flxFieldApiName__c) && (eachQuestion.validations && Array.isArray(eachQuestion.validations))) {
              eachQuestion.validations.forEach((validation) => {
                const value = Number.parseInt(validation.flxMax_Value__c, 10) || 0;
                switch (eachQuestion.flxFieldApiName__c) {
                  case 'Current_Flat_No__c':
                    flatNumberLimit = value;
                    break;
                  case 'HouseNumber__c':
                    houseNumberLimit = value;
                    break;
                  case 'Current_House_Name__c':
                    houseNameLimit = value;
                    break;
                  case 'Address_Line1__c':
                    addressLine1Limit = value;
                    break;
                  case 'Town__c':
                    townLimit = value;
                    break;
                  case 'Postal_Code__c':
                    postalCodeLimit = value;
                    break;
                  case 'Previous_Address_Line1__c':
                    previousAddressLine1Limit = value;
                    break;
                  case 'Previous_Town__c':
                    previousTownLimit = value;
                    break;
                  case 'Previous_Postal_Code__c':
                    previousPostalCodeLimit = value;
                    break;
                  case 'Previous_Flat_No__c':
                    previousFlatNumberLimit = value;
                    break;
                  case 'Previous_HouseNumber__c':
                    previousHouseNumberLimit = value;
                    break;
                  case 'Previous_House_Name__c':
                    previousHouseNameLimit = value;
                    break;
                  case 'Previous_Address_Line2__c':
                    previousAddressLine2Limit = value;
                    break;
                }
              });
            }
         });
      });
    }

    const flatAbode = allUserData['Current_Flat_No__c'] || '';
    const houseName = allUserData['Current_House_Name__c'] || '';
    const houseNumber = allUserData['HouseNumber__c'] || '';
    const addressLine1 = allUserData['Address_Line1__c'] || '';
    const town = allUserData['Town__c'] || '';
    const postalCode = allUserData['Postal_Code__c'] || '';
    const previousAddressLine1 = allUserData['Previous_Address_Line1__c'] || '';
    const previousTown = allUserData['Previous_Town__c'] || '';
    const previousPostalCode = allUserData['Previous_Postal_Code__c'] || '';
    const previousFlatNumber = allUserData['Previous_Flat_No__c'] || '';
    const previousHouseNumber = allUserData['Previous_HouseNumber__c'] || '';
    const previousHouseName = allUserData['Previous_House_Name__c'] || '';
    const previousAddressLine2 = allUserData['Previous_Address_Line2__c'] || '';
    return {
      isFlatAbodeValid: flatAbode.trim() === '' || flatNumberLimit === 0 || flatAbode.length <= flatNumberLimit,
      isHouseNameValid: houseName.trim() === '' || houseNameLimit === 0 || houseName.length <= houseNameLimit,
      isHouseNumberValid: houseNumber.trim() === '' || houseNumberLimit === 0 || houseNumber.length <= houseNumberLimit,
      isAddressLine1Valid: addressLine1.length <= addressLine1Limit,
      isTownValid: town.length <= townLimit,
      isPostalCodeValid: postalCode.length <= postalCodeLimit,
      isPreviousAddressLine1Valid: previousAddressLine1.length <= previousAddressLine1Limit,
      isPreviousTownValid: previousTown.length <= previousTownLimit,
      isPreviousPostalCodeValid: previousPostalCode.length <= previousPostalCodeLimit,
      isPreviousFlatNumberValid: previousFlatNumber.trim() === '' || previousFlatNumberLimit === 0 || previousFlatNumber.length <= previousFlatNumberLimit,
      isPreviousHouseNumberValid: previousHouseNumber.trim() === '' || previousHouseNumberLimit === 0 || previousHouseNumber.length <= previousHouseNumberLimit,
      isPreviousHouseNameValid: previousHouseName.trim() === '' || previousHouseNameLimit === 0 || previousHouseName.length <= previousHouseNameLimit,
      isPreviousAddressLine2Valid: previousAddressLine2.trim() === '' || previousAddressLine2Limit === 0 || previousAddressLine2.length <= previousAddressLine2Limit,
      flatNumberLimit,
      houseNameLimit,
      houseNumberLimit,
    };
  };

  setAddressConfirmed=()=>{
    this.setState({isAddressConfirmed:true})
  }

  componentWillReceiveProps =  (nextProps) => {
    const allUserData = Object.assign({}, ...nextProps.saveApplicationData);
    const secondSectionValidation = Object.assign({}, ...nextProps.secondSectionSteps);
    this.checkSecondSelectionValidation(secondSectionValidation,allUserData);
    if(allUserData['Mobile_Number']){
      this.setState({phoneNo: allUserData['Mobile_Number']});
    }
    if(allUserData['Email_Address']){
      this.setState({email: allUserData['Email_Address']});
    }

    const firstSectionValidation = Object.assign({}, ...nextProps.firstSectionSteps);
    const firstSectionValidFields = this.validationCheckForEachSection(firstSectionValidation); 
    this.checkNextPropsValidation(nextProps,firstSectionValidFields,firstSectionValidation,allUserData);
	if(nextProps.thirdSectionSteps===this.state.thirdSectionProgressValue){return}
	const { isFlatAbodeValid, isHouseNameValid, isHouseNumberValid, isAddressLine1Valid, isTownValid, isPostalCodeValid, isPreviousAddressLine1Valid, isPreviousTownValid, isPreviousPostalCodeValid, isPreviousFlatNumberValid, isPreviousHouseNumberValid, isPreviousHouseNameValid, isPreviousAddressLine2Valid } = this.getFlatHouseFieldValidation(allUserData);
	const DurationOfResidence= allUserData['Duration_of_Residence__c'];
    const isDurationOfResidenceValid=DurationOfResidence !=='' && DurationOfResidence !== undefined;
    const previousAddress = DurationOfResidence === 'Less than 3 years';
    
    const isPreviousAddressMandatory= previousAddress?(
    (allUserData['Previous_Address_Line1__c'] !== '' && allUserData['Previous_Address_Line1__c'] !== undefined)&&
    (allUserData['Previous_Town__c'] !== '' && allUserData['Previous_Town__c'] !== undefined) &&
    (allUserData['Previous_Postal_Code__c'] !== '' && allUserData['Previous_Postal_Code__c'] !== undefined) &&
    isPreviousAddressLine1Valid && isPreviousTownValid && isPreviousPostalCodeValid &&
    isPreviousFlatNumberValid && isPreviousHouseNumberValid && isPreviousHouseNameValid && isPreviousAddressLine2Valid) : true;
    const isCurrentAddressValid = allUserData['Address_Line1__c'] && allUserData['Town__c'] && allUserData['Postal_Code__c'] && allUserData['Address_Line1__c'].trim() !== '' && allUserData['Town__c'].trim() !== '' && allUserData['Postal_Code__c'].trim() !== '';

	const isBasicAddressValid = (isFlatAbodeValid && isHouseNameValid && isHouseNumberValid && isAddressLine1Valid && isTownValid && isPostalCodeValid);
    const validateThirdSection = isBasicAddressValid && allUserData['Current_Residential_Status__c'] !== undefined && isDurationOfResidenceValid && isPreviousAddressMandatory && isCurrentAddressValid;
    
    let thirdSectionValidFields;
    const expectedThirdStepValidation= previousAddress ? 8 : 5;
    if (validateThirdSection) {
        const thirdSectionValidation = Object.assign({}, ...nextProps.thirdSectionSteps);
        thirdSectionValidFields = this.validationCheckForEachSection(thirdSectionValidation);
    }

    setTimeout(() => {
        if(this.state.thirdSectionProgressValue === 75) {
          return false;
        }
        else if(thirdSectionValidFields === expectedThirdStepValidation){
      		this.setState({loading: true, thirdSectionProgressValue: 75, showProgressValue: false}, () => {
            
            setTimeout(() => {
              const span = document.getElementById("four-section");
              span.scrollIntoView({ behavior: 'smooth' });

              this.validationforPrepopulatedOfFourthSection();
            },2000);

            this.handleScrollOfFourSection();
          });
        }
      }, 800);
    

    if(nextProps.fourSectionSteps !== this.state.fourSectionProgressValue) {
      let fourSectionValidation = Object.assign({}, ...nextProps.fourSectionSteps);
      let fourSectionValidFields = 0;
      fourSectionValidation['Total_Monthly_Expenses__c'] = false
        fourSectionValidFields = this.validationCheckForEachSection(fourSectionValidation);
        console.log("fourSectionValidFields before",fourSectionValidFields);
      if(fourSectionValidFields>=6){
      const newValue = Date.now();
        this.setState({ finalinputValue: newValue });
        // Clear the previous timer, if any
      clearTimeout(this.timer);
      // Set a new timer to check for changes after 3 seconds
      this.timer = setTimeout(() => {
        // Check if the input value hasn't changed for 3 seconds
        if (this.state.finalinputValue == newValue) {
          console.log('No change for the last 3 seconds before final:', newValue);
          fourSectionValidation['Total_Monthly_Expenses__c'] = false
        fourSectionValidFields = this.validationCheckForEachSection(fourSectionValidation);
        console.log("fourSectionValidFields new",fourSectionValidFields);
        this.fourthSectionValidationDuringScroll(fourSectionValidFields, allUserData);
        }
      }, 2000);
    } 
    }

    setTimeout(() => {
    this.validationOfProgressBarAllSections(allUserData);
    this.validateFormProgress();
    }, 200);
  }

  checkNextPropsValidation = (nextProps,firstSectionValidFields,firstSectionValidation,allUserData) => {    
    if((nextProps.firstSectionSteps !== this.state.firstSectionProgressValue) || firstSectionValidFields<6) {      

      //28092023

      const newValue = Date.now();
      this.setState({ inputValue: newValue });
      // Clear the previous timer, if any
    clearTimeout(this.timer);
    // Set a new timer to check for changes after 3 seconds
    this.timer = setTimeout(() => {
      // Check if the input value hasn't changed for 3 seconds
      if (this.state.inputValue == newValue) {
        console.log('No change for the last 3 seconds:', newValue);
        this.firstSectionValidationDuringScroll(firstSectionValidFields, firstSectionValidation, allUserData)
      }
    }, 3000);
    
    
  }
  }

  validateEmailAddressCheck =  () => {
    //Disable interval pop-up display function to avoid multiple looping
  }

  checkEmailAddress = () => {
    const allUserValidation = Object.assign({}, ...this.props.applicationValidation);
    const allUserData = Object.assign({}, ...this.props.saveApplicationData);

    if(this.props.isChangeEmail && allUserData['Email_Address'] !== undefined) {
      if(allUserValidation['Email_Address'] === '') {
        const mobileInputElement = document.getElementById('Email_Address');
        mobileInputElement.style.border = "none";
        if(!this.state.isEmailOTPVerified || process.env.REACT_APP_ENABLE_EMAIL_OTP_VERIFICATION == 'true') {
          this.handleRecaptchaForResendEmail();
          
          setTimeout(() => {
            this.setState({ loading: false });
            if(this.state.codeSuccess !== '') {
              this.setState({ email: allUserData['Email_Address'], codeSuccess: '', codeError: '', codeErrorForResendCode: '', loading: false });
              
                this.props.updateEmailChange(false);
                window.$('#registerModal').modal('show');              
            }
            else if(this.state.codeErrorForResendCode !== '') {
              this.setState(prevState => ({ serverErrorMessage: prevState.codeErrorForResendCode, loading: false }));
              window.$('#serverErrorShowModel').modal('show');
              this.props.updateEmailChange(true);
              let fieldValues = {}
              fieldValues['Email_Address'] = false;
            }
          }, 3500)
        }
      }
    }
  }

  submitSectionDetails = async (sectionHeading) => {
    const allUserData = Object.assign({}, ...this.props.saveApplicationData);
    allUserData.flxHeader__c=sectionHeading;
    
    Object.keys(allUserData).forEach(key => {
      if (allUserData[key] === null || allUserData[key]=="") {
        delete allUserData[key];
      }
    });
    this.setState({onBlurInputFiled:false},async ()=>{
      this.aboutSectionValueSendInlogs(allUserData,'submitSectionDetails');
      await insertApplicationUserDetails(allUserData);
    })
  }


  handleSendOtpForMobile = () => {

    const allUserDataDetails = Object.assign({}, ...this.props.saveApplicationData);
    if(allUserDataDetails['Mobile_Number'] != undefined){
      this.setState({phoneNo: allUserDataDetails['Mobile_Number']});
    }
    this.handleRecaptchaForResendMobile();
          
    setTimeout(() => {
      if(this.state.codeSuccess !== '') {
        this.setState({ codeSuccess: '', codeError: '', codeErrorForResendCode: '', loading: false });
        
        setTimeout(() => {
          this.props.updateMobileChange(false);
          analyticsClickEvent('mobile_verification_popup_displayed', '');
          window.$('#mobileModal').modal('show');              
        }, 800);
      }
      else if(this.state.codeErrorForResendCode !== '') {
        this.setState(prevState => ({ serverErrorMessage: prevState.codeErrorForResendCode, loading: false }));
        window.$('#serverErrorShowModel').modal('show');
        this.props.updateMobileChange(false);
        let fieldValues = {}
        fieldValues['Mobile_Number'] = false;
      }
    }, 2500);
  }

  validateFlagOfMobileAndDateOfBirth = () => {

    if(!this.props.birthDateFlag && !this.props.mobileNumberFlag) {
      if(this.props.prepopulateStatus) {
        this.checkMfaValidationForUserToMobile();
      }
      else {
        this.handleSendOtpForMobile();
      }

    }
    else if(!this.props.birthDateFlag) { 
      this.checkIfUserExistsAfterMobileVerify()
    }
    else if(!this.props.mobileNumberFlag){
      this.handleSendOtpForMobile();
    }
    else if(this.props.birthDateFlag && this.props.mobileNumberFlag) {
      this.checkMfaValidationForUserToMobile();
    }
  }

  checkSectionValidation = (firstSectionValidFields,isFirstStepValidated,applicationValidation,isSecondStepValidated,secondSectionValidFields,thirdSectionValidFields,isThirdStepValidated) => {
    const allUserDatas = Object.assign({}, ...this.props.saveApplicationData);
    const durationValue = (allUserDatas['Duration_of_Residence__c'] || '').trim();
	const duration=durationValue==='Less than 3 years';
    const thirdStepValidation = duration ? 8 : 5;

	if(!durationValue){return false};

    // Check the validation results for each section and handle accordingly   
    if (firstSectionValidFields !== 6 || isFirstStepValidated !== 6) {
      // If the first section validation fails, log a message, scroll to the first section, and set 'applicationValidation' to false
      console.log("First step validation failed");
      return false;
    } else if (isSecondStepValidated !== 2 || secondSectionValidFields !== 2) {
      // If the second section validation fails, log a message, scroll to the next section, and set 'applicationValidation' to false
      console.log("Second step validation failed");
      return false;
    } else if (thirdSectionValidFields < thirdStepValidation || isThirdStepValidated < thirdStepValidation) {
      // If the third section validation fails, log a message, scroll to the third section, and set 'applicationValidation' to false
      console.log("Third step validation failed");
      return false;
    } else if (duration) {
      const requiredPreviousAddressField = ['Previous_Address_Line1__c', 'Previous_Town__c', 'Previous_Postal_Code__c'];
      const hasMissingPreviousAddressField = requiredPreviousAddressField.some(field => !allUserDatas[field] || allUserDatas[field].trim() === '');
      if (hasMissingPreviousAddressField) { return false; }
    }

    // Validate flat/house fields with proper empty value handling
    const flatHouseValidation = this.getFlatHouseFieldValidation(allUserDatas);
    const { isFlatAbodeValid, isHouseNameValid, isHouseNumberValid, isAddressLine1Valid, isTownValid, isPostalCodeValid, isPreviousAddressLine1Valid, isPreviousTownValid, isPreviousPostalCodeValid, isPreviousFlatNumberValid, isPreviousHouseNumberValid, isPreviousHouseNameValid, isPreviousAddressLine2Valid } = flatHouseValidation;
    
    if (!isFlatAbodeValid || !isHouseNameValid || !isHouseNumberValid || !isAddressLine1Valid || !isTownValid || 
        !isPostalCodeValid || allUserDatas['Address_Line1__c'] == '' || allUserDatas['Postal_Code__c'] == '' || allUserDatas['Town__c'] == '' ) {
        return false;
    }

    if(duration){
    const isValid = this.checkPreviousAddressValidity({allUserDatas, isPreviousAddressLine1Valid, isPreviousTownValid, isPreviousPostalCodeValid, isPreviousFlatNumberValid, isPreviousHouseNumberValid, isPreviousHouseNameValid, isPreviousAddressLine2Valid });
      
    if (!isValid) {
        return false;
      }
    }

    // Email match validation
    if(allUserDatas['Email_Address'].trim().toLowerCase() !== allUserDatas['Confirm_Email_Address'].trim().toLowerCase()) {
      return false;
    }

    const validationData = Object.assign({}, ...this.props.applicationValidation);
    const hasValidationData = validationData['Previous_Address__C'] && validationData['Previous_Address__C'] !== '';

    if (hasValidationData) {
      return false;
    }
    
    return applicationValidation;
  }

  checkPreviousAddressValidity({
  allUserDatas,
  isPreviousAddressLine1Valid,
  isPreviousTownValid,
  isPreviousPostalCodeValid,
  isPreviousFlatNumberValid,
  isPreviousHouseNumberValid,
  isPreviousHouseNameValid,
  isPreviousAddressLine2Valid
}) {
  if (!isPreviousAddressLine1Valid || !isPreviousTownValid || !isPreviousPostalCodeValid || 
      allUserDatas['Previous_Address_Line1__c'] == '' || allUserDatas['Previous_Town__c'] == '' || allUserDatas['Previous_Postal_Code__c'] == '') {        
    return false;
  }
  if (!isPreviousFlatNumberValid || !isPreviousHouseNumberValid || !isPreviousHouseNameValid || !isPreviousAddressLine2Valid) {
    return false;
  }
  return true;
}

validationForFourthSection = async (allUserData) => {

  if(!this.state.submitSectionFlag) {
    this.setState({ submitSectionFlag: true});
    this.submitSectionDetails("Income & Expenses");
    }
      
      // Initialize a flag for overall application validation
let applicationValidation = true;

// Create an object 'firstSectionField' by combining properties from 'firstSectionSteps' using Object.assign
const firstSectionField = Object.assign({}, ...this.props.firstSectionSteps);

// Perform validation for the first section and await the result
const isFirstStepValidated = this.validationForEachStep(firstSectionField);

// Create an object 'secondSectionField' for the second section
const secondSectionField = Object.assign({}, ...this.props.secondSectionSteps);

// Perform validation for the second section and await the result
const isSecondStepValidated = this.validationForEachStep(secondSectionField);

// Create an object 'thirdSectionField' for the third section
const thirdSectionField = Object.assign({}, ...this.props.thirdSectionSteps);

// Perform validation for the third section and await the result
const isThirdStepValidated = this.validationForEachStep(thirdSectionField);

// Calculate the number of valid fields in each section using 'validationCheckForEachSection'
const firstSectionValidFields = this.validationCheckForEachSection(firstSectionField);
const secondSectionValidFields = this.validationCheckForEachSection(secondSectionField);
const thirdSectionValidFields = this.validationCheckForEachSection(thirdSectionField);

const validationData = Object.assign({}, ...this.props.applicationValidation);
console.log(validationData,"validationData");

// Filter the object to include only non-empty values for specified properties
const filteredData = [];

// Specify the properties you want to skip
const propertiesToNotCheck = ["stage", "frequency", "flx_DocumentAgree__c", "flx_Contact_Humm_agree__c", "flx_Agree__c"];


// Loop through validationData to filter relevant fields
Object.keys(validationData).forEach(key => {
  if (propertiesToNotCheck.indexOf(key) !== -1) {
    console.log("skip validation",key);
  }else if(validationData[key] !=""){
    let fieldIndex=this.getLabelName(key);
    if(fieldIndex !== ''){
      filteredData.push(fieldIndex);
    }
  }
});

if(allUserData['Email_Address'].trim().toLowerCase() !== allUserData['Confirm_Email_Address'].trim().toLowerCase()) {
    filteredData.push('Email does not match');
}
    const allUserDatas = Object.assign({}, ...this.props.saveApplicationData);

    if (validationData['Previous_Address__C'] && validationData['Previous_Address__C'] !== '') {
      filteredData.push(validationData['Previous_Address__C']);
      applicationValidation = false;
    }

    const validations = [
      { key: 'Previous_Address_Line1__c', label: 'Previous Street' },
      { key: 'Previous_Town__c', label: 'Previous Town/City' },
      { key: 'Previous_Postal_Code__c', label: 'Previous Postcode' }
    ];
    const durationValue = (allUserDatas['Duration_of_Residence__c'] || '').trim();
    const duration = durationValue === 'Less than 3 years';

    if (duration && !validationData['Previous_Address_Line1__c'] && !validationData['Previous_Town__c'] && !validationData['Previous_Postal_Code__c']) {
      validations.forEach(({ key, label }) => {
        if (!allUserData[key]) {
          filteredData.push(label);
          applicationValidation = false;
        }
      });
    }

  
if (this.state.thirdSection && Array.isArray(this.state.thirdSection)) {
  this.state.thirdSection.forEach((src) => {
    src.Questions.forEach((eachQuestion) => {
      const fieldName = eachQuestion.flxFieldApiName__c;
      const inputValue = allUserData[fieldName] || '';

      if (['Current_Flat_No__c', 'HouseNumber__c', 'Current_House_Name__c','Previous_Flat_No__c','Previous_HouseNumber__c','Previous_House_Name__c'].includes(fieldName) && (eachQuestion.validations && Array.isArray(eachQuestion.validations))) {
          eachQuestion.validations.forEach((validation) => {
            const maxLength = Number.parseInt(validation.flxMax_Value__c, 10) || 0;
            const errorMessage = validation.flxError_Message__c;
            if (inputValue.length > maxLength && errorMessage) {
              filteredData.push(errorMessage);
            }
          });
        }
     });
  });
    }    
    
    if (allUserDatas['Current_Address_Country__c'] && allUserDatas['Previous_Address__C'] && allUserDatas['Current_Address_Country__c'] == allUserDatas['Previous_Address__C']) {
      filteredData.push('Previous address cannot be same as Current address');
      applicationValidation = false;
    }

// Now update state once with the full validation result
this.setState({ failedfieldValidationCollection: filteredData });

// Check the validation results for each section and handle accordingly
applicationValidation = this.checkSectionValidation(firstSectionValidFields,isFirstStepValidated,applicationValidation,isSecondStepValidated,secondSectionValidFields,thirdSectionValidFields,isThirdStepValidated);

// If the 'applicationValidation' flag is true, then all sections are validated successfully

    if(applicationValidation){    
    this.setState({ isEmailFieldDisabled: true, isConfirmEmailFieldDisabled: true });
    setTimeout(() => {

        this.setState({fourSectionProgressValue: 100, globalProgressBarValue: 100,progressBarImageSrc: "images/bird-shadow--logo.svg", progessBarLogoStyle: 'img-sizing-svg'}, () => {
          setTimeout(() => {
            this.setState({loading: true})
          }, 200);
        });

        setTimeout(() => {
          this.setState({loading: false})
          this.props.saveIncomeDataValue(allUserData['Total_Monthly_Income__c']);
          this.setState({
            userTotalExpenditure: allUserData['Total_Expenditure__c'],
            userLoanTerm: allUserData['Loan_Term_Requested__c'],
           })
           this.checkIfEmailOTPVerified();
        }, 400);
      
    }, 1800);
  }else{
    window.$('#finalValidationModal').modal('show');
  }
  }

  disableEmailOTPVerificationMethod = async() => {
    if (localStorage.getItem('fromWhere') == 'apply_now' || sessionStorage.getItem('fromWhere') == 'apply_now') {
      await this.checkIfUserExistsAfterMobileVerify();
      this.hidePopup('#registerModal');
      await this.createSessionForUser();      
    } else {
      this.termsDisplay()
      analyticsClickEvent('user_note_show_model_displayed', '');
      window.$('#userNoteShowModel').modal('show')
    }
  }

  loaderDelayWait = async(ms) => {
    await new Promise(resolve => setTimeout(resolve, ms));
  }

  checkIfEmailOTPVerified = async() => {
    if(this.state.isMobileOTPVerified) {
      if(process.env.REACT_APP_ENABLE_EMAIL_OTP_VERIFICATION == 'false') {
        if(this.state.isUserExists) {
          this.termsDisplay()
          analyticsClickEvent('user_note_show_model_displayed', '');
          window.$('#userNoteShowModel').modal('show')
        } else {
          await this.disableEmailOTPVerificationMethod();
          await this.loaderDelayWait(1100);
          this.termsDisplay()
          analyticsClickEvent('user_note_show_model_displayed', '');
          window.$('#userNoteShowModel').modal('show');
        }
      } else if(this.state.isEmailOTPVerified) {
        this.termsDisplay()
        analyticsClickEvent('user_note_show_model_displayed', '');
        window.$('#userNoteShowModel').modal('show')
      }
      else {
        this.handleRecaptchaForResendEmail();
        setTimeout(() => {
          if(this.state.codeSuccess !== '') {
            this.setState({ codeSuccess: '', codeError: '', codeErrorForResendCode: ''});
            this.setState({ loading: false });
            window.$('#registerModal').modal('show');
          }
          else if(this.state.codeErrorForResendCode !== '') {
            this.setState((prevState) => {
              return {
                validateStatusCode: '',
                popupButtonLabel: '',
                redirectURL: '',
                serverErrorMessage: prevState.codeErrorForResendCode,
                loading: false
              }
            })
            window.$('#serverErrorShowModel').modal('show');
            this.props.updateEmailChange(true);
            let fieldValues = {}
            fieldValues['Email_Address'] = false;
          }
        }, 2500);
      }
    }
  }

  changeProgressBarValueForFirstSection = (allUserData) => {
    this.setState({
      disableMobileNumberField: true, firstSectionProgressValue: 25, firstName: allUserData['First_Name'], lastName: allUserData['Last_Name'], dateOfBirth: allUserData['Birth_Date'], phoneNo: allUserData['Mobile_Number'], email: allUserData['Email_Address'], confirmEmailAddress: allUserData['Confirm_Email_Address']
    }, async () => {
      if(!window.$('#mobileModal').hasClass('show')) {
        this.setState({ loading: true });
      }
      setTimeout(() => {
        const firstSectionValidateAllField = Object.assign({}, ...this.props.firstSectionSteps);
        const firstSectionValidAllFields = this.validationCheckForEachSection(firstSectionValidateAllField);
        if (firstSectionValidAllFields === 6) {
          setEmailInStorage(allUserData['Email_Address']);
          this.submitSectionDetails("Personal Details");
          if (this.state.firstSectionProgressValue === 25) {

            if(allUserData['Email_Address'].trim().toLowerCase() !== allUserData['Confirm_Email_Address'].trim().toLowerCase()) {
              let stages = {};
              let fieldValues = {};
              let confirmEmailAddressStagesValues={}
              stages['Confirm_Email_Address'] = 'Email does not match';
              stages['stage'] = this.props.stage;                    
              fieldValues['Confirm_Email_Address'] = false;
              this.props.appvalidations(stages);
              this.props.saveApplicationDatas(confirmEmailAddressStagesValues);
              this.props.firstSectionValidationUpdate(fieldValues)
              this.setState({loading: false, firstSectionProgressValue: 0});
              return false;
          }

            if (localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') {

              this.validateFlagOfMobileAndDateOfBirth();
              return false;
            }

            if (!this.state.isMobileOTPVerified) {
              this.handleSendOtpForMobile();
            }
            else {
              console.log("Mobile number already verified");
              this.loaderDelayWait(3000);
              this.handleScrollOfNextSection();
            }
          }
        } else {
          this.setState({ loading: false })
        }
      }, 2000);


    });
  }

  changeProgressBarValueForSecondSection = (secondSectionValidFields,allUserData) => {
    if(allUserData['Email_Address']){

      setEmailInStorage(allUserData['Email_Address']);

    }
    
    if(this.state.secondSectionProgressValue === 50) {
      return false;
    }
    else if(secondSectionValidFields === this.state.sectionTwoLength){
      this.setState({secondSectionProgressValue: 50}, () => {

      setTimeout(() => {
        const span = document.getElementById("third-section");
        span.scrollIntoView({ behavior: 'smooth' });
      },2000);

        this.submitSectionDetails("Loan Details");
        this.handleScrollOfThirdSection();
      });
    }
  }

  onVerifyReCaptcha = async() => {
    if(this.state.resendEmailFlag){
      await this.resendCodeForEmail();
    }
    if(this.state.resendMobileFlag){
      await this.resendCodeForMobile();
    }
    if(this.state.loggedUserApplyNowFlag){
      await this.getUserValidated();
    }
  }


  // To check whether the validation of input field on each section is true or false
  validationCheckForEachSection = (sectionFieldValue) => {
    
    return Object.values(sectionFieldValue).reduce((acc, value) => acc + (value ? 1 : 0), 0);
  }
  validationFinalStepsDetails=(sectionFieldValue)=>{
    let fourSectionValidation = Object.assign({}, ...this.props.fourSectionSteps);
    // Initialize a counter for validation
    let finalvalidation = 0;

    // Define an array of field names to check
    const fieldsToCheck = [
      'occupation',
      'Fractional_Residential_Expense__c',
      'monthly_expense_financial_commitments',
      'Fractional_Living_Expense__c',
      'flxNumber_of_Other_Financial_Dependents__c',
      'Employment_Stability__c',
      'Total_Monthly_Income__c'
    ];

    // Iterate through the field names to check their values
    for (const fieldName of fieldsToCheck) {
      // Retrieve the field's value from the sectionFieldValue object
      const fieldValue = sectionFieldValue[fieldName];
      
      // Check if the field value is defined and not an empty string
      if (fieldValue !== undefined && fieldValue !== '') {
        // Increment the validation counter
        finalvalidation++;
      }
    }
    let fourthSectionValidatedFieldCount = this.validationCheckForEachSection(fourSectionValidation);
    if (finalvalidation !== fourthSectionValidatedFieldCount) {
      finalvalidation = fourthSectionValidatedFieldCount;
    }
    // Return the final validation count
    
    return finalvalidation;
  }

  validateFormProgress = async () => {
    let buttonStatus = true;
    let isEmptyChangeEmail = false;
    const allDetails = Object.assign({}, ...this.props.applicationValidation);
    const savedUserData = Object.assign({}, ...this.props.saveApplicationData);
    const progressBarFirstSectionField = Object.assign({}, ...this.props.firstSectionSteps);
    const isProgressBarFirststepValidated = this.validationForEachStep(progressBarFirstSectionField);
    const progressBarSecondSectionField = Object.assign({}, ...this.props.secondSectionSteps);
    const isProgressBarSecondtepValidated = this.validationForEachStep(progressBarSecondSectionField);
    const progressBarThirdSectionField = Object.assign({}, ...this.props.thirdSectionSteps);
    let isProgressBarThirdstepValidated = this.validationForEachStep(progressBarThirdSectionField);
    const { isFlatAbodeValid, isHouseNameValid, isHouseNumberValid } = this.getFlatHouseFieldValidation(savedUserData);
    const isCurrentAddressValid = this.checkCurrentAddressValidity({ savedUserData });
    const isHouseInvalid = !isFlatAbodeValid || !isHouseNameValid || !isHouseNumberValid;
    const isAddressEmpty = savedUserData['Town__c'] == '' || savedUserData['Address_Line1__c'] == '' || savedUserData['Postal_Code__c'] == '';
    if (this.state.isAmendButtonClicked && (isHouseInvalid || isAddressEmpty)) {
      isProgressBarThirdstepValidated = 50;
      this.setState({ globalProgressBarValue: 50 });
    }
    const DurationOfResidence = savedUserData['Duration_of_Residence__c'];
    const isDurationOfResidenceValid = DurationOfResidence !== undefined && DurationOfResidence !== '';
    let PreviousAddressFieldRequired = DurationOfResidence === 'Less than 3 years';
    let isPreviousAddressValid = true;
    if (PreviousAddressFieldRequired) {
      const { isPreviousFlatNumberValid, isPreviousHouseNumberValid, isPreviousHouseNameValid, isPreviousAddressLine1Valid, isPreviousTownValid, isPreviousPostalCodeValid } = this.getFlatHouseFieldValidation(savedUserData);
      const isPreviousFlatHouseValid = !isPreviousFlatNumberValid || !isPreviousHouseNumberValid || !isPreviousHouseNameValid;
      const requiredFields = ['Previous_Address_Line1__c', 'Previous_Town__c', 'Previous_Postal_Code__c'];
      requiredFields.forEach((fields) => {
        if (!savedUserData[fields] || savedUserData[fields].trim() === '') {
          isPreviousAddressValid = false;
        }
      });
      if (!isPreviousAddressLine1Valid || !isPreviousTownValid || !isPreviousPostalCodeValid || isPreviousFlatHouseValid) {
        isPreviousAddressValid = false;
      }
    }
    const residentialStatus = savedUserData['Current_Residential_Status__c'];
    const isResidentialStatusValid = residentialStatus !== undefined && residentialStatus !== '';
    const expectedThirdStepValidation = PreviousAddressFieldRequired ? 8 : 5;
    const finalThirdStepValidation = PreviousAddressFieldRequired ? isProgressBarThirdstepValidated : expectedThirdStepValidation;
    const fourthSectionFieldValuesValidation = this.validationFinalStepsDetails(savedUserData);

    let validationCheckForFourthSection = false;
    const fourthSectionLimit = ['Student', 'Unemployed', 'Retired'].includes(savedUserData['Employment_Stability__c']) ? 6 : 7;
    validationCheckForFourthSection = isProgressBarSecondtepValidated >= 2 && finalThirdStepValidation >= expectedThirdStepValidation && fourthSectionFieldValuesValidation < fourthSectionLimit;

    const firstStepValidation = isProgressBarFirststepValidated !== 6
    const secondStepValidation = isProgressBarSecondtepValidated !== 2
    const thirdStepValidation = !isDurationOfResidenceValid || !isResidentialStatusValid || !isCurrentAddressValid ||
          finalThirdStepValidation !== expectedThirdStepValidation || (PreviousAddressFieldRequired && !isPreviousAddressValid)
    const fourthSectionValidation = validationCheckForFourthSection || allDetails['Total_Monthly_Income__c']
    const isFormValid = firstStepValidation || secondStepValidation || thirdStepValidation || fourthSectionValidation
    if (isFormValid) {
      buttonStatus = false;
      isEmptyChangeEmail = true;
    }
    if (allDetails['Email_Address'] !== '') {
      isEmptyChangeEmail = true;
    }
    this.setState({ isFormValidated: buttonStatus, isEmptyChangeEmail: isEmptyChangeEmail });
  }

  checkCurrentAddressValidity = ({ savedUserData }) => {
    return (
      savedUserData['Address_Line1__c'] &&
      savedUserData['Town__c'] &&
      savedUserData['Postal_Code__c'] &&
      savedUserData['Address_Line1__c'].trim() !== '' &&
      savedUserData['Town__c'].trim() !== '' &&
      savedUserData['Postal_Code__c'].trim() !== '' &&
      savedUserData['Town__c'].length >= 2 &&
      savedUserData['Postal_Code__c'].length >= 1 &&
      savedUserData['Address_Line1__c'].length >= 2 &&
      (savedUserData['Current_Flat_No__c'] == null || savedUserData['Current_Flat_No__c'].length <= 40) &&
      (savedUserData['Current_House_Name__c'] == null || savedUserData['Current_House_Name__c'].length <= 70) &&
      (savedUserData['HouseNumber__c'] == null || savedUserData['HouseNumber__c'].length <= 55) &&
      (savedUserData['Address_Line1__c'] == null || savedUserData['Address_Line1__c'].length <= 85) &&
      savedUserData['Town__c'].length <= 25
    );
  };

  validationForEachStep(sectionFieldValue) {
    const savedUserData = Object.assign({}, ...this.props.saveApplicationData);
    let validationCheckCount=0;
    let optionalFields= new Set(["Address_Line2__c"]);
    if(Object.keys(sectionFieldValue).length>0){
      validationCheckCount = Object.entries(sectionFieldValue).map(([key, value]) =>{
      if (!optionalFields.has(key)) {
        if(savedUserData[key] !== undefined && savedUserData[key] !== '' && savedUserData[key] !== null){
          return validationCheckCount++;
        }
      }
    });
  }

    let validatedFieldCount = this.validationCheckForEachSection(sectionFieldValue);
    if (validationCheckCount !== validatedFieldCount) {
      validationCheckCount = validatedFieldCount;
    }

    return validationCheckCount;
    
  }

  // To validate the input fields of all sections when input changes and update the progress bar value
  validationOfProgressBarAllSections = async (allDetailsData) => {
    const firstSectionField = Object.assign({}, ...this.props.firstSectionSteps);
    const isFirststepValidated = this.validationForEachStep(firstSectionField);
    const secondSectionField = Object.assign({}, ...this.props.secondSectionSteps);
    const isSecondtepValidated = this.validationForEachStep(secondSectionField);
    const thirdSectionField = Object.assign({}, ...this.props.thirdSectionSteps);
    const isthirdstepValidated = this.validationForEachStep(thirdSectionField);
    

    const savedUserData = Object.assign({}, ...this.props.saveApplicationData);
    const duration = savedUserData["Duration_of_Residence__c"];
    const previousAddressRequired = duration === "Less than 3 years";
    const thirdStepValidation = previousAddressRequired ? 8 : 5;
    const fourthSectionFieldValuesValidation = this.validationFinalStepsDetails(savedUserData)
    let validationCheckForFourthSection = false;

      const employementStability=['Student','Unemployed','Retired'];
      let finalStepSuccessed=false;
      if (employementStability.includes(allDetailsData['Employment_Stability__c'])) {
        validationCheckForFourthSection = isSecondtepValidated >= 2 && isthirdstepValidated >= thirdStepValidation && fourthSectionFieldValuesValidation<6;
        finalStepSuccessed=validationCheckForFourthSection?false:true;
      } else {
        validationCheckForFourthSection = isSecondtepValidated >= 2 && isthirdstepValidated >= thirdStepValidation && fourthSectionFieldValuesValidation<7;
        finalStepSuccessed=validationCheckForFourthSection?false:true;
      }
      const validationCheckForOneofEachSection =  isFirststepValidated==6 && isSecondtepValidated == 2 && isthirdstepValidated == thirdStepValidation && finalStepSuccessed;
      
      this.setStateToIncreaseProgressbar(isFirststepValidated,isSecondtepValidated,isthirdstepValidated,validationCheckForFourthSection,validationCheckForOneofEachSection);

  }

  setStateToIncreaseProgressbar = (isFirststepValidated,isSecondtepValidated,isthirdstepValidated,validationCheckForFourthSection,validationCheckForOneofEachSection) => {
    if(this.state.isAmendButtonClicked || this.state.changedValueAfterComplete) {
      const savedUserData = Object.assign({}, ...this.props.saveApplicationData);
      const duration = savedUserData["Duration_of_Residence__c"];
      const isDurationValid = duration !== undefined && duration !== '';
      const { isPreviousFlatNumberValid, isPreviousHouseNumberValid, isPreviousHouseNameValid, isPreviousAddressLine1Valid, isPreviousTownValid, isPreviousPostalCodeValid } = this.getFlatHouseFieldValidation(savedUserData);

      
      const isPreviousAddressRequired =duration ==='Less than 3 years';
      
	  const isPreviousAddressValid = !isPreviousAddressRequired ||
		(savedUserData['Previous_Address_Line1__c']?.trim() &&savedUserData['Previous_Town__c']?.trim() &&savedUserData['Previous_Postal_Code__c']?.trim() && 
          isPreviousAddressLine1Valid && isPreviousTownValid && isPreviousPostalCodeValid && isPreviousFlatNumberValid && isPreviousHouseNumberValid && isPreviousHouseNameValid);
      
      const thirdSectionValidation = duration === "Less than 3 years" ? 8 : 5;
      const isCurrentAddressValid=savedUserData['Address_Line1__c'] && savedUserData['Town__c'] && savedUserData['Postal_Code__c'] && savedUserData['Address_Line1__c'].trim()!=='' && savedUserData['Town__c'].trim()!=='' && savedUserData['Postal_Code__c'].trim()!=='';
      const residentialStatus = savedUserData['Current_Residential_Status__c'];
      const isResidentialStatusValid =residentialStatus !== undefined && residentialStatus !== '';
      if(isFirststepValidated!=6){
        this.setState({globalProgressBarValue: 0})
      }
      else if(isSecondtepValidated!=2){
        this.setState({globalProgressBarValue: 25})
      }
      else if(!isDurationValid || isthirdstepValidated<thirdSectionValidation || !isCurrentAddressValid || !isResidentialStatusValid || !isPreviousAddressValid){
        this.setState({globalProgressBarValue: 50})
      }
      else if(validationCheckForFourthSection)
      {
        this.setState({globalProgressBarValue: 75});
      }
      else if(validationCheckForOneofEachSection && isPreviousAddressValid) 
      {
        this.setState({ globalProgressBarValue: 100,isAddressConfirmed:true});
      }
  }
}

  setSectionMovieToSmallScreen = (divposition,globalProgressBarIndicatorValue,sectionToShow) => {
    if (divposition >= 0 && divposition < 125) {
      globalProgressBarIndicatorValue = 25;
      sectionToShow = "section-one";
    } else if (divposition >= 125 && divposition < 375) {
      globalProgressBarIndicatorValue = 50;
      sectionToShow = "section-two";
    } else if (divposition >= 375 && divposition < (this.state.thirdSectionHeight + 375)) {
      globalProgressBarIndicatorValue = 75;
      sectionToShow = "section-third";
    } else if (divposition >= this.state.thirdSectionHeight + 375) {
      globalProgressBarIndicatorValue = 100;
      sectionToShow = "section-four";
    }
    return {globalProgressBarIndicatorValue:globalProgressBarIndicatorValue,sectionToShow:sectionToShow}
  }

  setSectionMovieToBigScreen = (divposition,globalProgressBarIndicatorValue,sectionToShow) => {
    if (divposition >= 0 && divposition < 300) {
      globalProgressBarIndicatorValue = 25;
      sectionToShow = "section-one";
    } else if (divposition >= 300 && divposition < 700) {
      globalProgressBarIndicatorValue = 50;
      sectionToShow = "section-two";
    } else if (divposition >= 700 && divposition < (this.state.thirdSectionHeight + 705)) {
      globalProgressBarIndicatorValue = 75;
      sectionToShow = "section-third";
    } else if (divposition >= this.state.thirdSectionHeight + 705) {
      globalProgressBarIndicatorValue = 100;
      sectionToShow = "section-four";
    }
    return {globalProgressBarIndicatorValue:globalProgressBarIndicatorValue,sectionToShow:sectionToShow}
  }

  setSectionMovieToLargeScreen = (divposition,globalProgressBarIndicatorValue,sectionToShow) => {
    if (divposition >= 0 && divposition < 200) {
      globalProgressBarIndicatorValue = 25;
      sectionToShow = "section-one";
    } else if (divposition >= 200 && divposition < 800) {
      globalProgressBarIndicatorValue = 50;
      sectionToShow = "section-two";
    } else if (divposition >= 800 && divposition < (this.state.thirdSectionHeight + 805)) {
      globalProgressBarIndicatorValue = 75;
      sectionToShow = "section-third";
    } else if (divposition >= (this.state.thirdSectionHeight + 805)) {
      globalProgressBarIndicatorValue = 100;
      sectionToShow = "section-four";
    }
    return {globalProgressBarIndicatorValue:globalProgressBarIndicatorValue,sectionToShow:sectionToShow}
  }
  
  // To validate the input fields of all sections when input changes and update the progress bar indicator
  validationOfProgressIndicatorSections = async (event) => {

    // Get the width and scroll position
    const width = this.state.width;
    const divposition = event.target.scrollTop;
    // Initialize variables for progress bar and section to show
    let globalProgressBarIndicatorValue = 25;
    let sectionToShow = "";

    // Check screen width and scroll position to determine progress bar and section
    if (width <= 991) { // For screens less than or equal to 991px

     let checkSmallScreenResult =  this.setSectionMovieToSmallScreen(divposition,globalProgressBarIndicatorValue,sectionToShow);
     globalProgressBarIndicatorValue = checkSmallScreenResult.globalProgressBarIndicatorValue;
     sectionToShow = checkSmallScreenResult.sectionToShow;

    } else if (width <= 1199) { // For screens between 992px and 1199px

      let checkBigScreenResult =  this.setSectionMovieToBigScreen(divposition,globalProgressBarIndicatorValue,sectionToShow);
     globalProgressBarIndicatorValue = checkBigScreenResult.globalProgressBarIndicatorValue;
     sectionToShow = checkBigScreenResult.sectionToShow;

    } else if (width > 1200) { // For screens greater than 1200px

      let checkLargeScreenResult =  this.setSectionMovieToLargeScreen(divposition,globalProgressBarIndicatorValue,sectionToShow);
     globalProgressBarIndicatorValue = checkLargeScreenResult.globalProgressBarIndicatorValue;
     sectionToShow = checkLargeScreenResult.sectionToShow;

    }

    // Update the state with the calculated progress bar and section values
    this.setState({
      globalProgressBarIndicatorValue,
    });
    this.changeHeaderAndSubContentForEachSection(sectionToShow);

  }


  // To change the value of header and subcontent for progress Bar during scroll of each section
  changeHeaderAndSubContentForEachSection = (sectionId) => {
    if(sectionId == 'section-one') {
      this.props.sectionHeading.map((eachHeading, i) => {
        this.setSectionHeading(i, eachHeading, 0)
      })
      this.props.sectionSubContext.map((eachContext, i) => {
        this.setSectionContext(i, eachContext, 0)
      })
    }
    else if(sectionId == 'section-two') {
      this.props.sectionHeading.map((eachHeading, i) => {
        this.setSectionHeading(i, eachHeading, 1)
      })
      this.props.sectionSubContext.map((eachContext, i) => {
        this.setSectionContext(i, eachContext, 1)
      })
    }
    else if(sectionId == 'section-third') {
      this.props.sectionHeading.map((eachHeading, i) => {
        this.setSectionHeading(i, eachHeading, 2)
      })
      this.props.sectionSubContext.map((eachContext, i) => {
        this.setSectionContext(i, eachContext, 2)
      })
    }
    else if(sectionId == 'section-four') {
      this.props.sectionHeading.map((eachHeading, i) => {
        this.setSectionHeading(i, eachHeading, 3)
      })
      this.props.sectionSubContext.map((eachContext, i) => {
        this.setSectionContext(i, eachContext, 3)
      })
    }
  }

  // This function prepares the request payload for an API call 'application/submit_application'  
  saveApplicationUserData = (savedUserData, allUserDetails) => {
    for(let fieldName in savedUserData) {
      if(savedUserData[fieldName] !== "") {
        allUserDetails[fieldName] = savedUserData[fieldName]

      }
    }
    return allUserDetails;
  }

  checkThreasholdAmount = () => {
    if(Number(this.props.amountRequested) > Number(process.env.REACT_APP_MAXIMUM_LT_AMOUNT)){
      analyticsChangeEvent('big_thing',this.props.amountRequested)
      window.dataLayer.push({ 
        "event" : "metadata", 
        "customerType" : "[BIG THINGS]" 
      });

    } else {
      analyticsChangeEvent('little_thing',this.props.amountRequested)
        window.dataLayer.push({ 
          "event" : "metadata", 
          "customerType" : "[LITTLE THINGS]"
        });
    }
  }

  checkRedirectionBasedOnApplicationSubmitResponse = (applicationResult) => {
    this.checkIfButtonLabelAndRedirectUrLExists(applicationResult.data.data);
    analyticsClickEvent('application_approved', '');
    this.setState({ hasErrorMessage: applicationResult.data.message, loading: false });
    window.$('#commonModel').modal('show');
    this.props.showappValidation('');
    this.props.appValidationsRemove([]);
    window.$('#commonModel').modal({ backdrop: 'static', keyboard: false });
    sessionStorage.setItem('flxPersonEmail__c', '');
    sessionStorage.setItem('isObFlow', false);
    return false;
  }

  // This function initiates an API call to 'application/submit_application' and handles its response.
  applicationSubmit = async () => {
    let filteredData = await this.validateMissingparams();
    if (filteredData.length > 0) {
      frontEndLogs('Missing Application Request ' + this.getApplicationIDInstorage(), false, 400, 'applicationSubmit', filteredData);
      this.setState({changedValueAfterComplete:true,failedfieldValidationCollection: filteredData,isFormValidated:false,showContinueAppButton: true},()=>{
        window.$('#finalValidationModal').modal('show');
        const allUserData = Object.assign({}, ...this.props.saveApplicationData);
        this.validationOfProgressBarAllSections(allUserData);
      })
      return false;
    } else {
      const savedUserData = Object.assign({}, ...this.props.saveApplicationData);
      let allUserDetails = {}
      this.setState({ obStatusRecived: true, loading: true, popupButtonLabel: '', redirectURL: '' })
      allUserDetails = this.saveApplicationUserData(savedUserData, allUserDetails)
      allUserDetails['flx_DocumentAgree__c'] = this.state.flxDocumentAgree_C
      allUserDetails['flx_Agree__c'] = this.state.flxAgree_C
      allUserDetails['flx_Contact_Humm_agree__c'] = this.state.flxContactAgree_C
      if (IS_TMX_ENABLED) {
        const TMXSessionId = uuidv4();
        window.threatmetrix.profile(process.env.REACT_APP_TMXDOMAIN, process.env.REACT_APP_TMXKEY, TMXSessionId);
        allUserDetails.session_id = TMXSessionId;
      }
      const cookie = new Cookies();
      allUserDetails.application_id = await this.getApplicationIDInstorage();
      const { First_Name, Last_Name, Mobile_Number, Email_Address, Birth_Date, ...allDetails } = allUserDetails;
      this.checkThreasholdAmount();
      await frontEndLogs('Application submit request : session Storage applicationId :' + sessionStorage.getItem("applicationId") + ',cookie applicationID :' + cookie.get('applicationId'), false, 200, 'applicationSubmit', allDetails);
      analyticsClickEvent('application_submit_clicked', '');
      let applicationResult = await applicationSave(allDetails);
      await frontEndLogs('Application submit response ' + this.getApplicationIDInstorage(), false, 200, 'applicationSubmit', applicationResult);
      if (applicationResult?.data?.data?.decision_taken_by === 'LendingMetrics') {
        this.setState({ decisionByLendingMetrics: true }, async () => {
          await this.handleLendingMetricsResponse(applicationResult);
        })
        return false;
      } else if (applicationResult === undefined || applicationResult?.data?.statusCode === 503) {
        this.handleServiceUnavailableInApplicationResponse(applicationResult, 'applicationSubmit');
        return false;
      } else if (applicationResult?.data?.message === 'Sorry, something has gone wrong with the processing of your application. Please try again.') {

        this.setState({ loading: false })
        this.setState({ hasErrorMessage: applicationResult.data.message });
        window.$('#commonModel').modal('show');
        GTMApplicationFunnelSubmitError('Application Flow', 'server', 1, 2, "1:2", applicationResult?.data?.message);
        return false;
      } else if (applicationResult.data.statusCode === 202) {

        GTMApplicationSubmitStatus("Step 1", "server", 1, 2, "1 : 2", "[Approved]")
        return this.checkRedirectionBasedOnApplicationSubmitResponse(applicationResult);
      }
      else if (applicationResult.data.statusCode === 200) {
        analyticsClickEvent('application_referred', '');
        GTMApplicationSubmitStatus('Step 1', 'server', 1, 2, "1 : 2", '[Refer]')
        this.checkIfButtonLabelAndRedirectUrLExists(applicationResult.data.data);
        this.setState({ hasErrorMessage: applicationResult.data.message, loading: false, messageTitle: applicationResult.data.data.message_title })
        window.$('#commonModel').modal('show');
        this.props.showappValidation('');
        this.props.appValidationsRemove([]);
        window.$('#commonModel').modal({ backdrop: 'static', keyboard: false });
        sessionStorage.setItem('flxPersonEmail__c', '');
        sessionStorage.setItem('isObFlow', false);
        return false;
      }
      else if (applicationResult.data.statusCode === 417) {
        let errorMessage = applicationResult.data.message;

        analyticsClickEvent('application_declined', '');
        GTMApplicationSubmitStatus('Step 1', 'server', 1, 2, "1 : 2", "[Decline]")
        this.checkIfButtonLabelAndRedirectUrLExists(applicationResult.data.data);
        this.setState({ loading: false, hasErrorMessage: errorMessage, messageTitle: applicationResult.data.data.message_title });
        window.$('#commonModel').modal('show');
      }
      else if (applicationResult.status === 206) {
        this.setState({ loading: false });
        this.props.showappValidation('');
        this.setState({ isMitekProcessReached: true, showMitekConsent: true })
        window.scrollTo(0, 0);
        await this.handleLogsForDocumentpage('applicationSubmit');
      }
      else {
        GTMApplicationFunnelSubmitError('Application Flow', 'server', 1, 2, "1:2", applicationResult?.data?.message);
        this.setState({ serverErrorMessage: applicationResult?.data?.message, loading: false })
        window.$('#serverErrorShowModel').modal('show');
      }
    }

  }

   validateMissingparams = async () =>{
    let missingParamsData = [];
    let applicationValidationData = Object.assign({}, ...this.props.applicationValidation);
    const doNotCheckTheFields = new Set(["stage", "frequency", "flx_DocumentAgree__c", "flx_Contact_Humm_agree__c", "flx_Agree__c"]);
    // Email match check
    const allUserData = Object.assign({}, ...this.props.saveApplicationData);
    const email = (allUserData['Email_Address'] || '').trim().toLowerCase();
    const confirmEmail = (allUserData['Confirm_Email_Address'] || '').trim().toLowerCase();

    if (email && confirmEmail && email !== confirmEmail) {
      missingParamsData.push('Email does not match');
    }

     const current = allUserData['Current_Address_Country__c']?.trim();
     const previous = allUserData['Previous_Address__C']?.trim();

     if (previous && current === previous) {
       missingParamsData.push('Previous Address cannot be same as Current address');
     }

    applicationValidationData = Object.keys(applicationValidationData)
  .filter(key => !doNotCheckTheFields.has(key))
  .reduce((obj, key) => {
    obj[key] = applicationValidationData[key];
    return obj;
  }, {});
    Object.keys(applicationValidationData).forEach(key => {
      if (applicationValidationData[key] != "") {
        let fieldIndex = this.getLabelName(key);
        if(fieldIndex !== ''){
          missingParamsData.push(fieldIndex);
        }
      }
    });
    return missingParamsData;
  }

  // To handle the service unavailable when  application submit
  handleServiceUnavailableInApplicationResponse = async (applicationResult, methodName) => {
    try {
      await frontEndLogs('Service unavailable when application submit ' + sessionStorage.getItem("applicationId"), false, 200, methodName, applicationResult);
      analyticsClickEvent('service_unavailable_in_application_submit', '');
      if (this.state.retryLimit < process.env.REACT_APP_HANDLE_SERVICE_UNAVAILABLE_RETRYLIMIT) {
        setTimeout(async () => {
          this.setState(
            (prevState) => ({
              retryLimit: prevState.retryLimit + 1
            }),
            () => {
               Promise.resolve(this.applicationSubmit()).catch((error) => {
                console.error("Failed to submit application:", error);
              });
            }
          );
        },10000)  
      } else {
        let serviceDelayRespone = 'Something has gone wrong while processing your application, please apply again. If this has occurred previously, please email contactuk@shophumm.com and we will investigate.';
        let convertMessage = this.convertMessage(serviceDelayRespone);
        this.setState({ obStatusRecived: false, loading: false, hasErrorMessage: convertMessage }, () => {
          window.$('#commonModel').modal('show');
        })
      }
    } catch (error) {
      await frontEndLogs('Catch Error ' + sessionStorage.getItem("applicationId"), true, 400, 'handleServiceUnavailableInApplicationResponse', error?.message);
    }
  }

  // To handle the lending metrics backend response
  handleLendingMetricsResponse = async(applicationResult)=>{
    try {
      let broker = window.location.search.includes('broker');    
      if(applicationResult?.data?.statusCode === 206 || (!applicationResult && broker)){
          analyticsClickEvent('application_warning_ob', '');
        GTMApplicationSubmitStatus('Step 1','server', 1, 2,"1 : 2", '[Warning-OB]')
        await frontEndLogs('Application response received as Warning-OB '+await this.getApplicationIDInstorage(),false,200,'handleLendingMetricsResponse',applicationResult?.data?.data);
        await this.handleWarningOBResponse();
          
        }else  if(applicationResult?.data?.statusCode === 202){
          if (applicationResult.data.data.appStatus === 'APPROVED - APPROVED') {
            analyticsClickEvent('application_approved', '');
            await frontEndLogs('Application has been approved and provided the approved URL ' + await this.getApplicationIDInstorage(), false, 200, 'handleLendingMetricsResponse');
            this.checkIfButtonLabelAndRedirectUrLExists(applicationResult.data.data);
            this.setState({ obStatusRecived: false, loading: false, hasErrorMessage: applicationResult.data.message, messageTitle: applicationResult.data.data.message_title });
            window.$('#commonModel').modal('show');
          } else if (applicationResult.data.data.appStatus === 'REFER_NO_ID') {
            analyticsClickEvent('application_referred_with_no_id_or_ob','');
            await frontEndLogs (' Application has been referred without OB and ID' + await this.getApplicationIDInstorage(),false,200,'handleLendingMetricsResponse',applicationResult?.data?.data);
            this.checkIfButtonLabelAndRedirectUrLExists(applicationResult.data.data);
            this.setState({ obStatusRecived: false, loading:false, hasErrorMessage: applicationResult.data.message, messageTitle: applicationResult.data.data.message_title});
            window.$('#commonModel').modal('show');
          } else {
            analyticsClickEvent('mitek_screen_shown_after_application_accept_or_refer', '');
            await frontEndLogs('Showed the Mitek screen after the application was accepted or refer ' + await this.getApplicationIDInstorage(), false, 200, 'handleLendingMetricsResponse');
            this.props.showappValidation('');
            this.setState({ isMitekProcessReached: true, showMitekConsent: true }, () => {
              this.setState({ loading: false, obStatusRecived: false });
            })
            window.scrollTo(0, 0);
            await this.handleLogsForDocumentpage('applicationSubmit');
          }        
      }else if(applicationResult?.data?.statusCode === 417){
        let firstStageDeclineErrorMessage = applicationResult.data.message;

      analyticsClickEvent('application_declined_based_on_lendingmetrics', '');
      GTMApplicationSubmitStatus('Step 1','server', 1, 2, "1 : 2", "[Decline]")
      this.checkIfButtonLabelAndRedirectUrLExists(applicationResult.data.data);
      this.setState({ obStatusRecived:false, loading: false, hasErrorMessage: firstStageDeclineErrorMessage,messageTitle:applicationResult.data.data.message_title });
      window.$('#commonModel').modal('show');
      } else if (applicationResult === undefined || applicationResult?.data?.statusCode === 503) {
        this.handleServiceUnavailableInApplicationResponse(applicationResult, 'handleLendingMetricsResponse');
        return;
      } else if (applicationResult?.data?.statusCode === 400) {
        let convertMessage = this.convertMessage(applicationResult.data.message);
        this.setState({ loading: false, obStatusRecived: false, hasErrorMessage: convertMessage })
        window.$('#commonModel').modal('show');
        return false;
      } else {
        await frontEndLogs('Submit application another response ' + await this.getApplicationIDInstorage(), false, 400, 'handleLendingMetricsResponse', applicationResult?.data);
        analyticsClickEvent('submit_application_another_response', '');
        this.setState({ loading: false, obStatusRecived: false });
        this.setState({ hasErrorMessage: "Something went wrong" })
        GTMApplicationFunnelSubmitError('Application Flow','server',1,2,"1:2","Something went wrong");
        window.$('#commonModel').modal('show');
      }
      return;
    } catch (error) {
      await frontEndLogs('Catch Error '+await this.getApplicationIDInstorage(),true,400,'handleLendingMetricsResponse',error?.message);
    }
  }

  // To handle Waring-ob response to show consent
  handleWarningOBResponse = async()=>{
    try {
      let searchParams = new URLSearchParams(window.location.search);
      let applicationID = searchParams.get("applicationID");
      let broker = searchParams.get("broker");
      let email = getEmailFromStorage();
      let requestPayloadOBInitialize = {
        "application_id": await this.getApplicationIDInstorage() || applicationID,
        "email":  email ?? this.state.email,
        "userId": sessionStorage.getItem('userID'),
        "application_external_id": sessionStorage.getItem('application_Id')
      }
      let obInitializeResponse =  await openBankingInitialize(requestPayloadOBInitialize);
      await frontEndLogs('Open banking initialize response ' + await this.getApplicationIDInstorage(), false, 200, 'handleWarningOBResponse', obInitializeResponse?.data);
      analyticsClickEvent('open_banking_initialized_response_received', '');
      sessionStorage.setItem('resetMitekOrigin','ob-landing')
      if(obInitializeResponse && obInitializeResponse?.data?.statusCode === 201){
        if(obInitializeResponse?.data?.data?.url){
          this.setState({openBankingRedirectURL: obInitializeResponse.data.data.url,openWarningOBConsent:true},()=>{
            if(broker) {
              
            sessionStorage.setItem('applicationId', obInitializeResponse.data.data.applicationId);
            setEmailInStorage(obInitializeResponse.data.data.email);
            }
            const applicationBodyElement = document.querySelector('body');
            applicationBodyElement.classList.remove('applicationPage');
            this.setState({ loading: false,obStatusRecived:false })
            })
        } else {
          await this.unableToRetrieveVerificationLink(obInitializeResponse, broker);
        }        
      } else {
        await this.unableToRetrieveVerificationLink(obInitializeResponse, broker);
      }
    } catch (error) {
      await frontEndLogs('Catch Error '+await this.getApplicationIDInstorage(),true,400,'handleWarningOBResponse',error?.message);
    }
  }

  unableToRetrieveVerificationLink = async (obInitializeResponse, broker) => {
    if (broker && (obInitializeResponse.data.data['url'] == '' || obInitializeResponse.data.data['url'] == null)) {      
      this.setState({
        serverErrorMessage: `Your ID link has expired. Please email <a href="mailto:contactuk@shophumm.com">contactuk@shophumm.com</a> for instructions to complete your application.`
      });
      window.$('#serverErrorShowModel').modal('show');
      this.setState({ loading: false });
    } else {
      await this.unableToRetrieveLink(obInitializeResponse);
    }
  }

  // Handle the situation where the OB Link cannot be retrieved.
  unableToRetrieveLink = async(obInitializeResponse)=>{
      await frontEndLogs('The backend response OB link could not be retrieved. ' + await this.getApplicationIDInstorage(), false, 400, 'unableToRetrieveLink', obInitializeResponse?.data);
      analyticsClickEvent('backend_response_ob_link_not_retrieved', '');
      this.setState({ serverErrorMessage: "Something went wrong. Please try again." })
      window.$('#serverErrorShowModel').modal('show');
      this.setState({ loading: false })
  }

// will be sent to a third party in order to finish the OB procedure.
  redirectionToOpenBankingScreen = async() => {
    try {
      this.setState({ loading: true });
      await frontEndLogs('The user click on continue with open banking button ' + await this.getApplicationIDInstorage(), false, 200, 'redirectionToOpenBankingScreen', this.state.openBankingRedirectURL);
      analyticsClickEvent('continue_with_open_banking_clicked', '');
      let requestofContinueOpenBankingUser = {
        "application_id": await this.getApplicationIDInstorage(),
        "url": this.state.openBankingRedirectURL
      }
      let response = await continueOpenBanking(requestofContinueOpenBankingUser);
      if (response.data?.data?.status) {
        const message = response.data?.message;
        const title = response.data?.data?.message_title;
        const buttonLabel = response.data.data.buttonLabel || '';
        const redirectUrl = response.data.data.redirectUrl || '';
        this.setState({ popupButtonLabel: buttonLabel, redirectURL: redirectUrl, hasErrorMessage: message, messageTitle: title, loading: false }, () => {
          window.$('#commonModel').modal({ show: true, backdrop: 'static', keyboard: false });
        }); 
        return response.data.data 
      }
      else {
        window.location.href = this.state.openBankingRedirectURL;
      }
    } catch (error) {
      await frontEndLogs('Catch Error '+await this.getApplicationIDInstorage(),true,400,'redirectionToOpenBankingScreen',error?.message);
    }
    
  }

// To proceed with the Mitek flow in lending metrics flow 
  continueOnMitekFlow = async()=>{
    try {
      this.setState({ loading: true });
      await frontEndLogs('Continued the Mitek flow after the application status was Warning-OB' + await this.getApplicationIDInstorage(), false, 200, 'continueOnMitekFlow');
      analyticsClickEvent('continue_on_mitek_flow_after_status_warning_ob', '');
      let requesttoContinueWithoutOpenBankingUser = {
        "application_id": await this.getApplicationIDInstorage(),
        "url": ""
      }
      const response =await continueOpenBanking(requesttoContinueWithoutOpenBankingUser);
      if(response.data?.data?.status==='REFER_NO_ID'){
        analyticsClickEvent('application_referred_no_id', '');
        GTMApplicationSubmitStatus('Step 2','server', 2, 2,"2 : 2", '[Refer - No ID or OB]')
        const message=response.data?.message;
        const title=response.data?.data?.message_title;
        const buttonLabel = response.data.data.buttonLabel || '';
        const redirectUrl = response.data.data.redirectUrl || '';
        this.setState({
          popupButtonLabel: buttonLabel,
          redirectURL: redirectUrl,
          hasErrorMessage:message,
          messageTitle:title,
          loading:false,
          decisionByLendingMetrics:false,
          isMitekProcessReached: false, 
          showMitekConsent: false
        },()=>{
          document.body.classList.add('modal-open');
		  document.body.style.overflow='hidden';
          window.$('#commonModel').modal({show:true, backdrop: 'static', keyboard: false});
        });  
        this.props.showappValidation('');
        this.props.appValidationsRemove([]);
        return response.data.data;
      }
      else{
        this.props.showappValidation('');
        this.setState({
          openWarningOBConsent:false,
          decisionByLendingMetrics:false,
          isMitekProcessReached: true, 
          showMitekConsent: true,
          loading: false
        });
        window.scrollTo(0, 0);
        try {
          await this.handleLogsForDocumentpage('applicationSubmit');
        } catch (logError) {
          console.error('Error in handleLogsForDocumentpage:', logError);
        }
      }
    } catch (error) {
      await frontEndLogs('Catch Error '+await this.getApplicationIDInstorage(),true,400,'continueOnMitekFlow',error?.message);
    }
  }

 // To handling the response for OB success and failure
  handlingOBSuccessResponse = async (result)=>{
    try {
      const urlParams = new URLSearchParams(window.location.search);
      await frontEndLogs('Following being redirected to the application send the OB status', false, 200, 'handlingOBSuccessResponse', window.location.href);
      analyticsClickEvent('redirected_to_application_ob_status_success', '');
      const obStatus = urlParams.get('status');
      const obTaskId = urlParams.get('task_id');
      const applicationId = sessionStorage.getItem('applicationId') || urlParams.get('application_id');
      if(obStatus && obStatus === 'success' && obTaskId){
        this.setState({ obStatusRecived:true,obStatus:obStatus,loading:true})
        clearTimeout(this.timer);
          this.timer = setTimeout(async () => {
          this.props.navigate('/');
          const { pathname, search } = this.props.location;
          const newSearch = search.replace(`?status=${obStatus}&task_id=${obTaskId}`, '');
          this.props.navigate(`${pathname}?${newSearch}`, { replace: true });
              await this.getOBApplicationStatus(obStatus,obTaskId,applicationId);

        }, 10000);
        
      }else if(obStatus && obStatus === 'failure'){
        let obQrStatus = '';
        let connectionId = window.location.search.includes('connection_id');

        let requesttoContinueWithoutOpenBankingUser = {
          "application_id": await this.getApplicationIDInstorage()
        }
        
        if (connectionId) {
          obQrStatus = await updateQrStatusOb(requesttoContinueWithoutOpenBankingUser);//NOSONAR
        }
        this.setState({ obStatusRecived:true,obStatus:obStatus,serverErrorMessage: "Unfortunately, Your attempt to authenticate with open banking has failed. We kindly request that you try the process again." },()=>{
          window.$('#serverErrorShowModel').modal('show');
        })
      }
    } catch (error) {
      await frontEndLogs('Catch Error',true,400,'handlingOBSuccessResponse',error?.message);
    }
    
  }


  // To find out the status of an OB application
  getOBApplicationStatus = async(obStatus,obTaskId,applicationId)=>{
    try {
      let requestOfOBApplication = {
        "status": obStatus,
        "task_id":  obTaskId,
        "application_id":applicationId
      }
      let getOBApplicationResponse =  await getOBApplicationStatus(requestOfOBApplication);
      await frontEndLogs('Open banking attempted application status - ' + obTaskId, false, 200, 'getOBApplicationStatus', getOBApplicationResponse);
      analyticsClickEvent('open_banking_attempted_application_status', '');
      if (getOBApplicationResponse === undefined || getOBApplicationResponse?.data?.statusCode === 503) {
        GTMServerSubmitError('Step 2', 'client', "Service unavailable", 2, 2, '2 : 2')
        this.handleServiceUnavailableInOBResponse(obTaskId, getOBApplicationResponse, obStatus);
      } else if(getOBApplicationResponse.data.statusCode === 202) {
  
        GTMApplicationSubmitStatus("Step 2","server", 2, 2, "2 : 2", "[Approved]")
        this.setState({ hasErrorMessage: getOBApplicationResponse.data.message, loading: false, messageTitle: getOBApplicationResponse.data.data.message_title })
        return this.checkRedirectionBasedOnApplicationSubmitResponse(getOBApplicationResponse);
      }
      else if(getOBApplicationResponse.data.statusCode === 200) {
        analyticsClickEvent('application_referred', '');
        GTMApplicationSubmitStatus('Step 2','server', 2, 2,"2 : 2", '[Refer]')
        this.checkIfButtonLabelAndRedirectUrLExists(getOBApplicationResponse.data.data)
        this.setState({ hasErrorMessage: getOBApplicationResponse.data.message, loading: false,messageTitle:getOBApplicationResponse.data.data.message_title })
        analyticsClickEvent('common_modal_displayed', '');
        window.$('#commonModel').modal('show');
        this.props.showappValidation('');
        this.props.appValidationsRemove([]);
        window.$('#commonModel').modal({ backdrop: 'static', keyboard: false });
        sessionStorage.setItem('flxPersonEmail__c', '');
        return false;
      }
      else if (getOBApplicationResponse.data.statusCode === 417) {
        let obApplicationErrorMessage = getOBApplicationResponse.data.message;
  
        analyticsClickEvent('application_declined', '');
        GTMApplicationSubmitStatus('Step 2','server', 2, 2, "2 : 2", "[Decline]")
        this.checkIfButtonLabelAndRedirectUrLExists(getOBApplicationResponse.data.data);
        this.setState({ loading: false, hasErrorMessage: obApplicationErrorMessage,messageTitle:getOBApplicationResponse.data.data.message_title });
        window.$('#commonModel').modal('show');
      }else if (getOBApplicationResponse?.data?.statusCode === 400) {
        let convertMessage = this.convertMessage(getOBApplicationResponse.data.message);
        this.setState({ loading: false, obStatusRecived: false, hasErrorMessage: convertMessage })
        window.$('#commonModel').modal('show');
        return false;
      } else if (getOBApplicationResponse.data.statusCode === 404) {
        this.setState({ obStatusRecived: true, obStatus: "failure", serverErrorMessage: getOBApplicationResponse?.data?.message, loading: false }, () => {
          window.$('#serverErrorShowModel').modal('show');
        })
      }
      else {
        GTMServerSubmitError('Step 2', 'server', getOBApplicationResponse?.data?.message, 2, 2, '2 : 2')
        this.setState({ hasErrorMessage:  getOBApplicationResponse?.data?.message, loading: false ,unableToProvide:true},()=>{
          window.$('#commonModel').modal('show');
        })
        return false;
      }

    } catch (error) {
      await frontEndLogs('Catch Error '+ obTaskId,true,400,'getOBApplicationStatus',error?.message);
    }
  }

// To handle the service unavailable issue when OB flow
  handleServiceUnavailableInOBResponse = async (obTaskId, getOBApplicationResponse, obStatus) => {
    try {
      await frontEndLogs('Service unavailable in Open banking flow - ' + obTaskId, false, 200, 'handleServiceUnavailableInOBResponse', getOBApplicationResponse);
      analyticsClickEvent('service_unavailable_in_open_banking_flow', '');
      if (this.state.retryLimit < 4) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          this.setState(
            (prevState) => ({
              retryLimit: prevState.retryLimit + 1
            }),
            () => {
              Promise.resolve(this.getOBApplicationStatus(obStatus, obTaskId)).catch((error) => {
                console.error("Failed to get OB application status:", error);
              });
            }
          );
        }, 10000);
      } else {
        let serviceDelayRespone = 'Something has gone wrong while processing your application, please apply again. If this has occurred previously, please email contactuk@shophumm.com and we will investigate.';
        let convertMessage = this.convertMessage(serviceDelayRespone);
        this.setState({ loading: false, hasErrorMessage: convertMessage }, () => {
          window.$('#commonModel').modal('show');
        });
        return false;
      }
    } catch (error) {
      await frontEndLogs('Catch Error ' + obTaskId, true, 400, 'handleServiceUnavailableInOBResponse', error?.message);
    }
  }
  
  handleLogsForDocumentpage = async (methodName)=>{
    let { width } = this.state;
      let isMobile = width <= 768;
      if(isMobile){
        await frontEndLogs('All available document are showed in document verify' + await this.getApplicationIDInstorage(), false, 200, methodName);
        analyticsClickEvent('all_available_documents_showed_in_document_verify', '');
      } else {
        await frontEndLogs('QR Page showed - ' + this.getApplicationIDInstorage(), false, 200, methodName);
        analyticsClickEvent('qr_page_showed', '');
      }
  }


  displayResendSMSForEmail = () => {
    if(this.state.disableField) {
        return (
            <button id="resend-code" className="resendCode">Resend code</button>
        );
    }
    else {
        return(
          <button id="resend-code" className="resendCode" 
          onClick={(e) => this.handleRecaptchaForResendEmail(e)} onKeyDown={(e) => { e.preventDefault(); }} >Resend code</button>
        );
    }

  }



  stylingToHideApplicationFlow = () => {
    return (
      `below-form-section ${this.state.isMitekProcessReached ? 'd-none' : ''}`
    );
  }

  stylingOfNextButtonPopup = () => {
    return (
      `${this.state.disablePopupRegistration === 'disable-popup' ? 'btn btn-primary disable-popup' : 'btn btn-primary'}`
    );
  }

  analyticsClickEventPurchaseJourney = () => {
    analyticsClickEvent('return_to_purchase_journey','')
  }

  displayChangeEmail= () => {
    if(this.state.disableField){
        return (
            <button className="emailChange" style={{pointerEvents:"none"}} >
                            Wrong Email? Change here</button>
        );
    }
    else if(this.props.isDisableChangeEmailOption){
      return(
        <button className="emailChange" style={{pointerEvents:"none"}} >
            Wrong Email? Change here
        </button>
      )
    }
    else {
        return(
          <button className="emailChange" onClick={()=> {
            this.setState({onBlurInputFiled:false},()=>{
            let fieldValues = {}
            fieldValues['Email_Address'] = false;
            this.validateEmailAddressCheck();
            this.clearEmailAddressAndHighlightField();
            this.props.firstSectionValidationUpdate(fieldValues);
            this.hidePopup('#registerModal') })}}
            onKeyDown={(e) => { e.preventDefault(); }}
            >
              Wrong Email? Change here
          </button>
        )
    }
  }

  handleEmailPopupcloseButton = () => {
    if(this.props.isDisableChangeEmailOption || this.state.disableVerifyOkButton){
      return(
        <a href aria-label="Close" 
                            className="close" onClick={(e) => { e.preventDefault(); }} style={{pointerEvents:"none"}}>
                              <img src="images/close-orange.png" alt="close icon" className="img-fluid" />
                          </a>
          );
    }else{
      return(
        <a href aria-label="Close" 
        className="close" onClick={() => {
          this.setState({onBlurInputFiled:false},()=>{
          let fieldValues = {}
          fieldValues['Email_Address'] = false;
          this.validateEmailAddressCheck();
          this.clearEmailAddressAndHighlightField();
          this.props.firstSectionValidationUpdate(fieldValues);
          this.hidePopup("#registerModal") })
          }}>
          <img src="images/close-orange.png" alt="close icon" className="img-fluid" />
      </a>
      );
    }
  }

  handleMobilePopupcloseButton = () => {
    if(this.props.isDisableChangeMobileOption || this.state.disableVerifyOkButton){
          return(
            <a href aria-label="Close" 
            className="close" onClick={(e) => { e.preventDefault(); }} style={{pointerEvents:"none"}}>
                <img src="images/close-orange.png" alt="close icon" className="img-fluid" />
            </a>
          );
    }else{
      return(
        <a href aria-label="Close" 
                      className="close" onClick={()=> {
			this.setState({onBlurInputFiled:false, disableMobileNumberField: false},()=>{
                        this.props.updateMobileChange(true);
                        let fieldValues = {}
                        fieldValues['Mobile_Number'] = false;
                        this.clearMobileNumberAndHighlightField();
                        this.props.firstSectionValidationUpdate(fieldValues);
                        analyticsClickEvent('mobile_verification_popup_hidden', '');
                        this.hidePopup("#mobileModal")
                        })
                        } }>
                          <img src="images/close-orange.png" alt="close icon" className="img-fluid" />
                      </a>
      );
    }
  }

  displayResendSMSForMobile = () => {
    if(this.state.disableField) {
        return (
            <button id="resend-code" className="resendCode">Resend Code</button>
        );
    }
    else {
        return(
          <button id="resend-code" className="resendCode" 
          onKeyDown={(e) => { e.preventDefault(); }} onClick={(e) => this.handleRecaptchaForResendMobile(e)}  >Resend Code</button>
        );
    }

  }

  displayChangeMobileNumber = () => {
    if(this.state.disableField){
        return (
            <button className="emailChange" style={{pointerEvents:"none"}}>
                            Wrong Number? Change here</button>
        );
    }
    else if(this.props.isDisableChangeMobileOption){
      return(
        <button className="emailChange" style={{pointerEvents:"none"}}>Wrong Number? Change here</button>
      )

    }
    else {
        return(
          <button className="emailChange" 
          onKeyDown={(e) => { e.preventDefault(); }}
          onClick={()=> {
            this.props.updateMobileChange(true);
            let fieldValues = {}
            fieldValues['Mobile_Number'] = false;
            this.clearMobileNumberAndHighlightField();
            this.props.firstSectionValidationUpdate(fieldValues);
            analyticsClickEvent('mobile_verification_popup_hidden', '');
            this.hidePopup("#mobileModal")
            this.setState({disableMobileNumberField: false});
          }}>Wrong Number? Change here</button>
        )
    }
  }


  /* Display the success message when the message is not empty */
  resendSuccessMessagDisplay = () => {
    if(this.state.codeSuccess !== '') {
      return (
        <span>{this.state.codeSuccess}</span>
      );
    }
  }

  /* Display the error message when the message is not empty */
  resendErrorMessageDisplay = () => {
    let errorCodeMessage = this.state.codeErrorForResendCode
    if(this.state.codeErrorForResendCode !== '') {    
      let errorMessage = errorCodeMessage?.replaceAll("\n", "<br>");
      return (
        <span style={{ color: "#e60000" }}
          dangerouslySetInnerHTML={{ __html: errorMessage }}
        />
      );
    }
  }

  redirectionForErrorPopupUpIfRedirectURLExists = () => {
    if (this.state.redirectURL !== '' && this.state.redirectURL !== undefined) {
      this.setState({ loading: true })
      window.location.href = this.state.redirectURL
    }
    else if (localStorage.getItem('fromWhere') === 'apply_now' || sessionStorage.getItem('fromWhere') === 'apply_now') {
      this.props.navigate("/login");
      window.location.reload(false)
    }
    else {
      this.props.navigate("/home");
    }

  }

  redirectCodeScreen = () => {
   
    if(this.state.isContinuePrevAmount === false){
      analyticsClickEvent('cancel','')
    }else{
      analyticsClickEvent('popup_ok','');
    }
   
    window.$('#commonModel').modal('hide');
    window.$('#userBalanceShowModel').modal('hide')
    window.$('.modal-backdrop').removeClass('show');
    window.$('body').removeClass('modal-open');
    window.$('.modal-backdrop').remove();
    if (this.state.unableToProvide === false) {
      this.props.appValidationsRemove([]);
      this.props.getAmountRequested('');
      this.props.showappValidation('');
      this.props.removeSavedata([]);

      this.redirectionForErrorPopupUpIfRedirectURLExists();      
    }

  }

  clearMobileNumberAndHighlightField = () => {
    this.setState({loading: true, disableMobileNumberField: false});
    const inputElement = document.getElementById('Mobile_Number');
    inputElement.style.border = "1px solid #ff6200";
    let inputValues = {}
    inputValues['Mobile_Number'] = '';
    this.props.saveApplicationDatas(inputValues);

    setTimeout(() => {
      this.setState({loading: false})
      inputElement.focus();
    }, 2500);
  }

  handleLoaderStatus = (value) => {
    let loaderId = document.querySelector('.wrapper.welcome-page.loader-page');
    if(value === true){
      loaderId.style.backgroundColor = 'rgba(250, 250, 250, 0.980)';
    }
    else {
      loaderId.style.backgroundColor = '';
    }
    this.setState({loading: value})
  }


  hidePopup = (modalName) => {
    // Reset the variables on popup to its initial value when the popup is dismissed
    this.setState({code: '', disableVerifyOkButton: false, codeError: '', codeSuccess: '', 
    codeErrorForResendCode: '', disableField: false ,verificationMessage: ''});

    window.$(modalName).modal("hide");
  }

  handChange = (event) => {

    const name = event.target.name;
    const value = event.target.checked;

    switch(name){
      case 'flxAgree_C':
        if(value){
          this.setState({ flxAgree_C: true});

          this.setState({flxAgree_c_Error: ''});
        }
        else {
          this.setState({ flxAgree_C: false});
          this.setState({ flxAgree_c_Error: 'This is Required'})
        }
        break;

      case 'flxDocumentAgree_C':
        if(value){
          this.setState({ flxDocumentAgree_C: true});

          this.setState({flxDocumentAgree_c_Error: ''});
        }
        else {
          this.setState({ flxDocumentAgree_C: false});
          this.setState({flxDocumentAgree_c_Error: 'This is Required'});
        }
        break;
      case 'flxContactAgree_C':
        if(value){
          this.setState({ flxContactAgree_C: true});

          this.setState({flxContactAgree_C_Error: ''});
        }
        else {
          this.setState({ flxContactAgree_C: false});
          this.setState({flxContactAgree_C_Error: 'This is Required'});
        }
        break;
      default:
        break;
    }
  }

  buttonLabel = () => {
    return (this.state.popupButtonLabel !== '' ? this.state.popupButtonLabel : `Cancel`);
  }

  getRetailerFromBranchSDK = async () => {
    const cookie = new Cookies();
    let Dob = cookie.get("dob");
    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get('source');
    const trackingId = urlParams.get('trackingId');
    if (source || trackingId) {
      await frontEndLogs('Source or trackingId detected in getRetailerFromBranchSDK', false, 200, 'getRetailerFromBranchSDK', { source, trackingId });
      let getRetailerRequest = {
        source: source,
        trackingId: trackingId
      };
      await frontEndLogs('Calling getRetailer with request', false, 200, 'getRetailerFromBranchSDK', getRetailerRequest);
      let retailerResponse = await getRetailer(getRetailerRequest);
      await frontEndLogs('getRetailer response received', false, 200, 'getRetailerFromBranchSDK', retailerResponse);
      if (retailerResponse?.data?.statusCode === 200) {
        let reatilerData = retailerResponse?.data?.data;
        if (reatilerData?.retailer_id) {
          await frontEndLogs('Retailer ID found: ' + reatilerData.retailer_id, false, 200, 'getRetailerFromBranchSDK');
          sessionStorage.setItem('storeID', reatilerData?.retailer_id)
        }
        let loanAmount = new URLSearchParams(window.location.search).get('loanAmt');
        let selectedPlanTerm = new URLSearchParams(window.location.search).get('term');
        this.setState(
          {
            hasPartnerDetails: {
              id: reatilerData?.retailer_id,
              store_name: reatilerData?.retailer_name
            },
            amount: loanAmount,
            selectedPlanInterval: selectedPlanTerm,
            addTermValue: 1
          },
          () => {
            this.selectTermPlan();
          }
        );
        if (Dob) {
          cookie.set('Dob', Dob, { path: '/', maxAge: 3600 });
        }
        await frontEndLogs('The retailer ID was received for the retailer link from the backend API' + retailerResponse?.data?.data, false, 200, 'getRetailerFromBranchSDK');
      } else {
        await frontEndLogs('Retailer response failed or no retailer ID', false, 400, 'getRetailerFromBranchSDK');
        await frontEndLogs('The retailer ID was not received for the retailer link from the backend API ', false, 200, 'getRetailerFromBranchSDK', retailerResponse?.data);
        analyticsClickEvent('retailer_ID_not_received', '');
      }
    } else {
      try {
        frontEndLogs('Branch SDK Initiated', false, 200, 'getRetailerFromBranchSDK');
        analyticsClickEvent('branch_sdk_initiated', '');
        branch.init(process.env.REACT_APP_BRANCH_KEY, async function (err, data) {
          await frontEndLogs('Branch SDK Initiate response', false, 200, 'getRetailerFromBranchSDK', { 'Error': err, 'Data': data });
          if (!err) {
            branch.data(async function (err, data) {
              console.log('Branch SDK data response',data)
              await frontEndLogs('Branch SDK data response', false, 200, 'getRetailerFromBranchSDK', { 'Error': err, 'Data': data });
              if (err) {
                await frontEndLogs('Error fetching Branch deep link data', false, 400, 'getRetailerFromBranchSDK', err);
              } else if (data?.data_parsed?.retailer_id) {
                sessionStorage.setItem('storeID', data.data_parsed.retailer_id)
                sessionStorage.setItem('storeName', data.data_parsed.$marketing_title)
                let loanAmount = new URLSearchParams(window.location.search).get('loanAmt');
                let selectedPlanTerm = new URLSearchParams(window.location.search).get('term');
                this.setState(
                  {
                    hasPartnerDetails: {
                      id: data.data_parsed.retailer_id,
                      store_name: data.data_parsed.$marketing_title,
                    },
                    amount: loanAmount,
                    selectedPlanInterval: selectedPlanTerm,
                    addTermValue: 1
                  },
                  () => {
                    this.selectTermPlan();
                  }
                );
                if (Dob) {
                  cookie.set('Dob', Dob, { path: '/', maxAge: 3600 });
                }
                await frontEndLogs('Retailer ID received from branch link ' + data.data_parsed.retailer_id, false, 200, 'getRetailerFromBranchSDK');
              } else {
                await frontEndLogs('Retailer ID not received from branch link ', false, 404, 'getRetailerFromBranchSDK', data.data_parsed);
              }
            }.bind(this));
          } else {
  
            await frontEndLogs('Branch SDK initiate error', false, 400, 'getRetailerFromBranchSDK', err);
          }
        }.bind(this));
      } catch (error) {
        frontEndLogs('Branch SDK catch error', true, 400, 'getRetailerFromBranchSDK', error);
      }
    }
  }


  getRetailerDetailsFromBackend = async() => {
    const cookie = new Cookies(); 
    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get('source');
    const trackingId = urlParams.get('trackingId');
    let browserUrl = window.location.href
    let getRetailerRequest = {     
        expandedUrl: browserUrl 
    };
    if(source && trackingId) {
      getRetailerRequest.source = source;
      getRetailerRequest.trackingId = trackingId;
  } else {
    let decryptedPayload = cookie.get('decryptedPayload');
    if(decryptedPayload){
      browserUrl = `${window.location.origin}${window.location.pathname}?${decryptedPayload}`
      getRetailerRequest.expandedUrl = browserUrl;
    }
  }
    let retailerResponse = await getRetailer(getRetailerRequest)
    await frontEndLogs('Retailer response through the webhook in the Backend Branch SDK', false, 200, 'getRetailerDetailsFromBackend', retailerResponse?.data);
    analyticsClickEvent('retailer_response_through_webhook_backend_branch_sdk', '');
    if(retailerResponse?.data?.statusCode === 200){
      let reatilerData = retailerResponse?.data?.data;
      if(reatilerData?.retailer_id){
        sessionStorage.setItem('storeID', reatilerData?.retailer_id)
        cookie.set('retailerId',reatilerData?.retailer_id);
        this.setRetailerFinancialCookies({ cookie, reatilerData });
        this.handleApplicationQuestion();
      }else {
        await frontEndLogs('The retailer ID was not received for the purchase link from the backend API ', false, 200, 'getRetailerDetailsFromBackend', retailerResponse?.data);
        analyticsClickEvent('retailer_ID_not_received', '');
        this.handleApplicationQuestion();
      }
    } else if (retailerResponse?.data?.statusCode === 400) {
      this.handleApplicationQuestion();
    } else {
      await frontEndLogs('Other responses received from backend in the purchase flow', true, 400, 'getRetailerDetailsFromBackend', retailerResponse?.data);
      analyticsClickEvent('other_responses_received_from_backend', '');
      this.handleApplicationQuestion();
    }
  }

  setRetailerFinancialCookies = ({ cookie, reatilerData }) => {
    if (reatilerData?.loanAmount) {
      cookie.set('loanAmount', reatilerData.loanAmount, { path: '/', maxAge: 3600 });
    }
    if (reatilerData?.term) {
      cookie.set('term', reatilerData.term, { path: '/', maxAge: 3600 });
    }
  };

  handleApplicationQuestion = async()=>{
    if (localStorage.getItem('fromWhere') == 'apply_now' || sessionStorage.getItem('fromWhere') == 'apply_now')
      {
        await this.getUserValidated();
      } 
      else {
        await this.loggedUserApplyNow();
     }
  }

  assignAmountDetailsToApplication = async () => {
    let stageValues = {}
    let formattedLoanAmount=Number(this.state.amount).toFixed(2);
    let loanTermValue = Object.assign({}, ...this.props.saveApplicationData);
    loanTermValue['Loan_Term_Requested__c'] = this.state.selectedTermId;
    let loanAmountValue = Object.assign({}, ...this.props.saveApplicationData);
    loanAmountValue['genesis__Loan_Amount__c'] = formattedLoanAmount;
    let loanTermPlanId = Object.assign({}, ...this.props.saveApplicationData);
    loanTermPlanId['retailer_plan__c'] = this.state.selectedPlanId;
    stageValues['genesis__Loan_Amount__c'] = true;
    setTimeout(() => {
      this.props.saveApplicationDatas(loanTermValue);
      this.props.saveApplicationDatas(loanAmountValue);
      this.props.saveApplicationDatas(loanTermPlanId);
      this.props.secondSectionValidationUpdate(stageValues);
      this.props.getAmountRequested(formattedLoanAmount)
    }, 10000);
  }

  redirectionOfApplyNowButton = async () => {
    this.assignAmountDetailsToApplication();
    if (localStorage.getItem('fromWhere') == 'apply_now' || sessionStorage.getItem('fromWhere') == 'apply_now'){
        removeSessionIdFromStorage();
        sessionStorage.removeItem('applicationId');
        sessionStorage.removeItem('application_id');
        sessionStorage.removeItem('userID');
        removeEmailFromStorage();
        sessionStorage.removeItem('brokerFlow');
        localStorage.clear();
        localStorage.setItem('fromWhere','apply_now');
    }
    sessionStorage.removeItem('previousAppId');
    this.setState({ loading: true, isShowDecommissionMessage: false }, async () => {
      const cookie = new Cookies();
      let branchReferrer = window.location.search.includes('_branch_referrer');
      let branchTrackingId = window.location.href.includes('trackingId');
      let branchApprovedURL = window.location.href.includes('approvedURL');
      let branchRedirectToken = window.location.href.includes('redirectToken');
            
      if (cookie.get('trackingId')) {
        branchTrackingId = cookie.get('trackingId')
      }
      let quoteLoanAmount = sessionStorage.getItem('quote-loan-amount');
      let quoteLoanTerm = sessionStorage.getItem('quote-loan-term');
      let quoteRetailerId = sessionStorage.getItem('RetailerIdFromQuoteTool');
      if ((quoteLoanAmount && quoteLoanTerm && quoteRetailerId) && ((!branchRedirectToken || !branchApprovedURL) && !branchTrackingId)) {        
        this.handleApplicationQuestion();
      } else if ((branchApprovedURL || branchRedirectToken) && branchTrackingId) {
        await this.getRetailerDetailsFromBackend()
      } else if (branchReferrer && !branchTrackingId) {
        frontEndLogs('Attempted to retrieve the retailerId using the Branch SDK.', false, 200, 'redirectionOfApplyNowButton');
        analyticsClickEvent('attempted_to_retrieve_retailerId_using_branch_sdk', '');
        await this.handleApplicationQuestion();
      } else {
        this.handleApplicationQuestion();
      }
    });
  }

  stylingForMissingFieldsList = () => {

    if(this.state.stepZeroData !== '') {
      return 'ml-1'; 
    }
    else {
      return 'ml-5';
    }

  }

  handleScrollOfNextSection = () => {
    const nextSection = document.getElementById("second-section");
    const prevSection = document.getElementById("first-section");

    const span = document.getElementById("second-section");

    setTimeout(() => {
      this.setState({loading: true})
    }, 300);

    setTimeout(() => {
      if(this.state.globalProgressBarValue !== 100) {
        this.setState({globalProgressBarValue: 25});
      }
      this.setState({loading: false}, () => {
        this.showSectionSubContext();
        this.showSectionHeading(); 
      });
      if(nextSection && this.state.firstSectionProgressValue === 25){

        if(this.state.width <= 768) {
          window.scrollTo({ top: nextSection.offsetTop +30, behavior: "smooth"})
        }
        else {
          // styling for position scroll view of second section 
          nextSection.style.marginBottom = "410px"
          prevSection.style.marginBottom = "210px"
          window.scrollTo({ top: nextSection.offsetTop - 110, behavior: "smooth"})
        }

        span.scrollIntoView({ behavior: 'smooth' });

        setTimeout(() => {
          this.validationforPrepopulatedOfSecondSection();
        }, 1100);
        GTMValidStepsSubmit('About You','Client','1','4','1:4');
      }
    }, 1500);
  }

  handleScrollOfThirdSection = () => {
    const thirdSection = document.getElementById("third-section");

    setTimeout(() => {
      this.setState({loading: true})
    }, 300);


    setTimeout(() => {
      this.setState({loading: false, globalProgressBarValue: 50}, ()=> {
        this.showSectionHeading();
        this.showSectionSubContext();
      })

      if(thirdSection && this.state.secondSectionProgressValue === 50){
        if(this.state.width <= 768) {
          window.scrollTo({ top: thirdSection.offsetTop +30, behavior: "smooth"})
        }
        else {
          thirdSection.style.marginBottom = "250px"
          window.scrollTo({ top: thirdSection.offsetTop - 190, behavior: "smooth"})
        }

        setTimeout(() => {
          this.validationforPrepopulatedOfThirdSection();
        }, 1100);
        GTMValidStepsSubmit('Loan Details','Client','2','4','2:4');
      }
    }, 1500);
  }

  updateIncomeValue = () => {
    const allUserDetails = Object.assign({}, ...this.props.saveApplicationData);

    this.props.saveIncomeDataValue(allUserDetails['Total_Monthly_Income__c']) 
  }

  handleScrollOfFourSection = () => {
    const fourSection = document.getElementById("four-section");

    setTimeout(() => {
      this.setState({loading: true})
    }, 300);
    
    setTimeout(() => {
      this.setState({loading: false, globalProgressBarValue: 75}, () => {
        this.showSectionHeading(); 
        this.showSectionSubContext();
        this.submitSectionDetails("Current Address");
      })
      if(fourSection && this.state.thirdSectionProgressValue === 75){

        if(this.state.width <= 768) {
          window.scrollTo({ top: fourSection.offsetTop + 30, behavior: "smooth"})
        }
        else {
          window.scrollTo({ top: fourSection.offsetTop - 150, behavior: "smooth"})
        }

        this.setState({showFooterText: true});

        GTMValidStepsSubmit('Address','Client','3','4','3:4');
      }
    }, 1500);
  }

  scrollToFirstSection = () => {
    const firstSection = document.getElementById("first-section");

    setTimeout(() => {
      if(firstSection){

        if(this.state.width <= 768) {
          window.scrollTo({ top: firstSection.offsetTop +30, behavior: "smooth"})
        }
        else {
          window.scrollTo({ top: firstSection.offsetTop - 190, behavior: "smooth"})
        }
        
        firstSection.scrollIntoView({ behavior: 'smooth' });
      }
    }, 1500);
  }

  validationforPrepopulatedOfSecondSection = async() => {
    if (localStorage.getItem('fromWhere') !== 'apply_now' && sessionStorage.getItem('fromWhere') !== 'apply_now') {
      let stageValues = {}
      let amountStageValues = {}
      let loanTermValue = {};
      loanTermValue['Loan_Term_Requested__c'] = this.state.selectedTermId;
      let loanAmountValue = {};
      loanAmountValue['genesis__Loan_Amount__c'] = this.state.amount;
      amountStageValues['Loan_Term_Requested__c'] = true
      let loanTermPlanId = {};
      loanTermPlanId['retailer_plan__c'] = this.state.selectedPlanId;
      stageValues['genesis__Loan_Amount__c'] = true;
      await this.props.saveApplicationDatas(loanTermValue);
      await this.props.saveApplicationDatas(loanAmountValue);
      await this.props.saveApplicationDatas(loanTermPlanId);
      await this.props.secondSectionValidationUpdate(stageValues);
      await this.props.secondSectionValidationUpdate(amountStageValues);
    }
    const allUserDetails = Object.assign({}, ...this.props.saveApplicationData);
    const validationData = Object.assign({}, ...this.props.applicationValidation);
    let loanFieldValues = {}, loanStageTwoValue= {}
    if (allUserDetails['Loan_Term_Requested__c'] !== '' &&
      allUserDetails['Loan_Term_Requested__c'] !== undefined) {
      loanFieldValues['Loan_Term_Requested__c'] = "";
      loanStageTwoValue['Loan_Term_Requested__c'] = true;
      frontEndLogs('Loan term requested field prepopulated', false, 200, 'validationforPrepopulatedOfSecondSection', allUserDetails['Loan_Term_Requested__c']);
    } else if (validationData['Loan_Term_Requested__c'] ) {
      loanFieldValues['Loan_Term_Requested__c'] = "";
      loanStageTwoValue['Loan_Term_Requested__c'] = false;
      frontEndLogs('Loan term requested field validation reset', false, 400, 'validationforPrepopulatedOfSecondSection', validationData['Loan_Term_Requested__c']);
    }
    this.props.appvalidations(loanFieldValues);
    this.props.secondSectionValidationUpdate(loanStageTwoValue);
    let amountFieldValues = {}, amountStageTwoValue= {}
    if (allUserDetails['genesis__Loan_Amount__c'] !== '' &&
      allUserDetails['genesis__Loan_Amount__c'] !== undefined) {
      amountFieldValues['genesis__Loan_Amount__c'] = '';
      amountStageTwoValue['genesis__Loan_Amount__c'] = true;
    }
    
    this.props.appvalidations(amountFieldValues);
    this.props.secondSectionValidationUpdate(amountStageTwoValue);
    console.log('secondSectionValidationUpdate', this.props.secondSectionSteps);
    
    analyticsClickEvent('second_section_field_values_populated', '');
  }

  validationforPrepopulatedOfThirdSection = () => {
    const allUserDetails = Object.assign({}, ...this.props.saveApplicationData);
    let fieldValues = {}, stageThreeValues= {}

    if((this.props.prepopulateStatus) && allUserDetails['Address_Line1__c'] !== '' && 
      allUserDetails['Address_Line1__c'] !== undefined) {
      fieldValues['Address_Line1__c'] = '';
      stageThreeValues['Address_Line1__c'] = true;
    }
    if((this.props.prepopulateStatus) && allUserDetails['Postal_Code__c'] !== '' && 
      allUserDetails['Postal_Code__c'] !== undefined) {
      fieldValues['Postal_Code__c'] = '';
      stageThreeValues['Postal_Code__c'] = true;
    }
    if((this.props.prepopulateStatus) && allUserDetails['Town__c'] !== '' && 
      allUserDetails['Town__c'] !== undefined) {
      fieldValues['Town__c'] = '';
      stageThreeValues['Town__c'] = true;
    }
    if((this.props.prepopulateStatus) && allUserDetails['Current_Residential_Status__c'] ) {
      fieldValues['Current_Residential_Status__c'] = '';
      stageThreeValues['Current_Residential_Status__c'] = true;
    }

    this.props.appvalidations(fieldValues);
    this.props.thirdSectionValidationUpdate(stageThreeValues);
    analyticsClickEvent('third_section_field_values_populated', '');
  }

  validationforPrepopulatedOfFourthSection = () => {
    const allUserDetails = Object.assign({}, ...this.props.saveApplicationData);
    let fieldValues = {}, stageFourValues= {}, stage={}

    if(this.props.prepopulateStatus && allUserDetails['Employment_Stability__c'] !== undefined) {
      fieldValues['Employment_Stability__c'] = '';
      stageFourValues['Employment_Stability__c'] = true;
    }
    if((this.props.prepopulateStatus) && allUserDetails['occupation'] !== '' && 
    allUserDetails['occupation'] !== undefined) {
      fieldValues['occupation'] = '';
      stageFourValues['occupation'] = true;
      stage['occupation'] = ''
      this.props.appvalidations(stage);
      this.props.getEmploynmentstatus(true);

    }
    if((this.props.prepopulateStatus) && allUserDetails['flxNumber_of_Other_Financial_Dependents__c'] !== '' && 
    allUserDetails['flxNumber_of_Other_Financial_Dependents__c'] !== undefined) {
      fieldValues['flxNumber_of_Other_Financial_Dependents__c'] = '';
      stageFourValues['flxNumber_of_Other_Financial_Dependents__c'] = true;
      stage['flxNumber_of_Other_Financial_Dependents__c'] = ''
      this.props.appvalidations(stage);
    }

    this.props.appvalidations(fieldValues);
    this.props.fourSectionValidationUpdate(stageFourValues);
    analyticsClickEvent('fourth_section_field_values_populated', '');
  }

  setSectionHeading = (i, eachHeading, value) => {
    if(i==value) {
      this.setState({sectionHeadingValue: eachHeading[value]})
    }
  }

  setSectionContext = (i, eachContext, value) => {
    if(i==value) {
      this.setState({sectionContextValue: eachContext[value]})
    }
  }
 
  showSectionHeading = () => {
    if(this.state.globalProgressBarValue === 0) {
      this.props.sectionHeading.map((eachHeading, i) => {
        this.setSectionHeading(i, eachHeading, 0)
      })
    }
    else if(this.state.globalProgressBarValue === 25) {
      this.props.sectionHeading.map((eachHeading, i) => {
        this.setSectionHeading(i, eachHeading, 1)
      })
    }
    else if(this.state.globalProgressBarValue === 50) {
      this.props.sectionHeading.map((eachHeading, i) => {
        this.setSectionHeading(i, eachHeading, 2)
      })
    }
    else if(this.state.globalProgressBarValue === 75) {
      this.props.sectionHeading.map((eachHeading, i) => {
        this.setSectionHeading(i, eachHeading, 3)
      })
    }
  }

  showSectionSubContext = () => {
    if(this.state.globalProgressBarValue === 0) {
      this.props.sectionSubContext.map((eachContext, i) => {
        this.setSectionContext(i, eachContext, 0)
      })
    }
    else if(this.state.globalProgressBarValue === 25) {
      this.props.sectionSubContext.map((eachContext, i) => {
        this.setSectionContext(i, eachContext, 1)
      })
    }
    else if(this.state.globalProgressBarValue === 50) {
      this.props.sectionSubContext.map((eachContext, i) => {
        this.setSectionContext(i, eachContext, 2)
      })
    }
    else if(this.state.globalProgressBarValue === 75) {
      this.props.sectionSubContext.map((eachContext, i) => {
        this.setSectionContext(i, eachContext, 3)
      })
    }
  }

  showAnimateForProgress = () => {
    if(this.state.globalProgressBarValue === 0) {
      return "";
    }
    else if(this.state.globalProgressBarValue === 25) {
      return "progressBar20";
    }
    else if(this.state.globalProgressBarValue === 50) {
      return "progressBar40";
    }
    else if(this.state.globalProgressBarValue === 75) {
      return "progressBar60"
    }
    else if(this.state.globalProgressBarValue >75) {
      return "progressBar100";
    }
  }

  animateHummLogoStyling = () => {
    if(this.state.globalProgressBarValue === 0) {
      return "";
    }
    else if(this.state.globalProgressBarValue === 25) {
      return "humm-logo--position-for-twenty";
    }
    else if(this.state.globalProgressBarValue === 50) {
      return "humm-logo--position-for-forty";
    }
    else if(this.state.globalProgressBarValue === 75) {
      return "humm-logo--position-for-sixty"
    }
    else if(this.state.globalProgressBarValue > 75) {
      return "humm-logo--position-on-completion";
    }
  }

  stylingForDisplayFooterTextDisclaimer = () => {
    return (this.state.showFooterText && this.state.width <= 480) ? 'text-center footer-text' : 'text-center footer-text d-none';
  }

  isDisplayMarketingConsentForLoginUser = () => {
    return !(this.state.isEmailConsentChecked || this.state.isSMSConsentChecked || this.state.isMobileAppConsentChecked || this.state.isApplicationConsentChecked)
  }

  stylingForApplicationHeading = (isMobile) => {
    return isMobile ? 'application-heading mb-2' : 'application-heading';
  }

  stylingForVerticalIndicatorIcons = (isMobile) => {
    return isMobile ? 
      'vertical-carousel-scrollview-sections d-none' : 'vertical-carousel-scrollview-sections';
  }

  stylingForSpacingToFirstSection = (isMobile) => {
    return `row ml-0 mr-0 ${isMobile ? 'firstSection-Scrollable' : ''
      } ${this.props.isBannerEnable ? 'bannerEnabled' : ''
      }`.trim();
  }

  stylingForProgressBar = (isMobile) => {
    return isMobile ?
      'col-md-4 slidecontainer-form px-5 progress-bar-section fixed-topProgressBar d-none':
      'col-md-4 slidecontainer-form progress-bar-section fixed-topProgressBar';
  }

  stylingForAllSectionsResponsively = (isMobile) => {
    return isMobile ? 
      'col-md-7 form-row ml-0 mb-5 m-0' : 'col-md-7 form-row application-sections';
  }

  stylingForDisplayTwoSection = () => {
    return this.state.firstSectionProgressValue === 25 && this.state.isMobileOTPVerified && !this.state.hideSecondSection ?
      'second-section form-row align-items-end' : 'second-section form-row align-items-end d-none';
  }

  stylingForDisplayThirdSection = () => {
    return this.state.secondSectionProgressValue === 50 ? 
      'third-section form-row align-items-end' : 'third-section form-row align-items-end d-none';
  }

  stylingForDisplayFourthSection = () => {
    return this.state.thirdSectionProgressValue == 75 ? 
      'four-section form-row align-items-end': 'four-section form-row align-items-end d-none';
  }

  redirectionThirdPartnerSite = () => {
    window.open("https://www.cifas.org.uk/fpn", '_blank', 'noopener noreferrer');
    window.$('#thirdPartyWebsiteModel').modal('hide');
  }

  checkBoxValidationForJustConfirm = (çheckBoxName) => {
    if(çheckBoxName === 'flxAgree_C'){
      return this.state.flxAgree_C === true ? "images/checked.svg" : "images/unchecked.svg"
    }

    if(çheckBoxName === 'flxDocumentAgree_C'){
      return this.state.flxDocumentAgree_C === true ? "images/checked.svg" : "images/unchecked.svg"
    }
    if(çheckBoxName === 'flxContactAgree_C'){
      return this.state.flxContactAgree_C === true ? "images/checked.svg" : "images/unchecked.svg"
    }
  }

  valueCheckForProgressBarValue = () => {
    return this.state.globalProgressBarValue === 110 ? 100 : this.state.globalProgressBarValue;
  }

  stylingForContinueAppButton = () => {
    return this.state.showContinueAppButton ? 'btn btn-primary mt-0 mb-5' : 'btn btn-primary d-none'
  }

  termsDisplay = async () => {
    const cookie = new Cookies();
    const allUserData = Object.assign({}, ...this.props.saveApplicationData);

    const retailerId = this.state.hasPartnerDetails.id ?? cookie.get('retailerId') ?? sessionStorage.getItem('storeID') ?? sessionStorage.getItem('RetailerIdFromQuoteTool');
    let loanAmount = allUserData['genesis__Loan_Amount__c'];
    let term = allUserData['Loan_Term_Requested__c'];

    const response = await getFrequencyDuration(retailerId, loanAmount, term);    

    frontEndLogs('Frequency duration plan API call has been made successfully', false, 200, 'getFrequencyDuration', { dataResponse: response, retailerIdRequested: retailerId, loanAmountRequested: loanAmount, termRequested: term });
    analyticsClickEvent('frequency_duration_plan_api_called_successfully', '');

    if (response?.data?.statusCode === 200) {
      this.setState({ frequencyDuration: response.data.data.frequency });
    } else {
      frontEndLogs('Frequency duration plan API call has been failed', false, 400, 'getFrequencyDuration', { dataResponse: response, retailerIdRequested: retailerId, loanAmountRequested: loanAmount, termRequested: term });
      analyticsClickEvent('frequency_duration_plan_api_called_failed', '');
      this.setState({ frequencyDuration: 'Months' });
    }
  };

  removeWebView(){
    if(sessionStorage.getItem('webView') != null){
      sessionStorage.removeItem('webView');
      window.location.reload(false)
    }
  }

//Function to prepopulate retailer name in quotecalculator flow
  updateStoreNameById = (response, id) => {
    const store = response?.data?.data?.store?.find(item => item.id === id);
    this.setState({
      hasPartnerDetails: {
        id: id,
        store_name: store ? store.store_name : ""
      },
      isDisabled: store ? true : false
    });

  }

  getApplicationIDInstorage(){
    const cookie = new Cookies();
    return sessionStorage.getItem('applicationId') ? sessionStorage.getItem('applicationId') :cookie.get('applicationId')
  }

  getConsentStatus = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const applicationId = urlParams.get('applicationID') || await this.getApplicationIDInstorage();  
    const response = await getConsentStatus(applicationId);    
    this.setState({loading: true});
    if (response.data.statusCode === 200) {      
      frontEndLogs('Agree consent checkbox clicked, Consent and Continue Button enabled', false, 200, 'getConsentStatus', response);
      analyticsClickEvent('agree_consent_checkbox_clicked', '');
        
        this.setState({
            isBioConsentShown: response.data.data.isBioConsentShown,
            disableApplicationConsentButton: !response.data.data.isBioConsentShown,
            email: response.data.data.email,
        });
        
          setEmailInStorage(response.data.data.email);

        if(response.data.data.isBioConsentShown) {
          this.setState({showQRCode: true, applicationConsentSrc: 'images/checked.svg'});  
        }
        
    }    
    setTimeout(() => {
      this.setState({loading: false});
    }, 2000);
  }

  getBrokerUserDetails = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const applicationId = urlParams.get('applicationID') || await this.getApplicationIDInstorage();  
    this.setState({ loading: true });    
    
      const response = await getBrokerUserDetails(applicationId);
       
      if (response.data.statusCode === 200 && response.data.data.mobile) {      
        frontEndLogs('Broker mobile number has been fetched from the API', false, 200, 'getBrokerUserDetails', response);
        analyticsClickEvent('broker_mobile_number_fetched', '');
        this.setState({ phoneNo: response.data.data.mobile, email: response.data.data.email });  
        sessionStorage.setItem('userID', response.data.data.userId )
        sessionStorage.setItem('mobileNumber', response.data.data.mobile);
        setSessionIdInStorage(response.data.data.sessionId);
      }
    
    this.setState({ loading: false });
  };


  checkMitekToken = (token) => {
    if(token) {
      this.setState({mitekToken: token});
    }
    if(!token && this.state.showQRCode) {
      this.setState({ displayQRCodeErrorModal:true })
    }
  }

  closeQRCodeErrorModal = () => {
    this.setState({ displayQRCodeErrorModal: false });
  };

  handleScrollMitekConsentPage = () => {
    setTimeout(() => {
      if (this.divRef?.current && this.wrapperRef) {
        const container = this.wrapperRef;
        const element = this.divRef.current;  
        const elementTop = element.offsetTop - container.offsetTop;
  
        container.scrollTo({
          top: elementTop + 1000,
          behavior: 'smooth',
        });
      }
    }, 2000);

  };
  handleFromValidation = (isValidated, amount, selectedRetailer, hasDisplay) => {
    this.setState({
      isFormValidated: isValidated,
      amount: amount.toString(),
      hasPartnerDetails: selectedRetailer,
      hasDisplay: hasDisplay
    });
    if (this.state.amount != '' && Object.keys(this.state.hasPartnerDetails).length > 0 ) {
      this.setState({
        hasDisplay: false
      })
    }
  };

  selectTermPlan = async() => {
    analyticsClickEvent('quote_landing_page_submit','') 
    this.setState({ 
      loading: true,
    })
    let payload;
    payload = {
      "store_id": this.state.hasPartnerDetails.id,
      "amount": this.state.amount
    }
    const result = await QuoteTool(payload);
    const responseData = result?.data?.data;
    const pcaData = responseData?.pca || {};
    const allPcaPlans = [
      ...(pcaData?.standard_plan || []),
      ...(pcaData?.deferred_plan || [])
    ];

    if (result.data.statusCode == 400) {
      this.setState({
          loading: false,
          NoRetailerMessage: result.data.message,
          // selectPlanNext: false,
          recalculationRequired: false,
          isplanSelected: false,
          selectedPlanId: "",
          quoteResult: "",
          isAmountAvailable: false
          // isDisabled: false,

      })     
    }
    else if(result.status === 200) {
      this.setState({ 
        quoteResult: result.data,
        selectPlanNext: true,
        loading: false,
        isDisabled: true,
        recalculationRequired: false,
        isplanSelected: false,
        selectedPlanId: "",
        NoRetailerMessage: ''
      })
      if (this.state.selectedPlanInterval) {
        allPcaPlans.forEach((src, index) => {
          if (this.state.selectedPlanInterval && (this.state.selectedPlanInterval == result.data.data.retailer_plan[index].term)) {
            this.setState({
              selectedPlanId: src.plan_id,
              isplanSelected: true,
              selectedTermId: result.data.data.retailer_plan[index].term,
              selectedPlanName: src.planName,
              planNotSelectedByDefault: true
            });
          }
        })
      }
      else if (allPcaPlans.length == 1) {
          allPcaPlans.forEach((src, index) => {
          this.setState({
            selectedPlanId: src.plan_id,
            isplanSelected: true,
            selectedTermId: result.data.data.retailer_plan[index].term,
            selectedPlanName: src.planName,
            planNotSelectedByDefault: true
          });
        })
      }
      else {
        this.setState({
          planNotSelectedByDefault: false
        })
      }
    }
  }

  selectIndividualPlan = async (planDetails, selectedPlanObj, quoteResult) => {
    const cookie = new Cookies();
    const term = selectedPlanObj?.term;

    if (term) {
      cookie.set('term', term, { path: '/', maxAge: 3600 });
    }

    this.setState({
      selectedPlanId: planDetails.plan_id,
      isplanSelected: true,
      selectedTermId: term,
      selectedPlanName: planDetails.planName
    });
  };

  resetSelectedPlans = async() => {
    this.setState({
      selectedPlanId: '',
      isplanSelected: false,
      selectPlanNext: false,
      isDisabled: false,
      recalculationRequired: false
    });
    
  }

  handleQrCode = () => {
    this.setState({ showQRCode: true });
  }

  handleAmendButtonlick = () => {
    this.setState({ isAmendButtonClicked: true, showContinueAppButton: true });
  }

  updateAmountAction = async(stateValue) => {
    this.setState({
      recalculationRequired: stateValue,
      NoRetailerMessage: ''
    });
  }

    checkAndCombineText = (planText, frequencyText) => {
      if (!planText) return frequencyText || ''; 
      if (!frequencyText) return planText;       

      // Create a case-insensitive regex to find the frequency text inside the plan text
      const regex = new RegExp(`\\b${frequencyText}\\b`, 'i');

      // If frequency already exists inside plan text, return planText only
      if (regex.test(planText)) {
        return planText;
      }

      // Otherwise, combine them with a space
      return `${planText} ${frequencyText}`;
    };

renderPrivacyPolicyCheck({isMobile}) {
  return(
    <div className={`appfrom-section ${this.state.isMitekProcessReached ? "d-none" : ""}`}>
      {!this.state.isMitekProcessReached &&
        <div className={this.stylingForApplicationHeading(isMobile)}>
          <center className="top-nav-bar">
            <h2>
              Let's get started
            </h2>
            <p className='pb-0 mb-0'>
              To make this process even faster for you, when you complete each section, you will be automatically scrolled to the next.
            </p>
          </center>
        </div>
      }

      {!this.state.showMitekConsent && <div className={this.stylingToHideApplicationFlow()}>

        <div className='tab-pane fade active show' id="stepOne" role="tabpanel" aria-labelledby="stepOne-tab">
          <div className="step-two-section step-one">

            <form autoComplete='nope'> 

              <div className={`slidecontainer-form progress-bar-section ${isMobile ? '' : 'd-none'}`} id='FixedProgressBar'>
                <h3 className='mt-2 mb-0'>
                  {this.state.sectionHeadingValue?.includes('Loan')
                    ? (this.state.hideSecondSection
                      ? (this.state.thirdSection?.[0]?.flxHeader__c)
                      : (this.state.sectionHeadingValue))
                    : this.state.sectionHeadingValue}
                </h3>

                <p className='mt-3 mb-0'>
                  {this.state.sectionContextValue}
                </p>

                <div className='app-progressBar progress-moved'>
                  <div className={`progress-bar2 ${this.showAnimateForProgress()}`}></div>
                  {this.state.progressBarImageSrc !== null &&
                    <img
                      src={this.state.progressBarImageSrc}
                      alt="logo"
                      className={`img-fluid ${this.animateHummLogoStyling()} ${this.state.progessBarLogoStyle}`}
                      id="progressBar-slider"
                    />
                  }
                </div>

                <p>
                  <span id="demo"></span>
                  {(this.state.hideSecondSection && this.state.sectionHeadingValue?.includes('Loan')) && this.state.showProgressValue ? 50 : this.valueCheckForProgressBarValue()}% Complete
                </p>

              </div>



              <div className={this.stylingForSpacingToFirstSection(isMobile)} >
                <div className={this.stylingForProgressBar(isMobile)}>
                  <h3 className=''>
                    {this.state.sectionHeadingValue?.includes('Loan')
                      ? (this.state.hideSecondSection
                        ? (this.state.thirdSection?.[0]?.flxHeader__c)
                        : (this.state.sectionHeadingValue))
                      : this.state.sectionHeadingValue}
                  </h3>

                  <p className='section-context'>
                    {this.state.sectionContextValue}
                  </p>

                  <div className='app-progressBar progress-moved mb-3'>
                    <div className={`progress-bar2 ${this.showAnimateForProgress()}`}></div>
                    {this.state.progressBarImageSrc !== null &&
                      <img
                        src={this.state.progressBarImageSrc}
                        alt="logo"
                        className={`img-fluid ${this.animateHummLogoStyling()} ${this.state.progessBarLogoStyle}`}
                        id="progressBar-slider"
                      />
                    }
                  </div>

                  <p>
                    <span id="demo"></span>
                    {(this.state.hideSecondSection && this.state.sectionHeadingValue?.includes('Loan')) && this.state.showProgressValue ? 50 : this.valueCheckForProgressBarValue()}% Complete
                  </p>

                </div>


                <div className={this.stylingForAllSectionsResponsively(isMobile)} onScroll={this.handleScroll} onTouchMove={this.handleScroll}>

                  <div className='first-section form-row align-items-end' id="first-section" data-section="#section-one">

                    {this.state.stepZeroData?.map((data, i) =>
                      <Element fieldItem={data['Questions']} ref={this.child} stage={'0'} mobileno={this.state.phoneNo} change={this.handleChange} showValidation={this.state.displayErrorsStepOne} key={data.sections} goBackAmendClicked={this.state.isAmendButtonClicked} onBlurInputFiled={this.state.onBlurInputFiled} disableMobileNumberField={this.state.disableMobileNumberField} isConfirmEmailFieldDisabled={this.state.isConfirmEmailFieldDisabled} isEmailFieldDisabled={this.state.isEmailFieldDisabled} />
                    )}

                  </div>
                  {!this.state.hideSecondSection && <div className='section-break'></div>}
                  <div className={this.stylingForDisplayTwoSection()} id='second-section' data-section="#section-two">

                    {this.state.secondSection?.map((data, i) =>
                      <Element fieldItem={data['Questions']} ref={this.child} stage={'1'} mobileno={this.state.phoneNo} change={this.handleChange} showValidation={this.state.displayErrorsStepOne} key={data.sections} goBackAmendClicked={this.state.isAmendButtonClicked} onBlurInputFiled={this.state.onBlurInputFiled} />
                    )}
                  </div>

                  {(!this.state.hideSecondSection && this.state.globalProgressBarValue >= 25 || this.state.secondSectionProgressValue == 50) &&
                    <div className='section-break'></div>
                  }
                  <div className={this.stylingForDisplayThirdSection()} id='third-section' data-section="#section-third" ref={this.thirdSectionRef}>

                    {this.state.thirdSection?.map((data, i) =>
                      <Element fieldItem={data['Questions']} ref={this.child} stage={'2'} mobileno={this.state.phoneNo} change={this.handleChange} showValidation={this.state.displayErrorsStepOne} key={data.sections} goBackAmendClicked={this.state.isAmendButtonClicked} onBlurInputFiled={this.state.onBlurInputFiled} isReturningUser={this.state.isReturningUser} isAddressConfirmed={this.state.isAddressConfirmed} setAddressConfirmed={this.setAddressConfirmed} isExistingUser={this.state.isExistingUser} />
                    )}
                  </div>

                  {this.state.thirdSectionProgressValue === 75 &&
                    <div className='section-break'></div>
                  }
                  <div className={this.stylingForDisplayFourthSection()} id='four-section' data-section="#section-four">

                    {this.state.fourSection?.map((data, i) =>
                      <Element fieldItem={data['Questions']} ref={this.child} stage={'3'} mobileno={this.state.phoneNo} change={this.handleChange} showValidation={this.state.displayErrorsStepOne} key={data.sections} goBackAmendClicked={this.state.isAmendButtonClicked} onBlurInputFiled={this.state.onBlurInputFiled} />
                    )}
                  </div>


                  {this.props.isChangeEmail &&

                    <button type="button" id="continueAppButton"
                      className='btn btn-primary mt-0 mb-5'
                      onClick={() => {
                        let fieldValues = {}
                        fieldValues['Email_Address'] = true;
                        this.handlechangeemailNotTriggred()
                      }}
                      disabled={this.state.isEmptyChangeEmail}>
                      Continue
                    </button>
                  }

                  {this.state.isFormValidated &&

                    <button type="button" id="continueAppButton"
                      className={this.stylingForContinueAppButton()}
                      onClick={() => {
                        this.updateIncomeValue();
                        this.termsDisplay()
                        analyticsClickEvent('user_note_show_model_displayed', '');
                        window.$('#userNoteShowModel').modal('show')
                      }}>
                      Continue
                    </button>
                  }
                  {!this.state.isFormValidated &&

                    <button type="button" id="continueAppButton"
                      className={this.stylingForContinueAppButton()}
                      disabled>
                      Continue
                    </button>
                  }

                </div>
                <div className={this.stylingForVerticalIndicatorIcons(isMobile)}>
                  {this.state.hideSecondSection ?
                    Array.from({ length: 4 }, (_, index) => index)
                      .filter((index) => index !== 1)
                      .map((index) => {
                        const progressValue = (index + 1) * 25;

                        const isActive =
                          this.state.globalProgressBarIndicatorValue === progressValue ||
                          (this.state.globalProgressBarIndicatorValue === 50 && index === 2);

                        return (
                          <span
                            key={`section-${index + 1}`}
                            className={`app-section${isActive ? ' is-active' : ''}`}
                            id={`section-${index + 1}`}
                          ></span>
                        );
                      }) :
                    Array.from({ length: 4 }, (_, index) => (
                      <span
                        key={`section-${index + 1}`}
                        className={`app-section${this.state.globalProgressBarIndicatorValue === ((index + 1) * 25) ? ' is-active' : ''}`}
                        id={`section-${index + 1}`}
                      ></span>
                    ))

                  }
                </div>



              </div>
              <div className={this.stylingForDisplayFooterTextDisclaimer()}>
                <p>
                  humm is a trading style of Humm Group Limited which is authorised and regulated by the Financial Conduct Authority. Financial Services Registration Number 954478.</p>
              </div>

              <Reaptcha
                ref={event => (this.reCaptchaRef = event)}
                size="invisible"
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                badge="bottomright"
                onLoad={this.onLoad}
                onVerify={this.onVerify}
              />

            </form>

          </div>
        </div>
      </div>

      }
    </div>
  )
}

  
render() { 
    const allUserData = Object.assign({}, ...this.props.saveApplicationData);
    let broker = window.location.search.includes('broker');  
    let sessionId = window.location.search.includes('sessionId');  
    let approvedURL = window.location.search.includes('approvedURL');  
    let redirectToken = window.location.search.includes('redirectToken');    
    const { width } = this.state;
    const isMobile = width <= 768;
    const { step } = this.state;
    const cookie = new Cookies();
    let codeStatus = this.state.codeSuccess !== '' || this.state.codeErrorForResendCode !== '';

    this.removeWebView();
    if(this.state.openWarningOBConsent){
      return (
        <div>
		  {/* Common Modal */}
          <CommonModal messageTitle={this.state.messageTitle} hasErrorMessage={this.state.hasErrorMessage} buttonLabel={this.state.popupButtonLabel} redirectCodeScreen={this.redirectCodeScreen} />
          <Loader loaderStatus={this.state.loading} obStatusRecived = {this.state.obStatusRecived}/>
          <OpenBankingConsent redirectToOpenBanking={this.redirectionToOpenBankingScreen} redirectToMitekPage={this.continueOnMitekFlow} phoneNo={this.state.phoneNo} openBankingRedirectURL={this.state.openBankingRedirectURL} handleLoader={this.handleLoaderStatus}  handleObVerificationLinkSentToMobile={this.handleObVerificationLinkSentToMobile} handleObredirect={this.handleObredirect} ></OpenBankingConsent>  
        </div>        
      )
    }    
  
    if ( isMobile === true && this.state.showQRCode && (new URLSearchParams(window.location.search).get("mitek_token") || this.state.mitekToken) ) {
      const mitekVerifyToken = new URLSearchParams(window.location.search).get("mitek_token") || this.state.mitekToken;
      return <Navigate to={`/humm-verfication/${mitekVerifyToken}`} />;
    }

    if (step == 0 || this.state.openWarningOBConsent) {
      return (
        <ApplicationLanding
          nextStep={this.nextStep}
        />
      );
    }
    const { storeName, isDisabled, quoteResult, amount, hasPartnerDetails, recalculationRequired, NoRetailerMessage, hasDisplay, isAmountAvailable, selectedPlanId } = this.state;

    const repayMentTerm=this.checkAndCombineText(this.state.selectedPlanName ?? allUserData['Loan_Term_Requested__c'], this.state.frequencyDuration);

      return (
        <>
       <div className="wrapperpage"
        ref={el => (this.wrapperRef = el)}
        style={{position: "relative"}}
        onScroll={this.validationScroll} >
         <div className="wrapperapp application" style={{ marginTop: this.props.isBannerEnable ? '10px' : '15px' }}>
          <Loader loaderStatus={this.state.loading} obStatusRecived = {this.state.obStatusRecived}/>
          <section className="main-application-page">
                <div className="container-terms-page">
                  {!this.state.privacyPolicyCheck && !broker && !sessionId && !this.state.showInitializePage &&
                    
                    <div className="top-nav-bar--terms-page" >
                      {this.state.selectPlanNext && this.state.selectedPlanInterval == '' && this.state.isApplicationNormalFlow  && (
                        <div className="left-iteQerd">
                          <div className="back-btn-item">
                              <button className="back-btnQr" type="button" onClick={() => this.resetSelectedPlans()}>
                                <img src="images/back.svg" alt="<-"/> Back
                              </button>
                          </div>
                        </div>
                      )}
                      <div className="start-the-application--subsection text-justify">
                        <div className="loan-info-section">
                      <div className="start-the-application--heading">
                        
                        <div className="retailer-form-section">
                          <RetailerPlanSection amount={amount} hasPartnerDetails={hasPartnerDetails} storeName={storeName} isDisabled={isDisabled} recalculationRequired={recalculationRequired} onFormCompleted={ this.handleFromValidation } isAmountUpdated={this.updateAmountAction} recalculateOperation={this.selectTermPlan} isApplicationNormalFlow={this.state.isApplicationNormalFlow} NoRetailerMessage={NoRetailerMessage} hasDisplay={hasDisplay} isAmountAvailable={isAmountAvailable} isSelectPlanNext={this.state.selectPlanNext}></RetailerPlanSection>
                          { !this.state.selectPlanNext && (
                            <div className="qc-footer-section">                                
                                {
                                    <button disabled={ !this.state.isFormValidated || this.state.hasDisplay || (this.state.amount == '' || this.state.amount == 0) } type="button" className="qc-confirm-btn btn" onClick={this.selectTermPlan}>Confirm</button>
                                }
                            </div>
                          )}
                          
                        </div>
                        { this.state.selectPlanNext && !this.state.recalculationRequired && (
                          <div className="retailer-plan-section">
                              {quoteResult.data?.pca && (
                                <SelectPlan quoteResult={quoteResult} isApplicationNormalFlow={this.state.isApplicationNormalFlow} planNotSelectedByDefault={this.state.planNotSelectedByDefault} selectedPlanInterval={this.state.selectedPlanInterval} isplanSelected={this.state.isplanSelected}  selectedPlanId={selectedPlanId} selectIndividualPlan={this.selectIndividualPlan} />
                              )}
                          </div>
                        )}
                      </div>
                    </div>
                    { this.state.selectPlanNext && (
                      <p className='terms-of-privacy-policy'>
                      Please read our <a href="https://www.shophumm.com/uk/privacy-policy/" target='_blank' rel="noopener noreferrer"
                      className='apply-important-info-link' id="privacy-policy-link">
                      Privacy Policy</a> which sets out the basis on which we will process your personal data when you use our services.{' '}
                      <span className='d-block'>By clicking "Apply Now" you agree that you have read and accepted all of the important information above.</span>{' '}
                      </p>
                    )}
                    

                    {this.isDisplayMarketingConsentForLoginUser() && this.state.selectPlanNext && 
                     <DisplayMarketingConsent emailCheckConsentSrc = {this.state.emailCheckConsentSrc} smsCheckConsentSrc = {this.state.smsCheckConsentSrc} handleInputChange = {this.handleInputChange} />
                    }

                  </div>

                  <div className="modal-footer d-flex flex-column" style={{ borderTop: "none" }}>
                  {((localStorage.getItem('sessionId') !== null) || (sessionStorage.getItem('sessionId') !== null)) && (
                    <Reaptcha
                      ref={event => (this.reCaptchaRef = event)}
                      size="invisible"
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onLoad={this.onLoad}
                      onVerify={this.onVerify}
                    />
                  )}
                  <div className="d-flex button-group">
                    <>
                    {((approvedURL || redirectToken) && this.state.selectPlanNext) &&
                      <a className='purchase-button' href={cookie.get('approvedURL')} 
                        onClick={(e) => {this.analyticsClickEventPurchaseJourney(e);}}>
                        <button
                          type="button"
                          id="purchaseButton"
                          className="btn btn-warning btn-outline"
                          disabled={this.state.isDisableContinue}
                        >
                        {window.innerWidth > 768 ? (
                          <>
                            Already Approved?
                            <br />
                            Start Purchase
                          </>
                        ) : (
                          'Already Approved? Start Purchase'
                        )} 
                        </button>
                      </a>
                    }
                    </>
                    <>
                    {this.state.selectPlanNext && (
                      <button
                        type="button"
                        id="termsApplyButton"
                        className="btn btn-primary"
                        disabled={(this.state.isDisableContinue || !this.state.isplanSelected) || this.state.recalculationRequired}
                        onClick={() => {
                          this.redirectionOfApplyNowButton().catch(error => console.error(error));
                        }}
                      >
                        Apply Now
                      </button>
                    )}
                    </>
                  </div>
                  <div ref={this.bottomScrollRef}></div>
                </div>
              
                    </div>
            }

            {/*Application consent page */}
            {(this.state.isBrokerApplication || ((this.state.showMitekConsent || this.state.showQRCode))) &&
            <MitekConsent isBrokerApplication={this.state.isBrokerApplication}  showQRCode={this.state.showQRCode} applicationConsentSrc={this.state.applicationConsentSrc} isBioConsentShown={this.state.isBioConsentShown} disableApplicationConsentButton={this.state.disableApplicationConsentButton} phoneNo={this.state.phoneNo} width={width} divRef={this.divRef} qrRef={this.qrRef} handleInputChange={this.handleInputChange} getBrokerUserDetails={this.getBrokerUserDetails} getConsentStatus={this.getConsentStatus} handleScrollMitekConsentPage={this.handleScrollMitekConsentPage} handleLoaderStatus={this.handleLoaderStatus} isEnableDesktopCapture={this.state.isEnableDesktopCapture} checkMitekToken={this.checkMitekToken} mitekVerificationLinkForUser={this.mitekVerificationLinkForUser} handleQrCode ={this.handleQrCode} sendButtonDisable = {this.state.sendButtonDisable} getApplicationIDInstorage = {this.getApplicationIDInstorage} />          }


              {this.state.privacyPolicyCheck && this.renderPrivacyPolicyCheck({isMobile})}
            </div>
          </section>
          <dialog className="modal fade" id="exampleModal" aria-labelledby="exampleModalLabel">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">�</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p className="mt-4">You will Be Lose Data</p>
                </div>
                <div className="modal-footer mb-4">
                  <button type="button" className="btn btn-primary">Ok</button>
                </div>
              </div>
            </div>
          </dialog>
          
          {/* session Expired */}
          <SessionExpiredModal />

          {/* stage save message modal */}
          <CommonModal messageTitle={this.state.messageTitle} hasErrorMessage={this.state.hasErrorMessage} buttonLabel={this.state.popupButtonLabel} redirectCodeScreen={this.redirectCodeScreen} />

          {/* field error show modal */}
         <FieldErrorShowModal errorCount={this.state.errorCodeMessage} requiredFieldCount={this.state.requiredFieldCount} LabelNames={this.state.LabelNames} stylingForMissingFieldsList={this.stylingForMissingFieldsList} analyticsClickEvent={this.analyticsClickEvent} />

          {/* userNoteShowModel show modal */}
           <UserNoteShowModal flxAgree_C = {this.state.flxAgree_C} flxDocumentAgree_C = {this.state.flxDocumentAgree_C} flxContactAgree_C = {this.state.flxContactAgree_C} flxAgree_c_Error = {this.state.flxAgree_c_Error} flxDocumentAgree_c_Error = {this.state.flxDocumentAgree_c_Error} flxContactAgree_C_Error = {this.state.flxContactAgree_C_Error} amountRequested = {this.props.amountRequested} saveIncomeData = {this.props.saveIncomeData} saveexpendituredata = {this.props.saveexpendituredata} DocumentAgreeLabel = {this.props.DocumentAgreeLabel} AgreeLabel = {this.props.AgreeLabel} contactDocumentAgree = {this.props.contactDocumentAgree} allUserData = {allUserData} repayMentTerm = {repayMentTerm} checkBoxValidationForJustConfirm = {this.checkBoxValidationForJustConfirm} handChange = {this.handChange} analyticsCheckBoxClickEvent = {this.analyticsCheckBoxClickEvent} applicationSubmit = {this.applicationSubmit} analyticsClickEvent = {this.analyticsClickEvent}  handleAmendButtonlick = {this.handleAmendButtonlick} scrollToFirstSection = {this.scrollToFirstSection}/>   

          {/* userBalanceShowModel show modal */}
          <UserBalanceShowModal message={this.state.approvedApplicationMessage} redirectCodeScreen={this.redirectCodeScreen} buttonLabel={this.buttonLabel} createNewApplication={this.createNewApplication} />

          {/* show server error message */}
          <ServerErrorShowModal serverErrorMessage={this.state.serverErrorMessage} obStatusRecived={this.state.obStatusRecived} obStatus={this.state.obStatus} serverErrorRedirection={this.serverErrorRedirection} redirectionBasedOnOB={this.redirectionBasedOnOB} />

          <dialog className="modal fade" id="mobileSuccessModal" aria-labelledby="mobileSuccessModalLabel" data-backdrop="static">
              <div className="modal-dialog">
                  <div className="modal-content">
                      <div className="modal-body pt-0 pb-0">
                          <div className="logo">
                              <img src="images/modal-logo.svg" alt="logo" className="img-fluid" />
                          </div>

                          <h5 className="modal-title text-center" id="mobileSuccessModalLabel">
                            Confirmed
                          </h5>

                        {this.state.verifyMessage !== '' &&
                          <p className='sucess-message text-center'>
                            {parse(this.state.verifyMessage)}
                          </p>
                        }
                      </div> 
                    </div>
              </div>
           </dialog>

           <dialog className="modal fade" id="registerSuccessModal" aria-labelledby="registerSuccessModalLabel" data-backdrop="static">
              <div className="modal-dialog" >
                  <div className="modal-content">
                      <div className="modal-body pt-0 pb-0">
                          <div className="logo mt-5 mx-auto">
                              <img src="images/modal-logo.svg" alt="logo" className="img-fluid" />
                          </div>

                          <h5 className="modal-title text-center" id="registerSuccessModalLabel">
                            Confirmed
                          </h5>

                        {this.state.verifyMessage !== '' &&
                          <p className='sucess-message text-center'>
                            {parse(this.state.verifyMessage)}
                          </p>
                        }
                      </div> 
                    </div>
              </div>
           </dialog> 

          {/* Email Verification popup */}
        <RegisterModal closeButtonElement={this.handleEmailPopupcloseButton()} email={this.state.email || getEmailFromStorage()} code={this.state.code} codeError={this.state.codeError} codeStatus={codeStatus} disableVerifyOkButton={this.state.disableVerifyOkButton} handleInputChange={this.handleInputChange} onKeyPressData={this.onKeyPressData} onlyAcceptInputs={this.onlyAcceptInputs} displayResendSMSForEmail={this.displayResendSMSForEmail} displayChangeEmail={this.displayChangeEmail} showMobileandEmailAddress={this.state.showMobileandEmailAddress} stylingOfNextButtonPopup={this.stylingOfNextButtonPopup} handleRecaptchaEmailVerify={this.handleRecaptchaEmailVerify} resendSuccessMessagDisplay={this.resendSuccessMessagDisplay} resendErrorMessageDisplay={this.resendErrorMessageDisplay}
             reCaptchaProps={{
             render: (localStorage.getItem('sessionId') !== null || sessionStorage.getItem('sessionId') !== null),
             refCallback: (event) => (this.reCaptchaRef = event),
             onLoad: this.onLoad,
             onVerify: this.onVerify,
                          }}
        />

          {/* Validation Failed Pop-up before final step */}
          <dialog className="modal fade finalValidationModal" id="finalValidationModal" data-keyboard="false" aria-labelledby="finalValidationPopupLabel">
            <div className="modal-dialog" >
              <div className="modal-content">
              <a href aria-label="Close" 
                      className="close" onClick={()=> {
                        this.hidePopup("#finalValidationModal")} }>
                          <img src="images/close-orange.png" alt="close icon" className="img-fluid" />
                      </a>
                <div className="modal-header">
                </div>
                <div className="modal-body">
                  <div className="logo">
                    <img src="images/modal-logo.svg" className="img-fluid" alt="logo" />
                  </div>
                  {this.state.failedfieldValidationCollection.length > 0 &&
<div className="text-center mt-4 validationErrorContainer">
  <span>Please Fill the below missing field values</span>
                  <ul>
  {
    this.state.failedfieldValidationCollection.map((value, idx) => (
      <li key={`${value}-${idx}`}>{value}</li>
    ))
  }
</ul>
</div>
    }

                </div>

                <div className="modal-footer mb-4">
                  
                  <button type="button" className="btn btn-primary" onClick={() => {
                  this.hidePopup("#finalValidationModal")}} >Continue</button>
                </div>


              </div>
            </div>
          </dialog>

          {/* Mobile verification modal */}
        <MobileModal closeButtonElement={this.handleMobilePopupcloseButton()} phoneNo={this.state.phoneNo} code={this.state.code} disableField={this.state.disableField} onlyAcceptInputs={this.onlyAcceptInputs} handleInputChange={this.handleInputChange} onKeyPressData={this.onKeyPressData} codeError={this.state.codeError} displayResendSMSForMobile={this.displayResendSMSForMobile} displayChangeMobileNumber={this.displayChangeMobileNumber} codeStatus={codeStatus} resendSuccessMessagDisplay={this.resendSuccessMessagDisplay} resendErrorMessageDisplay={this.resendErrorMessageDisplay} stylingOfNextButtonPopup={this.stylingOfNextButtonPopup} disableVerifyOkButton={this.state.disableVerifyOkButton} handleRecaptchaMobileVerify={this.handleRecaptchaMobileVerify} showMobileandEmailAddress={this.state.showMobileandEmailAddress}
            reCaptchaProps={{
            render: localStorage.getItem('sessionId') !== null,
            refCallback: (event) => (this.reCaptchaRef = event),
            onLoad: this.onLoad,
            onVerify: this.onVerify,
                          }}
         />

          {/* Third party website redirection popup */}
          <dialog className="modal fade model-error" id="thirdPartyWebsiteModel" data-keyboard="false" aria-labelledby="thirdPartyWebsitePopupLabel">
            <div className="modal-dialog" >
              <div className="modal-content">
                <div className="modal-header">
                </div>
                <div className="modal-body">
                  <div className="logo">
                    <img src="images/modal-logo.svg" className="img-fluid" alt="logo" />
                  </div>

                  <p className="text-center mb-0 mt-4">{thirdPartyWebsiteAlertPopupText}</p>
                </div>

                <div className="modal-footer mb-4">
                  <button type="button" className="btn btn-outline btn-warning" data-dismiss="modal">Cancel</button>
                  <button type="button" className="btn btn-primary" onClick={() => {this.redirectionThirdPartnerSite()}} >Ok</button>
                </div>


              </div>
            </div>
          </dialog>

          <BrokerPrivacyPolicy />

          {/* Error Message Display for QRCode */}
          {this.state.displayQRCodeErrorModal && isMobile === false && (
            <>
              <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)', zIndex: 1040, }} />
                <dialog
                  className={`modal fade model-error ${this.state.displayQRCodeErrorModal ? 'show' : ''}`}
                  id="QRCodeErrorDisplayModel"
                  data-keyboard="false"
                  aria-labelledby="QRCodeErrorDisplayPopupLabel"
                  data-backdrop="static"
                  style={{
                    display: this.state.displayQRCodeErrorModal ? 'block' : 'none',
                    zIndex: 1050,
                  }}>
                  <div className="modal-dialog">
                    <div className="modal-content" style={{ padding: '20px' }}>
                      <div className="modal-body pt-0 pb-0">
                        <div className="logo">
                          <img src="images/modal-logo.svg" alt="logo" className="img-fluid" />
                        </div>
                          <h5 className="modal-title text-center" id="QRCodeErrorDisplayModel">
                            Please Try Again
                          </h5>
                          <p className="text-center mb-0 mt-4">
                            There was an issue generating your QR Code. Please try again.
                          </p>
                      </div>
                      <div className="modal-footer mb-4 mt-3">
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={this.closeQRCodeErrorModal}
                          style={{ height: '41px' }}
                        >
                          Ok
                        </button>
                      </div>
                  </div>
                </div>
              </dialog>
            </>
          )
        }

        {/* Fallback Warning message display popup for new tab event */}
        <dialog
            className="modal fade model-error"
            id="FallbackNewTabWarningDisplayModel"
            data-keyboard="false"
            aria-labelledby="FallbackNewTabWarningDisplayModel"
            data-backdrop="static"
            style={{ zIndex: 1050 }}>
            <div className="modal-dialog">
              <div className="modal-content" style={{ padding: '20px' }}>
                <div className="modal-body pt-0 pb-0">
                  <div className="logo">
                    <img src="images/modal-logo.svg" alt="logo" className="img-fluid" />
                  </div>
                  <h5 className="modal-title text-center" id="FallbackNewTabWarningDisplayModel"
                  style={{ fontSize: '26px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.4em' }}
                  >
                    <img src="images/warning-sign.png" alt="Warning" style={{ height: '1.5em' }} />
                  {' '}Application open in another tab
                  </h5>
                    <p className="text-center mb-5 mt-4">
                    There was already an active application when this page<br /> was opened.
                    To continue please close this page<br />
                    and return to the original application
                    </p>
                  </div>
              </div>
            </div>
          </dialog>
        </div>
      </div>
      </>
      );
    }
  }
export const mapStateToProps = (state) => {
  return {
    getApplicationQuestions: state.dataStore.getApplicationQuestions,
    applicationValidation: state.dataStore.applicationValidation,
    showAppValidations: state.dataStore.showAppValidations,
    phoneNumbers: state.dataStore.phoneNumbers,
    saveDates: state.dataStore.saveDates,
    saveApplicationData: state.dataStore.saveApplicationData,
    amountRequested: state.dataStore.amountRequested,
    saveexpendituredata: state.dataStore.saveexpendituredata,
    employmentStatus: state.dataStore.employmentStatus,
    threashold: state.dataStore.threashold,
    prepopulateStatus: state.dataStore.prepopulateStatus,
    userDetailsPopulateStatus: state.dataStore.userDetailsPopulateStatus,
    emailFlag: state.dataStore.emailFlag,
    birthDateFlag: state.dataStore.birthDateFlag,
    mobileNumberFlag: state.dataStore.mobileNumberFlag,
    questionValueSave: state.dataStore.questionValueSave,
    showCurrentAddress: state.dataStore.showCurrentAddress,
    firstSectionSteps: state.dataStore.firstSectionSteps,
    loaderStatus: state.dataStore.loaderStatus,
    secondSectionSteps: state.dataStore.secondSectionSteps,
    thirdSectionSteps: state.dataStore.thirdSectionSteps,
    fourSectionSteps: state.dataStore.fourSectionSteps,
    fifthSectionSteps: state.dataStore.fifthSectionSteps,
    DocumentAgreeLabel: state.dataStore.DocumentAgreeLabel,
    AgreeLabel: state.dataStore.AgreeLabel,
    contactDocumentAgree: state.dataStore.contactDocumentAgree,
    sectionHeading: state.dataStore.sectionHeading,
    sectionSubContext: state.dataStore.sectionSubContext,
    isChangeMobile: state.dataStore.isChangeMobile,
    isChangeEmail: state.dataStore.isChangeEmail,
    saveIncomeData: state.dataStore.saveIncomeData,
    saveTermData: state.dataStore.saveTermData,
    isDisableChangeMobileOption: state.dataStore.isDisableChangeMobileOption,
    isDisableChangeEmailOption:state.dataStore.isDisableChangeEmailOption,
    profilePicture: state.dataStore.profilePicture,
    isBannerEnable: state.dataStore.isBannerEnable,
    contractSummary:state.dataStore.contractSummary,
    userName:state.dataStore.userName
  };
};


export const mapDispatchToProps = (dispatch) => {
  return {
    personalQuestions: () => {
      return dispatch(personalQuestions());
    },
    questions: () => {
      return dispatch(questions());
    },
    saveIncomeDataValue: (data) => {
      return dispatch({
        type: 'SAVEINCOMEDATA',
        value: data
      });
    },
    showappValidation: (validations) => {
      return dispatch({
        type: 'SHOW_APP_VALIDATIONS',
        value: validations
      });
    },
    firstSectionValidationUpdate: (validations) => {
      return dispatch({
        type: "FIRST_SECTION_STEPS",
        value: validations
      });
    },
    secondSectionValidationUpdate: (validations) => {
      return dispatch({
        type: "SECOND_SECTION_STEPS",
        value: validations
      });
    },
    thirdSectionValidationUpdate: (validations) => {
      return dispatch({
        type: "THIRD_SECTION_STEPS",
        value: validations
      });
    },
    fourSectionValidationUpdate: (validations) => {
      return dispatch({
        type: "FOUR_SECTION_STEPS",
        value: validations
      });
    },
    hideappValidation: (validations) => {
      return dispatch({
        type: 'HIDE_APP_VALIDATIONS',
        value: validations
      });
    },
    updateFrequencyExists: (validations) => {
      return dispatch({
        type: 'SET_FREQUENCY_EXISTS',
        value: validations
      });
    },
    resetFrequencyExists: (validations) => {
      return dispatch({
        type: 'RESET_FREQUENCY_EXISTS',
        value: validations
      });
    },
    removeContactHummAgreeLabel: (validations) => {
      return dispatch({
        type: 'REMOVE_CONTACT_AGREE_LABEL',
        value: validations
      });
    },
    getPhoneNumber: (validations) => {
      return dispatch({
        type: 'PHONENO',
        value: validations

      });
    },
    appvalidations: (validations) => {
      return dispatch({
        type: 'APP_VALIDATIONS',
        value: validations
      });
    },
    updateMobileVerified: (validations) => {
      return dispatch({
        type: 'SET_MOBILE_VERIFIED',
        value: validations
      });
    },
    resetMobileVerified: (validations) => {
      return dispatch({
        type: 'RESET_MOBILE_VERIFIED',
        value: validations
      });
    },
    updateEmailVerified: (validations) => {
      return dispatch({
        type: 'SET_EMAIL_VERIFIED',
        value: validations
      });
    },
    resetEmailVerified: (validations) => {
      return dispatch({
        type: 'RESET_EMAIL_VERIFIED',
        value: validations
      });
    },
    updateMobileChange: (validations) => {
      return dispatch({
        type: 'SET_MOBILE_CHANGE',
        value: validations
      });
    },
    resetMobileChange: (validations) => {
      return dispatch({
        type: 'RESET_MOBILE_CHANGE',
        value: validations
      });
    },
    updateEmailChange: (validations) => {
      return dispatch({
        type: 'SET_EMAIL_CHANGE',
        value: validations
      });
    },
    resetEmailChange: (validations) => {
      return dispatch({
        type: 'RESET_EMAIL_CHANGE',
        value: validations
      });
    },
    saveApplicationDatas: (data) => {
      return dispatch({
        type: 'SAVEDATA',
        value: data
      });
    },
    appValidationsRemove: (validations) => {
      return dispatch({
        type: 'APP_VALIDATIONS_Remove',
        value: validations
      });
    },
    firstSectionStepsReset: (validations) => {
      return dispatch({
        type: 'FIRST_SECTION_STEPS_REMOVE',
        value: validations
      });
    },
    secondSectionStepsReset: (validations) => {
      return dispatch({
        type: 'SECOND_SECTION_STEPS_REMOVE',
        value: validations
      });
    },
    thirdSectionStepsReset: (validations) => {
      return dispatch({
        type: 'THIRD_SECTION_STEPS_REMOVE',
        value: validations
      });
    },
    fourSectionStepsReset: (validations) => {
      return dispatch({
        type: 'FOUR_SECTION_STEPS_REMOVE',
        value: validations
      });
    },
    updateSectionHeading: (validations) => {
      return dispatch({
        type: 'SECTION_HEADING',
        value: validations
      });
    },
    updateSectionContext: (validations) => {
      return dispatch({
        type: 'SECTION_CONTEXT',
        value: validations
      });
    },
    resetSectionHeading: (validations) => {
      return dispatch({
        type: 'SECTION_HEADING_REMOVE',
        value: validations
      });
    },
    resetSectionContext: (validations) => {
      return dispatch({
        type: 'SECTION_CONTEXT_REMOVE',
        value: validations
      });
    },
    secondSectionStepsUpdate: (validations) => {
      return dispatch({
        type: 'SECOND_SECTION_STEPS',
        value: validations
      });
    },
    getAmountRequested: (validations) => {
      return dispatch({
        type: 'AMOUNTREQUESTED',
        value: validations
      });
    },
    prePopulate: (validations) => {
      return dispatch({
        type: 'PREPOPOLATE',
        value: validations
      });
    },

    removeSavedata: (validations) => {
      return dispatch({
        type: 'REMOVEDATA',
        value: validations
      });
    },
    removeDocumentAgreeLabel: (validations) => {
      return dispatch({
        type: 'REMOVE_DOCUMENT_AGREE_LABEL',
        value: validations
      });
    },
    removeAgreeLabel: (validations) => {
      return dispatch({
        type: 'REMOVE_AGREE_LABEL',
        value: validations
      });
    },
    prepopulateStatusCall: (validations) => {
      return dispatch({
        type: 'PREPOPULATEE',
        value: validations
      });
    },
    userDetailsPopulateStatusCall: (validations) => {
      return dispatch({
        type: 'USER_DETAILS_PREPOPULATE',
        value: validations
      })
    },
    birthDateFlagStatusCall: (validations) => {
      return dispatch({
        type: 'BIRTH_DATE_FLAG',
        value: validations
      })
    },
    firstNameFlagStatusCall: (validations) => {
      return dispatch({
        type: 'FIRST_NAME_FLAG',
        value: validations
      })
    },
    lastNameFlagStatusCall: (validations) => {
      return dispatch({
        type: 'LAST_NAME_FLAG',
        value: validations
      })
    },
    emailFlagStatusCall: (validations) => {
      return dispatch({
        type: 'EMAIL_FLAG',
        value: validations
      })
    },
    mobileNumberFlagStatusCall: (validations) => {
      return dispatch({
        type: 'MOBILE_NUMER_FLAG',
        value: validations
      })
    },
    questionSave: (data) => {
      return dispatch({
        type: 'QUESTIONSAVE',
        value: data
      });
    },
    saveDate: (data) => {
      return dispatch({
        type: 'SAVEDATE',
        value: data
      });
    },
    removeQuestionSave: (data) => {
      return dispatch({
        type: 'REMOVEQUESTIONSAVE',
        value: data
      });
    },
    showAddress:(data) => {
      return dispatch({
        type: 'SHOWADDRESS',
        value: data
      });
    },
    getEmploynmentstatus: (validations) => {
      return dispatch({
        type: 'EMPLOYNMENTSTATUS',
        value: validations
      });
    },    
    disableChangeMobileOption: (validations) => {
      return dispatch({
        type: 'UPDATE_MOBILE_CHANGE_OPTION',
        value: validations
      });
    },
    disableChangeEmailOption: (validations) => {
      return dispatch({
        type: 'UPDATE_EMAIL_CHANGE_OPTION',
        value: validations
      });
    },
    fetchBannerConfiguration: () => {
      return dispatch(fetchBannerConfiguration());
    },
    setUserName: (value) => {
      return dispatch({
        type: 'SET_USERNAME',
        value: value
      })
    },
    setProfilePic: (userPic) => {
      return dispatch({
        type: 'SET_PROFILE_PIC',
        value: userPic
      });
    }  
  }
}

Application.propTypes = {
  firstSectionSteps: PropTypes.array,
  secondSectionSteps: PropTypes.array,
  firstSectionStepsReset: PropTypes.func,
  secondSectionStepsReset: PropTypes.func,
  thirdSectionStepsReset: PropTypes.func,
  fourSectionStepsReset: PropTypes.func,
  resetSectionHeading: PropTypes.func,
  resetSectionContext: PropTypes.func,
  resetMobileChange: PropTypes.func,
  resetEmailChange: PropTypes.func,
  resetFrequencyExists: PropTypes.func,
  removeAgreeLabel: PropTypes.func,
  removeDocumentAgreeLabel: PropTypes.func,
  removeContactHummAgreeLabel: PropTypes.func,
  resetMobileVerified: PropTypes.func,
  resetEmailVerified: PropTypes.func,
  removeQuestionSave: PropTypes.func,
  appValidationsRemove: PropTypes.func,
  showappValidation: PropTypes.func,
  getAmountRequested: PropTypes.func,
  removeSavedata: PropTypes.func,
  showAddress: PropTypes.func,
  firstNameFlagStatusCall: PropTypes.func,
  lastNameFlagStatusCall: PropTypes.func,
  emailFlagStatusCall: PropTypes.func,
  mobileNumberFlagStatusCall: PropTypes.func,
  birthDateFlagStatusCall: PropTypes.func,
  phoneNumbers: PropTypes.string,
  applicationValidation: PropTypes.array,
  saveIncomeDataValue: PropTypes.func,
  updateMobileChange: PropTypes.func,
  updateEmailChange: PropTypes.func,
  history: PropTypes.object,
  saveApplicationDatas: PropTypes.func,
  saveApplicationData: PropTypes.array,
  questions: PropTypes.func,
  updateSectionHeading: PropTypes.func,
  updateSectionContext: PropTypes.func,
  updateFrequencyExists: PropTypes.func,
  prepopulateStatusCall: PropTypes.func,
  appvalidations: PropTypes.func,
  questionValueSave: PropTypes.array,
  amountRequested: PropTypes.string,
  threashold: PropTypes.string,
  emailFlag: PropTypes.bool,
  birthDateFlag: PropTypes.bool,
  mobileNumberFlag: PropTypes.bool,
  updateEmailVerified: PropTypes.func,
  updateMobileVerified: PropTypes.func,
  firstSectionValidationUpdate: PropTypes.func,
  userDetailsPopulateStatusCall: PropTypes.func,
  thirdSectionSteps: PropTypes.array,
  fourSectionSteps: PropTypes.array,
  isChangeEmail: PropTypes.bool,
  isChangeMobile: PropTypes.bool,
  sectionHeading: PropTypes.array,
  sectionSubContext: PropTypes.array,
  secondSectionValidationUpdate: PropTypes.func,
  prepopulateStatus: PropTypes.bool,
  thirdSectionValidationUpdate: PropTypes.func,
  fourSectionValidationUpdate: PropTypes.func,
  getEmploynmentstatus:PropTypes.bool,
  disableChangeMobileOption:PropTypes.func,
  disableChangeEmailOption:PropTypes.func,
  isDisableChangeMobileOption: PropTypes.bool,
  isDisableChangeEmailOption: PropTypes.bool,
  stage: PropTypes.string,
  location: PropTypes.object,
  navigate: PropTypes.object,
  saveIncomeData: PropTypes.string,
  saveexpendituredata: PropTypes.string,
  DocumentAgreeLabel: PropTypes.string,
  AgreeLabel: PropTypes.string,
  contactDocumentAgree: PropTypes.string,
  saveDate : PropTypes.func,
  hideappValidation: PropTypes.func,
  saveDates: PropTypes.any
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Application));
